import { Link } from '@material-ui/core';
import {
  AccountParticipationLevel,
  AmountOfEmployees,
  ArticleCategory,
  ArticleType,
  ArticleTypeExternal,
  AssetType,
  BorrowerFileType,
  BusinessType,
  CashInCashOutType,
  ChannelType,
  CompanyActivity,
  CustomLanguage,
  CustomRegistry,
  DeclaredBusinessType,
  deleteAgentInLenderContextById,
  deleteCheckoutSessionByCheckoutSessionId,
  DownPaymentCollection,
  EmploymentStatus,
  FeePaymentType,
  FeeType,
  Gender,
  HolderType,
  HppStatus,
  IberiaCompanyActivity,
  IberiaEmploymentStatus,
  IncomeType,
  LenderApprovalStatus,
  LenderName,
  LoanApplicationStatus,
  LoanDesistReason,
  LoanFileType,
  LoanStatusExternal,
  MerchantFileType,
  NetIncomeType,
  OnboardingDetailsRole,
  OperativeType,
  OtpStatus,
  patchAddCashInCashOutMethodByMerchantId,
  patchAddPricingSpecInLenderContextInPricingSpec,
  patchAddRequiredFileTypeToDocumentationRequired,
  patchBlockUser,
  patchChangeAcquisitionChannelByMerchantId,
  patchChangeAgentIdChannel,
  patchChangeApprovalStatusByMerchantId,
  patchChangeDescription,
  patchChangeLoanStatus,
  patchChangeMerchantStatusByMerchantId,
  patchChangeRegistrationFieldsByMerchantId,
  patchChangeType,
  patchChangeUserId,
  patchCreateSignatureReminderRequestForMerchantContract,
  patchCreateSignatureRequestForMerchantContract,
  patchPaymentMethodModification,
  patchProcessLoanApplicationInLenderManually,
  patchRemovePricingSpecInLenderContextFromPricingSpecByLenderId,
  patchRemoveRequiredFileTypeFromDocumentationRequired,
  patchSendDocumentationIncidenceNotification,
  patchSetAgentConfiguration,
  patchSetAgentIdInLenderContextById,
  patchSetAreDocumentsConfirmed,
  patchSetBorrowerOnboardingDetailsByRole,
  patchSetBrandInformationAndUploadLogoToCDN,
  patchSetBusinessDetailsToBusinessOnboardingDetails,
  patchSetCart,
  patchSetDocumentRequiredIsNotSent,
  patchSetDocumentStatus,
  patchSetHoldersToBusinessOnboardingDetails,
  patchSetLegalAddress,
  patchSetLenderRequestId,
  patchSetNieData,
  patchSetPricingIdsToAgent,
  patchSetProcessingConfigToMerchantAgents,
  patchSetRangesForAgent,
  patchSignLoanLenderBorrowerContract,
  patchSyncBorrowerDocumentationByLoanId,
  patchUnblockUser,
  patchUnSignLoanLenderBorrowerContract,
  patchUpdateBorrowerContractLoan,
  patchUpdateBorrowerDetails,
  patchUpdateCashInCashOutMethod,
  patchUpdateCashInCashOutMethodByMerchantId,
  patchUpdateDeclaredIncome,
  patchUpdateDownPayment,
  patchUpdateInvitationByType,
  patchUpdateLoanApplicationInLender,
  patchUpdateLoanConditionsByPricingIdPrincipalAndPeriod,
  patchUpdatePaymentDateByPaymentLineId,
  patchUpdatePaymentMethodOptions,
  patchUpdatePaymentPlanLineSentDate,
  patchUpdatePaymentPlanLineStatus,
  patchUploadDocumentationToLender,
  patchUploadFileToDocumentationRequired,
  PaymentMethodType,
  PaymentMode,
  PaymentPlanLineStatus,
  PayoutStatus,
  PetitionType,
  postAgentInLenderContext,
  postCloneOrUpdateAgent,
  postCreateAgent,
  postCreateChannel,
  postCreateCheckoutSession,
  postCreateMerchant,
  postCreateMerchantData,
  postCreatePaymentIntent,
  postCreateUser,
  postCreditCardIberiaCards,
  postPaymentMethodModificationPreview,
  postSendEmailForNewVideoId,
  postSyncPricingsToCdnByAgentId,
  Priority,
  Product,
  ProductExternal,
  ProfessionalPosition,
  Program,
  PurchaseCountry,
  Relation,
  SecurityCheckName,
  SentCodeStatus,
  SimilarityLevel,
  StopCondition,
  TransactionType,
  TravelCategory,
  Turnover,
  UserType,
  WorkflowPlace,
} from '@nemuru-eng/js-api-client';
import {
  InsuranceProvider,
  InsuranceType,
  PaymentAttemptFailReason,
  PaymentAttemptStatus,
  PaymentProvider,
  RangeType,
} from '@nemuru-eng/js-api-client/slim';
import esLocale from 'date-fns/locale/es';

import { CredentialsType } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/types/CredentialsType';
import { FilterType } from '@/components/modules/Application/components/PaymentMethod/_shared/types/Filter';
import { ApplicationIberiaCardsStep } from '@/components/modules/Application/IberiaCards/_shared/types/ApplicationIberiaCardsStep';
import { Action } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/types/PendingAction';
import { KycIntegrationMethodOwner } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/types';
import { CreditCardName } from '@/components/modules/CreditCard/Detail/Overview/hooks/useIberiaCardParams';
import { ValidationStep } from '@/components/modules/DocumentsValidation/types/ValidationStep';
import { ScoreCardMetricKey } from '@/components/modules/Metrics/shared/types/ScoreCardMetricKey';
import { TimeIntervalType } from '@/components/modules/Metrics/shared/types/TimeIntervalType';
import { UserCredentialsType } from '@/components/modules/Users/types/UserCredentials';
import { AuthorizationType } from '@/components/modules/Webhooks/schemas/AuthorizationType';
import { DistributionMethod } from '@/components/shared/components/DistributionDialog/types/DistributionMethod';
import { FilterByType } from '@/components/shared/components/SuperSearchBar/types/FilterByType';
import { UserRowActionType } from '@/components/shared/components/UserList/types/UserRowActionType';
import { PricingFilterType } from '@/components/widgets/LoanDetailActions/components/LoanDetailActionsDialog/components/ChangeLoanConditionsDialog/types/PricingFilterType';

import { OverduePlanLineStatus } from '../../components/modules/PaymentPlan/types/PaymentPlanLineStatusExtended';
import { FilterByDate } from '../../components/shared/components/SuperSearchBar/types/FilterByDate';
import { APP_ROLES } from '../config';
import { statusSections } from '../loanConfig';
import { PendingDataType } from '../types';
import { DictionaryType } from './types/dictionaryType';
/* eslint-disable quotes */

const ca: DictionaryType = {
  //GENERAL
  YES: 'Sí',
  NO: 'No',
  EDIT_INFORMATION: 'Editar informació',
  DATE_FORMAT_DAY_MONTH_YEAR: 'Dia, mes, any',
  DATE_FORMAT_MONTH_YEAR: 'Mes, any',
  DATE_FORMAT_YEAR: 'Any',
  DATE_LOCALE: esLocale,
  SEND: 'Enviar',
  CANCEL: 'Cancel·lar',
  SEE_MORE: 'Veure més',
  BY: 'per',
  OF: 'de',
  COPY: 'Copiar',
  EDIT: 'Editar',
  NO_OPTIONS_TO_DISPLAY: 'Sense opcions disponibles',
  ITEM: 'Element',
  ITEMS: 'Elements',
  INFORMATION: 'Informació',
  WELCOME_TO_THE_OFFER_PROCESS: 'Benvingut $v1',
  WELCOME_TO_THE_OFFER_PROCESS_SUBTITLE:
    'Associa una referència de comanda del teu sistema per a aquesta nova sol·licitud.',

  //PAGES
  HOME: 'Inici',
  CONSUMER_LOAN_LIST: 'Préstecs consum',
  CONSUMER_LOAN_DETAIL: 'Detall del préstec',
  DOCUMENTS_VALIDATION: 'Validació de documentació',
  AUTO_LOAN_LIST: 'Préstecs auto',
  AUTO_LIST: 'Préstecs auto',
  AUTO_LOAN_DETAIL: 'Detall del préstec',
  CREDIT_LINE_LIST: 'Línies de crèdit',
  CREDIT_LINE_DETAIL: 'Detall de la línia de crèdit',
  ORDER_LIST: 'BNPL',
  PAY_BY_LINK_LIST: 'Pagar amb enllaç',
  ORDER_DETAIL: 'Detall de la comanda',
  MERCHANTS_LIST: 'Llistat de merchants',
  MERCHANTS_LIST_TITLE: 'Merchants',
  CONSUMER_LOAN_SUBSECTION_TITLE: 'Llistat de préstecs consum',
  AUTO_SUBSECTION_TITLE: 'Llistat de préstecs auto',
  CREDIT_LINE_SUBSECTION_TITLE: 'Llistat de línies de crèdit',
  ORDER_SUBSECTION_TITLE: 'Llistat de BNPL',
  PAY_BY_LINK_SUBSECTION_TITLE: 'Llistat de Pagar amb enllaç',
  MERCHANT_DETAIL: 'Detall del merchant',
  MERCHANT_DETAILS: 'Detalls de merchant',
  BORROWER_LIST: 'Borrowers',
  BORROWER_DETAIL: 'Detall del borrower',
  APPLICATIONS: 'Sol·licituds',
  OPEN_APPLICATION: 'Obrir sol·licitud',
  CONTINUE_APPLICATION: 'Continuar sol·licitud',
  CONTINUE_APPLICATION_TEXT:
    'Has iniciat aquest mètode de pagament però encara no has completat la informació necessària per enviar la sol·licitud a les entitats.',
  CUSTOMER_CONTINUE_APPLICATION_TEXT:
    'El teu client ha iniciat aquest mètode de pagament però encara no ha completat la informació necessària per enviar la sol·licitud a les entitats.',
  PAY_FIRST_INSTALMENT_TITLE: 'Pendent pagament de la primera quota...',
  PAY_FIRST_INSTALMENT_DESCRIPTION:
    "Has d'compartir el link de pagament amb el teu client per que pugui accedir al procés i completar el pagament de la primera quota amb $v1. Una vegada realitzat el pagament, el procés es completarà automàticament.",
  PAY_FIRST_INSTALMENT_DESCRIPTION_NOT_SHAREABLE:
    'El teu client ha de pagar la primera quota amb $v1. Una vegada realitzat el pagament, el procés es completarà automàticament.',
  BNPL_LENDER_SELECTED_APPROVED_TITLE: 'Entitat seleccionada',
  BNPL_LENDER_SELECTED_APPROVED_DESCRIPTION:
    'El client ha seleccionat la entitat financera $v1. Debes compartir el link de pagament amb el teu client per que pugui accedir al procés i completar el pagament de la primera quota amb $v1. Una vegada realitzat el pagament, el procés es completarà automàticament.',
  BNPL_LENDER_SELECTED_REJECTED_TITLE: 'Entitat no seleccionada',
  BNPL_LENDER_SELECTED_REJECTED_DESCRIPTION:
    'El client no ha seleccionat la entitat financera. Pots continuar amb el procés de pagament seleccionant un altre mètode de pagament.',
  CAPTURE_ORDER_TITLE: 'Capturar la comanda',
  CAPTURE_ORDER_DESCRIPTION:
    "Per poder rebre el pagament d'aquesta comanda, has d'capturar-la. La captura de la comanda s'ha de realitzar quan facis el lliurament dels productes o prestacions dels productes.",

  START: 'Iniciar',

  //LOGIN
  EMAIL: 'Correu electrònic',
  PASSWORD: 'Contrasenya',
  PASSWORD_OPTIONAL: 'Contrasenya (opcional)',
  ENTER: 'Entrar',
  LOGOUT: 'Tancar sessió',
  FORGOT_PASSWORD: 'He oblidat la contrasenya',
  REQUIRED_FIELD_EMAIL: 'Es requereix un correu electrònic',
  REQUIRED_FIELD_PASSWORD: 'No has introduït una contrasenya',
  LOGIN: 'Iniciar sessió',
  DID_YOU_FORGET_YOUR_PASSWORD: 'Has oblidat la contrasenya?',
  PLEASE_REVIEW_YOUR_LOGIN_CREDENTIALS: "Si us plau, revisa les teves credencials d'accés",

  //ACCOUNT DETAIL
  ACTIVE_PROFILE: 'Perfil actiu',
  ACTIVE_PROFILE_CAPTION: 'Tens $v1 perfils. En canviar de perfil, la pàgina es recarrega.',
  ACTIVE_PROFILE_TAG: 'Actiu',
  MORE_PROFILES: '$v1 perfils més',
  MORE_PROFILES_ONE: '1 perfil més',
  GO_TO_ACCOUNT: 'Anar al Compte',
  PROFILE_SWITCH_ERROR: "No s'ha pogut canviar de perfil",
  PROFILE_SWITCHING_TO: 'Canviant a $v1…',
  ORGANIZATION: 'Organització',
  ORGANIZATION_STRUCTURE: 'Estructura jeràrquica de la teva organització',

  // FORGOT PASSWORD
  CREDENTIALS_RECOVERY: 'Recuperació de credencials',
  CREDENTIALS_RECOVERY_EXPLANATION:
    "Si us plau, introdueix la teva adreça de correu electrònic. Aviat rebràs un correu per crear una nova contrasenya i recuperar l'accés.",
  CREDENTIALS_RECOVERY_EMAIL_SENT: "S'ha enviat un correu electrònic a l'adreça introduïda",
  CREDENTIALS_RECOVERY_EMAIL_SENT_EXPLANATION:
    "Si us plau, revisa la teva safata d'entrada. Si l'adreça estava associada a un compte vàlid, rebràs un correu per crear una nova contrasenya i recuperar l'accés.",
  RECOVERY_PASSWORD_EMAIL_FAILED: "Ha fallat l'enviament del correu per recuperar la contrasenya.",
  PLEASE_CHECK_INPUT_DATA_OR_TRY_LATER:
    'Si us plau, revisa les dades introduïdes. Si el problema persisteix, prova-ho més tard o contacta amb el nostre suport al client',
  CREATE_YOUR_PASSWORD_EXPLANATION: "Crea una nova contrasenya per recuperar l'accés a la plataforma",
  BACK_TO_HOME: 'Tornar a Inici',
  INVALID_EMAIL: 'Adreça de correu electrònic invàlida',
  INVALID_URL: 'URL no vàlida',
  INVALID_JSON: 'JSON no vàlid',
  FORMAT_JSON: 'Formatejar JSON',
  YOU_CAN_SAFELY_CLOSE_THE_DIALOG: 'Ja pots tancar aquesta finestra',
  RETRY: 'Tornar a intentar',
  CLOSE: 'Tancar',
  OPEN_IN_NEW_TAB: 'Obrir en una nova pestanya',
  UPDATING: 'Actualitzant...',
  BACK_TO_LOGIN: 'Tornar a Iniciar sessió',
  ACTION_REQUEST_AUTH_REJECTED: 'Error en iniciar sessió',

  YOU_CAN_CLOSE_THIS_WINDOW_AND_LOGIN_WITH_YOUR_NEW_PASSWORD:
    'Ja pots tancar aquesta finestra amb seguretat i entrar al teu compte amb la nova contrasenya',

  //SET PASSWORD
  CREATE_YOUR_PASSWORD: 'Crea la teva contrasenya',
  MIN_PASSWORD_LENGTH: 'Ha de contenir com a mínim 6 caràcters',
  CURRENT_PASSWORD: 'Contrasenya actual',
  NEW_PASSWORD: 'Nova contrasenya',
  REPEAT_NEW_PASSWORD: 'Repeteix nova contrasenya',
  CHANGE_PASSWORD: 'Canviar contrasenya',
  CHANGE: 'Canviar',
  NEW_PASSWORD_CANNOT_BE_SAME_AS_CURRENT: "La nova contrasenya no pot ser igual a l'actual",
  NEW_PASSWORD_AND_CONFIRMATION_DONT_MATCH: 'Les contrasenyes no coincideixen',

  // FORM INPUT HELP
  REQUIRED_FIELD: 'Camp requerit',
  PLEASE_COMPLETE_THIS_FIELD_CORRECTLY: 'Si us plau, completa el camp correctament',
  INVALID_FORMAT: 'Format invàlid',
  PLEASE_CHECK_INPUT_DATA: 'Si us plau, revisa les dades introduïdes.',
  CANNOT_BE_LESS_THAN_LOAN_AMOUNT: "No pot ser inferior a l'import del préstec",
  REQUIRED_MIN_LENGTH: "No s'ha arribat a la longitud mínima de caràcters",
  REQUIRED_MAX_LENGTH: "S'ha arribat a la longitud màxima de caràcters",
  EQUAL_OR_LARGER_THAN: 'Igual o superior a $v1',

  //NOTIFICATIONS
  NOTIFICATIONS: 'Notificacions',
  ALL_NOTIFICATIONS_READ_AND_NO_NEW_NOTIFICATIONS:
    "Totes les notificacions s'han llegit i no hi ha noves notificacions",
  ALL_NOTIFICATIONS_READ: "Totes les notificacions s'han llegit",
  NO_NEW_NOTIFICATIONS: 'No hi ha noves notificacions',
  BORROWER_NOTIFICATIONS: 'Notificacions enviades al client',
  AGENT_NOTIFICATIONS: 'Notificacions enviades al comerç',
  NO_NOTIFICATIONS: "Encara no s'han enviat notificacions",
  EXTERNAL_ID_TYPE: 'Tipus',
  NOTIFICATION_TYPE: 'Tipus de notificació',
  DELIVERED_AT: 'Data de lliurament',
  MESSAGE_SUBJECT: 'Assumpte',
  DELIVERY_STATUS: 'Lliurat',
  LOADING_NOTIFICATIONS: 'Cargant notificacions',

  //TASKS:
  MANAGEMENT: 'Gestió',
  SUPPORT: 'Suport',
  TASKS: 'Tasques',
  NO_NEW_TASKS: 'No hi ha noves tasques',
  ALL_TASKS_COMPLETED: 'Totes les tasques estan completes',

  // SUPER SEARCH BAR:
  SEARCH_BAR: 'Cercador',
  SEARCH_APPLICATIONS: 'Cerca sol·licitud...',
  SEARCH_MERCHANTS: 'Cerca merchant...',
  SEARCH_AGENTS: 'Cerca agent...',
  LOADING_RESULTS: 'Carregant resultats...',
  DYNAMIC_CUSTOMER_NAME_WITH_APPLICATION_AMOUNT: '$v1 per $v2',
  [FilterByDate.TODAY]: 'Avui',
  [FilterByDate.LAST_7_DAYS]: 'Últims 7 dies',
  [FilterByDate.LAST_30_DAYS]: 'Últims 30 dies',
  [FilterByDate.ALL_DATES]: 'Qualsevol data',
  [FilterByType.APPLICATIONS]: 'Productes',
  [FilterByType.CHECKOUT_SESSIONS]: 'Sol·licituds',
  [FilterByType.MERCHANTS]: 'Merchants',
  UPDATED_AT_DESCEND: 'Data actualització: Recents primer',
  UPDATED_AT_ASCEND: 'Data actualització: Antics primer',
  CREATED_AT_ASCEND: 'Data creació: Antics primer',
  CREATED_AT_DESCEND: 'Data creació: Recents primer',
  SORT_BY: 'Ordenar',
  ITEMS_PER_PAGE: 'Resultats per pàgina',
  COPY_ID: 'Còpia ID',
  SELECT: 'Seleccionar',
  OPEN: 'Obert',
  NAVIGATE: 'Navegar',

  //HOME
  WELCOME_TO_PANEL: 'Hola, $v1!',
  CHOOSE_SECTION:
    'Aquests són els apartats als quals tens accés amb el teu rol $v1. Escull el que vulguis per començar a gestionar.',
  //GLOBAL METRICS
  [TimeIntervalType.TODAY]: 'Avui',
  [TimeIntervalType.THIS_WEEK]: 'Setmana passada',
  [TimeIntervalType.THIS_MONTH]: 'Més passat',
  [TimeIntervalType.MONTH_TO_DATE]: 'Aquest mes',
  [TimeIntervalType.CUSTOM]: 'Personalitzat…',
  METRICS_PERIOD_MONTH_TO_DATE: "$v1 $v2 · de l'1 al $v3",
  METRICS_PERIOD_CUSTOM: "De l'$v1 al $v2",
  METRICS_PERIOD_CUSTOM_TITLE: 'Període personalitzat',
  METRICS_PERIOD_CUSTOM_INVALID: "Tria una data d'inici anterior o igual a la de fi, fins avui",
  METRICS_PERIOD_FROM: 'Des de',
  METRICS_PERIOD_TO: 'Fins a',
  METRICS_PERIOD_APPLY: 'Aplica',
  METRICS_COMPARISON_MONTH_TO_DATE: 'Comparació amb el mateix tram de dies (1–$v1) del mes anterior',
  NO_PREVIOUS_RESULTS: 'Sense resultats anteriors',
  OF_PREV_PERIOD: 'període anterior ($v1)',
  [`${ScoreCardMetricKey.totalLoansNumber}_TID`]: 'Sol·licituds',
  [`${ScoreCardMetricKey.totalPrincipalAmount}_TID`]: 'Import',
  [ScoreCardMetricKey.totalLoansNumber]: 'Sol·licituds',
  [ScoreCardMetricKey.totalPrincipalAmount]: 'Import',
  METRICS_COMPARISON_PREVIOUS_DAY: 'Comparació amb el dia anterior',
  METRICS_COMPARISON_PREVIOUS_DAYS: 'Comparació amb els $v1 dies anteriors',
  LENDER_RANKING_TITLE: "Rànquing d'entitats",
  LENDER_RANKING_DESCRIPTION:
    'Vendes confirmades, aprovació i temps fins a la formalització de cada entitat durant $v1.',
  LENDER_RANKING_LENDER: 'Entitat',
  LENDER_RANKING_AMOUNT: 'Import',
  LENDER_RANKING_LOANS: 'Operacions',
  LENDER_RANKING_SHARE: 'Quota',
  LENDER_RANKING_VARIATION: 'vs. període anterior',
  LENDER_RANKING_APPROVAL: 'Aprovació',
  LENDER_RANKING_APPROVAL_TOOLTIP:
    "Sol·licituds aprovades sobre les enviades a l'entitat en el període (aprovades, denegades, en estudi i amb error)",
  LENDER_RANKING_AVERAGE_TICKET: 'Tiquet mitjà',
  LENDER_RANKING_FORMALIZATION: 'Formalització',
  LENDER_RANKING_FORMALIZATION_TOOLTIP:
    "Temps mitjà des de l'enviament de la sol·licitud a l'entitat fins als documents aprovats, només operacions formalitzades amb aquesta entitat",
  LENDER_RANKING_TOP: 'Top $v1',
  LENDER_RANKING_REST: "Resta d'entitats",
  LENDER_RANKING_TOTAL: 'Total',
  LENDER_RANKING_ERROR: "No s'ha pogut carregar el rànquing d'entitats",
  DURATION_MINUTES: '$v1 min',
  DURATION_HOURS: '$v1 h',
  DURATION_DAYS: '$v1 dies',

  [`LOAN_STATUS_EXTERNAL_${LoanStatusExternal.INITIAL}`]: 'Iniciat',
  [`LOAN_STATUS_EXTERNAL_${LoanStatusExternal.ON_HOLD}`]: 'Sol·licitat',
  [`LOAN_STATUS_EXTERNAL_${LoanStatusExternal.REQUESTED}`]: 'Preaprovat',
  [`LOAN_STATUS_EXTERNAL_${LoanStatusExternal.APPROVED}`]: 'Preaprovat',
  [`LOAN_STATUS_EXTERNAL_${LoanStatusExternal.CONFIRMED}`]: 'Confirmat',
  [`LOAN_STATUS_EXTERNAL_${LoanStatusExternal.PAID}`]: 'Pagat',

  [`PRODUCT_EXTERNAL_${ProductExternal.CONSUMER_LOAN}`]: 'Préstec consum',
  [`PRODUCT_EXTERNAL_${ProductExternal.AUTO}`]: "Préstec d'automòbil",
  [`PRODUCT_EXTERNAL_${ProductExternal.CREDIT_LINE}`]: 'Línia de crèdit',
  [`PRODUCT_EXTERNAL_${ProductExternal.BNPL}`]: 'BNPL',
  [`PRODUCT_EXTERNAL_${ProductExternal.PAY_BY_LINK}`]: 'Pay by link',

  TOP_MERCHANTS_TITLE: 'Els millors comerciants',
  TOP_MERCHANTS_DESCRIPTION: 'Amb més sol·licituds confirmades durant $v1.',

  PRODUCT_EXTERNAL_TITLE: 'Tipus de sol·licitud',
  PRODUCT_EXTERNAL_DESCRIPTION: 'Confirmades durant $v1.',

  CHANNEL_METRICS: 'Mètriques del canal',
  MERCHANT_METRICS: 'Mètriques del comerciant',
  AGENT_METRICS: 'Mètriques del agent',
  NO_METRICS_INFORMATION: 'Sense dades per mostrar',

  //CONSUMER LOAN LIST
  LOAN: 'Sol·licitud',
  PRODUCTS_LIST: 'Llistat de productes',
  TYPE: 'Tipus',
  CLIENT: 'Titular',
  CREATION_DATE: 'Data creació',
  CREATED: 'Creat:',
  UPDATE_DATE: 'Data actualització',
  ID: 'ID',
  STATUS: 'Estat',
  CHECKOUT_SESSION_STATUS: 'Estat sol·licitud',
  SELECTED_PAYMENT_INTENT: 'Mètode de pagament',
  ALL: 'Tots',
  [CustomRegistry.DEFAULT]: 'Per defecte',
  [CustomRegistry.TECHNOLOGICAL_PLATFORM]: 'Plataforma tecnològica',
  DEFAULT: 'Per defecte',
  SELECT_ALL: 'Seleccionar tots',
  DESELECT_ALL: 'Desseleccionar tots',
  FROM_DATE: 'Des de la data',
  TO_DATE: 'Fins a la data',
  LENDER: 'Entitat financera',
  ORDER_DETAILS: 'Detall de la comanda',
  LOAN_DETAILS: 'Detalls de la sol·licitud',
  BORROWER_DETAILS: 'Detalls prescriptor',
  STATUS_DETAILS: 'Detalls estat',
  LENDER_ASSIGNMENT_DETAILS: 'Detalls entitat financera',
  ID_DETAILS: 'Detalls ID',
  MAIN_RESIDENCE_ADDRESS: 'Adreça',
  EDIT_DOCUMENT_ID: 'Editar dades personals',
  EDIT_MAIN_RESIDENCE_INFORMATION: 'Editar dades del domicili principal',
  EDIT_FAMILIAR_SITUATION: 'Editar dades familiars',
  EDIT_PROFESSIONAL_DETAILS: 'Editar dades professionals',
  DOCUMENT_EXPEDITOR: "País d'expedició",

  REFERENCES_DETAILS: 'Detalls referències',

  [statusSections.PENDING]: 'Iniciat',
  [statusSections.ANALYSING]: 'Sol·licitat',
  [statusSections.APPROVED]: 'Preaprovat',
  [statusSections.FORMALIZED]: 'Confirmat',
  [statusSections.DENIED]: 'Denegat',
  [statusSections.CANCELLED]: 'Cancel·lat',
  [statusSections.DESISTED]: 'Desistit',
  [statusSections.EXPIRED]: 'Caducat',

  PROCESS_TERMINATED: 'Proces finalitzat',

  ['status_active,status_active_trial']: 'Pagament realitzat',
  ['status_cancelled,status_cancelled_test']: 'Cancel·lat',

  STATUS_NEXT_STEP_INITIAL_CERTIFICATION: 'Primera certificació',
  STATUS_DESC_INITIAL_CERTIFICATION: 'Primera certificació pendent',
  STATUS_DESC_APPLICATION_STARTED: 'Sol·licitud iniciada',

  STATUS_NEXT_STEP_PARTIALLY_CERTIFICATED: 'Certificacions i abonament',
  STATUS_DESC_PARTIALLY_CERTIFICATED: 'Certificacions pendents',

  STATUS_NEXT_STEP_INITIATED: 'Omplit de dades del client',
  STATUS_DESC_INITIATED: "Pendent d'omplir per part del client",

  STATUS_NEXT_STEP_LENDER_HAS_BEEN_SELECTED: 'Signatura del contracte',
  STATUS_DESC_PENDING_CONTRACT_SENDING: 'Pendent enviament contracte',
  STATUS_DESC_LENDER_HAS_BEEN_SELECTED: 'Contracte enviat, pendent signatura',

  STATUS_NEXT_STEP_CONTRACT_SIGNED: 'Validació de la sol·licitud',
  STATUS_DESC_CONTRACT_SIGNED: 'Signat per formalitzar',

  STATUS_NEXT_STEP_DOCUMENTATION: 'Enviament transferència',
  STATUS_DESC_DOCUMENTATION: 'Pagament pendent',

  STATUS_NEXT_STEP_UNOPENED: 'Obertura de la sol·licitud',
  STATUS_DESC_UNOPENED: 'Sense obrir',

  STATUS_NEXT_STEP_ANALYSING: 'Estudi de riscos',
  STATUS_DESC_ANALYSING: 'En estudi de riscos',

  STATUS_NEXT_STEP_UNPAID: 'Impagament',
  STATUS_DESC_UNPAID: 'Client en impagament',

  STATUS_NEXT_STEP_DENIED: 'Denegació',
  STATUS_DESC_DENIED: 'Sol·licitud denegada',

  STATUS_NEXT_STEP_DESISTED: 'Desistit',
  STATUS_DESC_DESISTED: "El client s'ha desistit",

  STATUS_NEXT_STEP_EXPIRED: 'Expiració',
  STATUS_DESC_EXPIRED: '30 dies sense activitat',
  STATUS_DESC_ORDER_EXPIRED: 'La comanda ha caducat',

  STATUS_NEXT_STEP_CANCELLED: 'Cancel·lació',
  STATUS_DESC_CANCELLED: 'Cancel·lat',

  STATUS_NEXT_STEP_CANCELLED_TEST: '-',
  STATUS_DESC_CANCELLED_TEST: 'Prova cancel·lada',

  STATUS_NEXT_STEP_ACTIVE: 'Abonament',

  STATUS_DESC_FRONT_COMPLETED: 'Completat',

  STATUS_DESC_ACTIVE: 'Pagament realitzat',
  STATUS_DESC_INFORMATION_PENDING: "Pendent d'omplir",
  STATUS_DESC_PAYMENT_PENDING: 'Pagament pendent',
  FILTER_FROM: 'Filtrar des de',
  FILTER_TO: 'Filtrar fins a',
  updated_at: 'Data actualització',
  created_at: 'Data creació',
  expiration_date: 'Data de caducitat',

  //CONSUMER LOAN DETAILS

  TOTAL_COST_PER_QUOTA: 'Cost total ($v1 per quota)',
  TOTAL_COST_PER_QUOTA_UPFRONT_PERCENTAGE: 'Cost total ($v1 upfront)',

  //MERCHANT LIST
  CONTACT_PERSON: 'Persona de contacte',
  STATUS_PENDING_DOCUMENTS: 'Documentació pendent',
  STATUS_DOCUMENTS_COMPLETED: 'Documentació completada',
  STATUS_DENIED_PENDING_MANUAL: 'Denegat pendent manual',
  STATUS_DENIED_EVALUATED: 'Avaluat denegat',
  STATUS_PRE_APPROVED: 'Preaprovat',
  STATUS_ASLEEP: 'Adormit',
  STATUS_SUSPENDED: 'Suspès',
  STATUS_BANNED: 'Expulsat',
  contact_person: 'Persona de contacte',
  status_pending_documents: 'Documentació pendent',
  status_documents_completed: 'Documentació completada',
  status_denied_pending_manual: 'Denegat pendent manual',
  status_denied_evaluated: 'Avaluat denegat',
  status_pre_approved: 'Preaprovat',
  status_asleep: 'Adormit',
  status_suspended: 'Suspès',
  status_banned: 'Expulsat',

  //MERCHANT LIST WIDGET
  ACTIONS: 'Accions',
  ADD_MERCHANT: 'Crear comerciant',
  CREATE_MERCHANT: 'Crear nou comerciant',

  //MERCHANT DETAIL WIDGET
  APPROVE_BY_COMMERCIAL: 'Aprovar per comercial',
  APPROVE_BY_COMMERCIAL_TEXT: 'Vols aprovar aquest comerciant per comercial?',
  APPROVE_BY_COMMERCIAL_BTN: 'Aprovar',
  APPROVE_BY_RISK: 'Aprovar per riscos',
  APPROVE_BY_RISK_TEXT: 'Vols aprovar aquest comerciant per riscos?',
  APPROVE_BY_RISK_BTN: 'Aprovar',
  SUSPEND_ACTION: 'Suspèn comerciant',
  SUSPEND_ACTION_TEXT: 'Vols suspendre temporalment aquest comerciant?',
  SUSPEND_ACTION_BTN: 'Suspèn',
  BAN_ACTION: 'Expulsa comerciant',
  BAN_ACTION_TEXT: 'Vols expulsar permanentment aquest comerciant?',
  BAN_ACTION_BTN: 'Expulsa',
  REACTIVATE_ACTION: 'Reactivar comerciant',
  REACTIVATE_ACTION_TEXT: 'Vols reactivar aquest comerciant?',
  REACTIVATE_ACTION_BTN: 'Reactivar',
  APPROVE: 'Aprova',
  SUSPEND: 'Suspèn',
  BAN: 'Expulsa',

  // MERCHANT OVERVIEW
  MERCHANT_CONFIGURATION: 'Configuració del merchant',
  PENDING_TODO_ACTIONS: 'Accions pendents',
  MERCHANT_OVERVIEW: 'Detall del comerciant',
  REGISTRATION_DATA: 'Dades de registre',
  COMPANY_INFORMATION: "Informació de l'empresa",
  BUSINESS_NAME: 'Nom comerciant',
  BUSINESS_NAME_FISCAL: 'Raó social',
  BUSINESS_TYPE: 'Tipus de negoci',
  DECLARED_BUSINESS_TYPE: 'Tipus de negoci',
  [DeclaredBusinessType.SELF_EMPLOYED]: 'Autònom/a',
  [DeclaredBusinessType.LTD]: 'Empresa',
  MERCHANT_CATEGORY: 'Sector',
  BUSINESS_DETAILS: 'Detalls empresa',
  SECTOR: 'Sector',
  ACQUISITION_CHANNEL: "Canal d'adquisició",
  CIF: 'CIF',
  TURNOVER: 'Facturació anual',
  [Turnover.ZERO_300]: 'De 0€ a 300K€',
  [Turnover.THREE_HUNDRED_1MILLION]: 'De 300K€ a 1M€',
  [Turnover.ONE_MILLION_2_MILLION]: 'De 1M€ a 2M€',
  [Turnover.TWO_MILLION_5_MILLION]: 'De 2M€ a 5M€',
  [Turnover.FIVE_MILLION_PLUS]: 'Més de 5M€',
  POSTAL_CODE: 'Codi postal',
  AMOUNT_OF_EMPLOYEES: "Nombre d'empleats",
  [AmountOfEmployees.ZERO_THREE]: 'De 0 a 3',
  [AmountOfEmployees.THREE_TEN]: 'De 3 a 10',
  [AmountOfEmployees.TEN_TWENTY]: 'De 10 a 20',
  [AmountOfEmployees.TWENTY_PLUS]: 'Més de 20',

  CONTACT_PERSON_DETAILS: 'Detalls de contacte',
  CONTACT_PERSON_FIRSTNAME: 'Nom persona de contacte',
  CONTACT_PERSON_LASTNAME: 'Cognoms persona de contacte',
  NAME: 'Nom',
  FIRSTNAME: 'Nom',
  LASTNAME: 'Cognoms',
  FULLNAME: 'Nom i cognoms',
  PHONE: 'Telèfon',

  LEGAL_ADDRESS: 'Adreça fiscal',
  ADD_LEGAL_ADDRESS: 'Afegir adreça fiscal',
  EDIT_LEGAL_ADDRESS: 'Editar adreça fiscal',
  CASH_IN_CASH_OUT_METHOD: 'Informació bancària',
  ACCOUNT_HOLDER_FIRSTNAME: 'Nom titular',
  ACCOUNT_HOLDER_LASTNAME: 'Cognoms titular',
  [`${AccountParticipationLevel.OWNER}_OPTION`]: 'Titular',
  [`${AccountParticipationLevel.CO_OWNER}_OPTION`]: 'Cotitular',
  [`${AccountParticipationLevel.OTHER}_OPTION`]: 'Altre',
  [`${AccountParticipationLevel.PARTICIPATED}_OPTION`]: 'Participant',
  [`${AccountParticipationLevel.UNKNOWN}_OPTION`]: 'Desconegut',

  [PaymentMethodType.A2A_PAYMENT]: 'Transferència bancària immediata',
  [PaymentMethodType.B2B_LOAN]: 'Préstec B2B',
  [PaymentMethodType.BNPL_INSTALMENTS]: 'Pagament en quotes',
  [PaymentMethodType.BNPL_SPLIT_PAY]: 'Fracciona el pagament',
  [PaymentMethodType.CONSUMER_LOAN_INSTALMENTS]: 'Finançament',
  [PaymentMethodType.CONSUMER_LOAN_SPLIT_PAY]: 'Finançament sense interessos',
  [PaymentMethodType.CARD_PAYMENT]: 'Pagament amb targeta',
  [PaymentMethodType.SUBSCRIPTION]: 'Subscripció',
  [PaymentMethodType.CARD_ONBOARDING]: 'Targeta de crèdit',
  // [PaymentMethodType.AUTO_LOAN]:'Préstec auto',   // Same as Product.AUTO
  // [PaymentMethodType.CREDIT_LINE]: 'Línia de crèdit',   // Same as Product.CREDIT_LINE

  [`${PaymentMethodType.A2A_PAYMENT}_SHORT`]: 'Transferència immediata',
  [`${PaymentMethodType.B2B_LOAN}_SHORT`]: 'Préstec B2B',
  [`${PaymentMethodType.BNPL_INSTALMENTS}_SHORT`]: 'Pagament en quotes',
  [`${PaymentMethodType.BNPL_SPLIT_PAY}_SHORT`]: 'Fracciona el pagament',
  [`${PaymentMethodType.CONSUMER_LOAN_INSTALMENTS}_SHORT`]: 'Finançament',
  [`${PaymentMethodType.CONSUMER_LOAN_SPLIT_PAY}_SHORT`]: 'Finançament sense interessos',
  [`${PaymentMethodType.CARD_PAYMENT}_SHORT`]: 'Pagament amb targeta',
  [`${PaymentMethodType.SUBSCRIPTION}_SHORT`]: 'Subscripció',
  [`${PaymentMethodType.AUTO_LOAN}_SHORT`]: 'Préstec auto',
  [`${PaymentMethodType.CREDIT_LINE}_SHORT`]: 'Línia de crèdit',
  [`${PaymentMethodType.CREDIT_CARD}_SHORT`]: 'Targeta de crèdit',
  [`${PaymentMethodType.CARD_ONBOARDING}_SHORT`]: 'Targeta de crèdit',

  [OperativeType.STANDARD]: 'Operació estàndard',
  [OperativeType.NO_PAYROLL]: 'Operació sense nòmina',

  PAYMENT_METHODS: 'Mètodes de pagament',
  PER_MONTH: '/mes',

  ACCOUNT_HOLDER_FIRST_NAME: 'Nom',
  ACCOUNT_HOLDER_FIRST_LAST_NAME: 'Primer cognom',
  ACCOUNT_HOLDER_SECOND_LAST_NAME: 'Segon cognom',
  ACCOUNT_HOLDER_PARTICIPATION_LEVEL: 'Tipus de participant',
  EDIT_BANK_ACCOUNT: 'Editar el compte bancari',

  BANK: 'Entitat financera',
  ACCOUNT_NUMBER_IS_NOT_VALID: 'El número de compte bancari no és vàlid',
  BANK_RELATED_TO_ACCOUNT_NUMBER_DOES_NOT_EXIST_IN_TABLE: 'El número de compte correspon a un banc no suportat',
  BANK_ACCOUNT_NUMBER_DOES_NOT_MATCHES_THE_SELECTED_BANK:
    'El banc seleccionat no correspon al compte bancari introduït',

  ADD_CASH_IN_CASH_OUT_METHOD: 'Afegir informació bancària',
  EDIT_CASH_IN_CASH_OUT_METHOD: 'Editar informació bancària',

  ADD_BRAND_INFORMATION: 'Afegir informació de marca',
  EDIT_BRAND_INFORMATION: 'Editar informació de marca',
  BRANDING: 'Marca',
  BRAND_NAME: 'Nom comercial',
  CUSTOMER_SUPPORT_EMAIL: 'Correu electrònic de suport',
  CUSTOMER_SUPPORT_PHONE_NUMBER: 'Telèfon de suport',
  HOMEPAGE_URL: 'URL pàgina principal',
  BRAND_LOGO: 'Logotip del comerç',
  BRAND_LOGO_URL: 'URL logotip',
  ADD_BRANDING_INFROMATION: 'Afegir branding',
  EDIT_BRANDING_INFORMATION: 'Editar branding',
  CHOOSE_IMAGE_FILE: 'Seleccionar el fitxer',
  CHOOSE_LOGO_IMAGE_FILE: 'Seleccionar el fitxer del logotip',
  IMAGE_SIZE: 'Mida de la imatge',

  // MERCHANT COMPLIANCE
  MERCHANT_CONTRACT: 'Contracte de col·laboració',
  CONTRACT_SENT_DATE: 'Data enviament del contracte',
  CONTRACT_SIGNED_DATE: 'Data signatura del contracte',
  CONTRACT_STATUS: 'Estat del contracte',
  SIGNED: 'Signat',
  NOT_SENT: 'No enviat',
  MERCHANT_DATA: "Dades de l'empresa",
  COMPANY_MANAGER_DATA: "Dades de l'administrador",
  COMPANY_MANAGER_NAME: 'Nom i cognom(s)',
  ID_NUMBER: "Número de document d'identitad",

  SEE_MERCHANT_CONTRACT_FIELDS: 'Veure dades del contracte enviat',
  SEE_MERCHANT_CONTRACT_FIELDS_FROM_CRM: 'Veure dades actuals al CRM',
  MERCHANT_CONTRACT_DATA: 'Dades del contracte',
  MERCHANT_CONTRACT_DATA_FROM_CRM: 'Dades del contracte al CRM',
  MERCHANT_CONTRACT_DATA_TEXT:
    'Les següents dades corresponen a les enviades al contracte de col·laboració el dia $v1.',
  PROVINCE: 'Província',
  COMPANY_MANAGER_FULLNAME: "Nom i cognoms de l'administrador",
  COMPANY_MANAGER_DOCUMENT_NUMBER: 'DNI administrador',
  CONTACT_EMAIL: 'Correu electrònic de contacte',
  CONTACT_PHONE_NUMBER: 'Telèfon de contacte',

  SEND_MERCHANT_CONTRACT_REMINDER: 'Enviar recordatori de signatura',
  SEND_REMINDER: 'Enviar recordatori',
  SEND_MERCHANT_CONTRACT_REMINDER_TEXT: 'Vols enviar un recordatori per signar el contracte que ja va ser enviat?',
  SEND_NEW_MERCHANT_CONTRACT: 'Enviar nou contracte',
  SEND_NEW_MERCHANT_CONTRACT_TEXT:
    'Vols enviar un nou contracte amb les dades actuals del CRM? Pots veure les dades que s\'inclouran al nou contracte fent clic a "Veure dades actuals al CRM".',

  // MERCHANT IN LENDER CONTEXT
  FINANCIAL_ENTITIES_ENABLED: 'Entitats financeres habilitades',
  ADD_MERCHANT_IN_LENDER_CONTEXT: 'Afegir entitats financeres',
  EDIT_MERCHANT_IN_LENDER_CONTEXT: 'Editar entitats financeres',
  EDIT_MERCHANT_IN_LENDER_CONTEXT_TEXT: 'Selecciona les entitats financeres habilitades per a aquest comerciant.',

  // MERCHANT_STRUCTURE
  REFRESH: 'Actualitzar',
  LIVE: "En viu: aquesta pàgina s'actualitza automàticament",
  LIVE_RECONNECTING: 'Reconnectant a les actualitzacions en viu…',
  LIVE_PENDING_CHANGES: '$v1 canvis · Actualitza',
  REFRESH_DATA: 'Actualitzar informació',
  MAIL: 'Correu electrònic',
  ADD_MERCHANT_STRUCTURE: 'Afegir canals i agents',
  MERCHANT_STRUCTURE: 'Estructura',
  CHANNEL_STRUCTURE: 'Estructura del canal',
  CHANNELS_AND_AGENTS: 'Canals i agents',
  SELECT_CHANNEL_TO_VIEW_ITS_AGENTS_AND_DETAILS: 'Selecciona un canal per veure els seus agents i detalls.',
  X_CHANNELS_AND_Y_AGENTS_IN_TOTAL: '$v1 canals i $v2 agents en total.',
  SELECT_CHANNEL_TO_VIEW_DETAILS: 'Selecciona aquest canal per veure els seus agents i detalls.',
  X_ONLY_INCLUDES_ONE_CHANNEL: "Es compon d'un únic canal amb $v2 agent/s",
  AGENTS: 'Agents',
  AGENT: 'Agent',
  SALES_AGENT: 'Agent (vendedor)',
  SEARCH_AGENT: 'Cercar agent',
  CHANNEL: 'Canal',
  CHANNELS: 'Canals',
  SALES_CHANNEL: 'Canal de vendes',
  NO_ASSOCIATED_CHANNEL_ACCOUNT: 'Sense accés',
  THERE_ARE_NO_AGENTS_ON_THIS_CHANNEL_YET: 'Encara no hi ha cap agent creat en aquest canal',
  THERE_ARE_NO_CHANNEL_YET: 'Encara no hi ha cap canal creat',
  THERE_ARE_NO_LISTS_TO_SHOW: 'Encara no hi ha sol·licituds per mostrar',
  AGENTS_OF_CHANNEL_X: 'Agents del canal $v1',
  MERCHANT_STATISTICS: 'Estadístiques del comerciant',
  COPY_MERCHANT_ID: 'Copiar ID del comerciant',
  COPY_AGENT_ID: "Copiar ID de l'agent",
  COPY_CHANNEL_ID: 'Copiar ID del canal',
  COPY_BORROWER_ID: 'Copiar ID del prestatari',
  ADD_CHANNEL: 'Afegir canal',
  ADD_ANOTHER_AGENT: 'Afegir un altre agent',
  ADD_AGENT_TO_CHANNEL: 'Afegir agent a $v1',
  NUMBER_OF_CHANNELS: '$v1 canals',
  NUMBER_OF_CHANNEL_1: '1 canal',
  NUMBER_OF_AGENTS: '$v1 agents',
  NUMBER_OF_AGENT_1: '1 agent',

  SELECTED_AGENT_ERROR_ALERT:
    "L'agent seleccionat no té mètodes de pagament disponibles. Si us plau, intenta seleccionar un altre agent o canal.",

  TYPE_OF_APPLICATIONS: 'Sol·licituds de tipus:',
  APPLICATIONS_LIST: 'Llistat de sol·licituds',

  //MERCHANT CATEGORY
  awnings: 'Tendals',
  elevators: 'Ascensors',
  installations: 'Instal·lacions',
  education_and_trainings: 'Educació',
  buildings: 'Edificació',
  car_dealerships: 'Venda de cotxes',
  moto_dealerships: 'Venda de motos',
  driving_courses: 'Cursos de conducció',
  languages_courses: "Cursos d'idiomes",
  bootcamp_courses: 'Bootcamps',
  fp_programs: 'Cursos de formació',
  business_schools_programs: 'Business schools',
  postgraduate_and_masters: 'Masters',
  other_professional_courses: 'Altres cursos professionals',
  school: 'Instituts',
  fertility_treatment: 'Tractaments de fertilitat',
  orthopedic_equipment: 'Aparells ortopèdics',
  other_surgery_interventions: 'Altres intervencions quirúrgiques',
  rehabilitation: 'Rehabilitació',
  optical_prosthesis: 'Pròtesis oculars',
  cosmetic_surgery: 'Medicina estètica',
  dental_treatments: 'Medicina dental',
  cosmetic_treatments: 'Tractaments cosmètics',
  auditory_prothesis: 'Pròtesis auditives',
  terrace_and_awnings: 'Terrasses i tendals',
  structure_and_humidity: 'Estructures i humitats',
  insulation: 'Aïllaments',
  warehouse: 'Emmagatzematge de material',
  kitchen: 'Cuines',
  bathrooms: 'Dutxes i banys',
  furniture: 'Mobles',
  windows: 'Finestres i portes',
  pools: 'Piscines',
  gardening: 'Jardins',
  home_automation: 'Domòtica',
  prefabricated_houses: 'Cases prefabricades',
  decoration_and_design: 'Decoradors i dissenyadors',
  architecture: 'Arquitectes',
  floors_and_ceilings: 'Parquet i sostres',
  whole_house: 'Reformes integrals',
  painting: 'Pintors',
  carpentry: 'Carpinteria, fusta i alumini',
  home_staging: 'Home staging',
  water_treatment: "Tractament d'aigua",
  air_treatments: 'Aire condicionat',
  eco_improvement_and_solar_panels: 'Ecoreformes i panells solars',
  electric_installations: 'Instal·lacions elèctriques',
  heating_installations: 'Calefacció',
  alarms_and_security: "Sistemes d'alarma",
  car_tuning: 'Car tuning',
  car_service: 'Tallers de cotxes',
  moto_service: 'Tallers de motos',
  bike: 'Bicicletes',
  other_mobility_and_accessories: 'Altres accessoris de mobilitat',
  household_appliances: 'Electrodomèstics',
  garden_machines: 'Maquinària de jardineria',
  perfumery_and_cosmetics: 'Perfumeria i cosmètics',
  gym_accessories: 'Accessoris de gimnàs',
  electronic: 'Electrònica',
  antiques: 'Antiguitats',
  art: 'Art',
  jewellery: 'Joieria',
  fashion: 'Moda i accessoris',
  lighting: 'Il·luminació',
  travels: 'Viatges',
  relocation: 'Mudances',
  real_estate_and_rentals: 'Immobililiàries i lloguers',
  celebrations: 'Celebracions',
  funeral_services: 'Serveis funeraris',
  pet_shops: "Botigues d'animals",
  charging_points: 'Punts de càrrega',

  //LOAN DETAIL WIDGET
  ADD_PARTICIPANT_TO_LOAN: 'Afegir cotitular/avalista',
  REMOVE_PARTICIPANT_FROM_LOAN: 'Eliminar cotitular/avalista',
  REMOVE_PARTICIPANT_DIALOG: 'Eliminar cotitular/avalista',
  REMOVE_PARTICIPANT_DIALOG_TEXT: 'Vols eliminar el següent participant de la sol·licitud?',
  REMOVE_PARTICIPANT_DIALOG_BTN: 'Eliminar participant',
  remove_co_borrower: 'Eliminar cotitular',
  remove_guarantor: 'Eliminar avalista',
  PARTICIPANT_ROLE: 'Tipus de participant',
  ADD_PARTICIPANT_DIALOG: 'Afegir cotitular/avalista',
  ADD_PARTICIPANT_DIALOG_TEXT:
    'Omple les dades de contacte del nou cotitular/avalista de la sol·licitud. A continuació li enviarem un email per a que pugui completar la seva informació personal.',
  PARTICIPANT_RELATION: 'Relació',
  ADD_PARTICIPANT_DIALOG_BTN: 'Afegir participant',
  add_borrower: 'Afegir titular',
  add_co_borrower: 'Afegir cotitular',
  add_guarantor: 'Afegir avalista',
  INVALID_PHONE_NUMBER: 'Número de telèfon invàlid',
  INVALID_DIAL_CODE: 'Codi invàlid',
  ADD_GUARANTOR_TO_LOAN: 'Afegir avalista',
  REMOVE_GUARANTOR_FROM_LOAN: 'Eliminar avalista',
  REMOVE_GUARANTOR_DIALOG: 'Eliminar avalista',
  ADD_GUARANTOR_DIALOG: 'Afegir avalista',
  REMOVE_GUARANTOR_DIALOG_TEXT: 'Vols eliminar el següent avalista de la sol·licitud?',

  CHANGE_LOAN_CONDITIONS: 'Modificar condicions',
  PRINCIPAL_VALUE_SELECTOR: 'Import (entre $v1 i $v2)',
  TERM_VALUE_SELECTOR: 'Termini (entre $v1 i $v2 mesos)',
  INVALID_PRINCIPAL_VALUE: 'Import no permès',
  AUTO_AMOUNT_OUT_OF_RANGE: "L'import del vehicle ha de ser superior a $v1",
  INVALID_TERM_VALUE: 'Termini no permès',
  THE_TERM_VALUE_DOES_NOT_EXIST_IN_PRICING: 'El termini no existeix per a la tarifa i import seleccionats',
  SELECT_PRICING: 'Selecciona tarifa',
  SELECT_PRICING_DESCRIPTION:
    "Selecciona una de les tarifes disponibles per a l'agent i introdueix els nous valors d'import i termini.",
  EDIT_LOAN_CONDITIONS: 'Editar condicions del préstec',
  CURRENT_LOAN_CONDITIONS: 'Condicions actuals',
  NEW_LOAN_CONDITIONS: 'Noves condicions',
  COMPARE: 'Comparar condicions',
  ADJUST_LOAN_CONDITION: 'Tornar a ajustar condicions',
  NO_PRICINGS_AVAILABLE: "No s'han trobat tarifes disponibles",
  PRICINGS_ARE_FILTERED_BY_LOAN_CONDITIONS: "*Les tarifes s'estan filtrant pel programa actual del préstec",
  LOAN_CALCULATOR_NOT_FOUND_FOR_THE_GIVEN_TERM: "No s'han trobat condicions per al termini seleccionat",
  SELECT_PRICING_PRINCIPAL_AND_TERM: "Selecciona una tarifa de l'agent i introdueix un import i termini vàlids",
  INVALID_OPTIONS_FOR_THE_CONDITIONS: 'Opcions no vàlides per al programa seleccionat',
  [`all_${PricingFilterType.PRODUCT}`]: 'Tots els productes',
  [`all_${PricingFilterType.PROGRAM}`]: 'Tots els programes',

  // AGENT DETAIL WIDGET
  CHANGE_TO_ANOTHER_CHANNEL: 'Canviar de canal',
  CHANGE_TO_ANOTHER_CHANNEL_TEXT: "Vols moure l'agent a un altre canal?",
  CHANGE_TO_ANOTHER_CHANNEL_BTN: 'Canviar de canal',
  NEW_CHANNEL: 'Nou canal',
  CURRENT_CHANNEL: 'Canal actual',

  CREATE_NEW_AGENTS: 'Crear nous agents',
  MODIFY_AGENTS: 'Modificar agents',
  FROM_THIS_AGENT: "Vas a copiar a partir de les dades d'aquest agent:",
  LIST_OF_NEW_AGENTS: 'Llistat de nous agents',
  LIST_OF_NEW_AGENTS_TEXT:
    "Introdueix el nom, cognoms i correu electrònic dels múltiples agents a generar a partir de l'agent seleccionat:",
  LIST_OF_AGENTS_TO_UPDATE: "Llistat d'agents a modificar",
  LIST_OF_AGENTS_TO_UPDATE_TEXT: "Tria els agents a modificar a partir de l'agent seleccionat:",
  BACK: 'Enrere',

  CLONE_AGENT_MENU: 'Copiar i crear nous agents',
  UPDATE_AGENT_MENU: 'Copiar i modificar agents',

  CLONE_AGENT_WITH_NAME: 'Clonar a $v1',
  CLONE_AGENT_BTN: 'Clonar',
  AGENT_TO_CLONE: 'Copiar dades de',
  DESTINATION_CHANNEL: 'Canal de destinació',
  DESTINATION_CHANNEL_TOOLTIP: "Tria el canal de destinació on s'assignaran els nous agents clonats",
  CONFIGURATION_OPTIONS: 'Opcions de configuració',
  CONFIGURATION_OPTIONS_CLONE_TEXT: 'Tria quines opcions de configuració vols per als nous agents:',
  CONFIGURATION_OPTIONS_UPDATE_TEXT:
    'Tria quines opcions de configuració vols copiar per modificar els agents seleccionats:',
  CLONE_CONFIGURATION: 'Configuració',
  CLONE_AGENT_IN_LENDER_CONTEXT: 'Credencials en entitats financeres',
  CLONE_PRICINGS: 'Tarifes',
  CLONE_CREATE_USER: 'Crear usuari',
  CLONE_SEND_PASSWORD_RECOVERY: 'Enviar correu electrònic per generar contrasenya',
  CLONE_AGENT_EMAIL_TOOLTIP:
    "A l'hora de crear o modificar un agent, es necessita un correu electrònic per validar que no existeixi ja a la plataforma. No obstant això, si no es vol crear un usuari per l'agent, es pot marcar aquesta opció al següent pas. En qualsevol cas, el correu electrònic és necessari per a la creació o modificació de l'agent.",
  NEW_AGENTS: 'Nous agents',
  NEW_AGENTS_TEXT: 'Introdueix el nom i correu electrònic dels nous agents a generar:',
  CREATE_NEW_AGENTS_NUMBER: 'Crear $v1 agents',
  UPDATE_NEW_AGENTS_NUMBER: 'Modificar $v1 agents',
  CREATING_NEW_AGENTS: 'Creant nous agents',
  SEE_ERROR_DETAILS: "Veure missatge d'error",
  CLONE_SUCCESS: 'Creat',
  CLONE_UPDATED: 'Modificat',
  CLONE_ERROR: 'Error',
  SELECT_DESIRED_AGENTS: 'Tria els agents a modificar',

  // CHANNEL

  CHANNEL_ID: 'ID de canal:',
  CHANNEL_TYPE: 'Tipus de canal',
  CHANNEL_DESCRIPTION: 'Descripció del canal',
  CHANNEL_DETAILS: 'Detalls del canal',
  CHANNEL_CONFIGURATION: 'Configuració del canal',
  [ChannelType.APP]: 'App',
  [ChannelType.MARKETPLACE]: 'Marketplace',
  [ChannelType.PHONE]: 'Telèfon',
  [ChannelType.SOCIAL_MEDIA]: 'Xarxes socials',
  [ChannelType.STORE]: 'Botiga física',
  [ChannelType.TPV]: 'TPV',
  [ChannelType.WEB]: 'Web',

  // AGENT

  AGENT_DETAILS: "Detall de l'agent",
  AGENT_ID: "ID de l'agent:",
  AGENT_CONFIGURATION: "Configuració de l'agent",
  CONFIGURATION: 'Configuració',
  ENABLED: 'Habilitat',
  DISABLED: 'Deshabilitat',
  AGENT_NAME: "Nom de l'agent",
  AGENT_EMAIL: "Email de l'agent",
  CUSTOM_THEME: 'Aparença',
  CUSTOM_REGISTRY: 'Registre',
  CUSTOM_LANGUAGE: 'Idioma',
  COMMUNICATIONS: 'Comunicacions',
  BANK_READER_ENABLED: 'Aggregació bancària',
  QUOTA_SELECTION_ALLOWED: 'Ajustament de quota',
  DOCUMENT_REQUIRED_MANAGEMENT: 'Gestor documental',
  CERTIFICATIONS: 'Certificacions',
  STATUS_ANALYSING_ENABLED: 'Estudi de Riscos',
  BANK_READER_MAX_ATTEMPTS: 'Màxim número intents bank reader',
  ALLOWED_ASSET_TYPES: 'Sectors permesos',
  ALLOWED_PRODUCTS: 'Productes permesos',
  ALLOWED_ARTICLE_TYPES: 'Articles permesos',
  ALLOWED_ONBOARDING_FULFILLED_BY_TYPES: 'Processos de sol·licitud permesos',
  [Product.CONSUMER_LOAN]: 'Préstec consum',
  [Product.AUTO]: 'Préstec auto',
  [Product.CREDIT_LINE]: 'Línia de crèdit',
  [CustomLanguage.ENGLISH]: 'Anglès',
  [CustomLanguage.SPANISH]: 'Castellà',
  FINANCIAL_ENTITIES: 'Entitats financeres',
  FINANCIAL_ENTITIES_CREDENTIALS: 'Credencials en entitats financeres',
  FREE_PROGRAM: 'Programa estàndard',
  ZERO_PROGRAM: 'Programa zero',
  FREE_PROGRAM_SHORT: 'Estàndard',
  ZERO_PROGRAM_SHORT: 'Zero',
  SLIDE_TO_SEE_ALL_VALUES: 'Arrossega per veure tots els valors',
  CREATION: 'Creació',
  CREATED_AT_FOR_TABLE: 'Data creació',
  PROGRAM: 'Programa',
  PROGRAMS: 'Program(es)',
  MARKET: 'Mercat',
  OPTIONAL: 'opcional',
  AGENT_IN_LENDER_CONTEXT_ID: 'ID merchant',
  MERCHANT_ID_IN_LENDER_CONTEXT: 'ID merchant',
  CHANNEL_ID_IN_LENDER_CONTEXT: 'ID canal',
  AGENT_ID_IN_LENDER_CONTEXT: 'ID agent',
  ALLOWED_PURCHASE_COUNTRIES: 'Països de compra permesos',
  paymentMethodType: 'Mètode de pagament',
  PAYMENT_METHOD_TYPE: 'Mètode de pagament',
  ALLOWED_PAYMENT_METHODS: 'Mitjans de pagament permesos',
  ALL_PAYMENT_METHODS: 'Tots els mètodes de pagament',
  FILTER_BY_PAYMENT_METHOD_AND_OTHERS: 'Filtra les tarifes pels filtres disponibles',
  RELOAD_PRICINGS: 'Torna a carregar les tarifes',
  WITH: 'Amb',
  WITHOUT: 'Sense',
  WITH_GRACE_PERIOD: 'Amb carencia',
  WITHOUT_GRACE_PERIOD: 'Sense carencia',
  WITH_SETUP_FEE: 'Amb comisión de apertura',
  WITHOUT_SETUP_FEE: 'Sense comisión de apertura',
  SEARCH_BY_PRICING_NAME: 'Buscar (nom de tarifa)',
  LENDER_NOT_AVAILABLE_WARNING:
    'La entitat $v1 no està disponible per a aquest usuari. Contacta amb Nemuru per configurar la possibilitat de treballar amb aquesta entitat financera.',

  USERNAME: 'Usuari',
  CLIENT_SECRET_OAUTH_2: 'Client secret (OAuth 2)',
  CLIENT_ID_OAUTH_2: 'Client ID (OAuth 2)',
  HAS_USERNAME_TOOLTIP: "Les credencials actuals emmagatzemades a la plataforma contenen un nom d'usuari",
  HAS_PASSWORD_TOOLTIP: 'Les credencials actuals emmagatzemades a la plataforma contenen una contrasenya',
  HAS_CLIENT_ID_OAUTH_2_TOOLTIP: 'Les credencials actuals emmagatzemades a la plataforma contenen un client_id',
  HAS_CLIENT_SECRET_OAUTH_2_TOOLTIP: 'Les credencials actuals emmagatzemades a la plataforma contenen un client_secret',
  STORED_CREDENTIAL_FIELD_TOOLTIP: "Ja guardat. Deixa'l buit per no canviar-lo.",
  STORED_VALUE_LABEL_SUFFIX: 'guardat',

  ADD_CREDENTIALS: 'Afegir credencials',
  THE_FOLLOWING_CREDENTIALS_WILL_BE_DELETED: "S'eliminaran les següents credencials:",
  EDIT_CREDENTIALS: 'Editar credencials',
  DELETE_CREDENTIALS: 'Eliminar credencials',
  DELETE: 'Eliminar',
  NO_CREDENTIALS_SET: 'Encara no hi ha credencials',
  NO_AGENT_PRICINGS: "Encara no s'han assignat tarifes",
  MUST_BE_A_NUMERIC_VALUE: 'Aquest valor ha de ser numèric',
  AGENT_CREATION_FOR_CHANNEL_X: 'Vas a crear un nou agent pel canal $v1',
  CREATE_AGENT: 'Crear agent',
  UPDATE_AGENT: 'Modificar agent',
  ADD_AGENT: 'Afegir agent',
  IS_STATUS_ANALYSING_ENABLED: 'Estudi de Riscos',
  SELECTED_PRICINGS: 'Tarifes seleccionades: $v1',
  REMOVE_PRICING_FROM_AGENT: "Eliminar tarifa de l'agent",
  REMOVE_PRICING_SPECS: 'Eliminar codis de tarifes',
  REMOVE_X_PRICING_SPECS: 'Eliminar $v1 codi(s) de tarifa',
  ADD_PRICING_SPEC_IN_LENDER_CONTEXT: 'Afegir codi de tarifa',
  ADD_PRICING_SPEC_IN_LENDER_CONTEXT_DESCRIPTION: 'Introdueix els detalls del nou codi de tarifa que vols afegir',
  REMOVE_PRICING_SPEC_IN_LENDER_CONTEXT_DESCRIPTION:
    'Selecciona els codis de tarifa de les entitats financeres que vols eliminar.',
  REMOVE_PRICING_SPEC_IN_LENDER_CONTEXT: 'Eliminar codi de tarifa',
  PRICING_NAME_IN_LENDER_CONTEXT: 'Nom de codi de tarifa',
  PRICING_VERSION: 'Versió',
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_PRICING_FROM_AGENT: "Vols eliminar aquesta tarifa de l'agent?",
  REMOVE_FROM: 'Eliminar',
  FILL_WITH_CHANNEL_AND_AGENT_DATA: 'Omplir dades del canal i agent',
  THERE_ARE_NO_CHANNELS_FOUND_BY_SEARCH_PARAMS: "No s'ha trobat cap canal en base als paràmetres de cerca",
  NO_AGENTS_FOUND_BY_SEARCH_TERM: "No s'ha trobat cap agent en base als paràmetres de cerca",
  SET_ARTICLE_TYPE: "Limitar el tipus d'article",
  SET_ARTICLE_TYPE_EXPLANATION: "Només utilitzar si es vol limitar aquesta credencial a un tipus d'article específic",

  //AGENT IN SINGLE PAYMENT PROVIDER CONTEXT
  SET_AGENT_IN_SINGLE_PAYMENT_PROVIDER_CONTEXT_CONFIGURATION: 'Afegir configuració de credencials',
  AGENT_IN_LENDER_CONTEXT_TAB_LABEL: 'Pagaments finançats',
  AGENT_IN_SINGLE_PAYMENT_PROVIDER_CONTEXT_TAB_LABEL: 'Pagament únic',
  PROVIDER_ID_IN_PROVIDER_CONTEXT: 'ID Plataforma de pagament',
  AGENT_ID_IN_PROVIDER_CONTEXT: 'ID Agent',
  PROVIDER_ID: 'Plataforma de pagament',
  PROVIDERS_DETAILS: 'Configuracions',
  [CredentialsType.AGENT_IN_LENDER_CONTEXT]: 'Credencials en entitats financeres',
  [CredentialsType.AGENT_IN_SINGLE_PAYMENT_PROVIDER_CONTEXT]: 'Credencials en plataformes de pagament',

  // AGENT PRICINGS
  PRICINGS: 'Tarifes',
  ASSIGNED_PRICINGS: 'Tarifes assignades',
  SEARCH_PRICING: 'Cerca de tarifes...',
  ASSIGN_PRICINGS_TO_AGENT: 'Modificar tarifes assignades',
  UPLOAD_PRICINGS_TO_CDN: 'Pujar tarifes al CDN',
  UPLOAD_PRICINGS_TO_CDN_DIALOG: 'Pujar tarifes al CDN',
  UPLOAD_PRICINGS_TO_CDN_DIALOG_TEXT: 'Vols pujar les tarifes assignades actualment a aquest agent al CDN?',
  UPLOAD_PRICINGS_TO_CDN_DIALOG_BTN: 'Pujar',
  PRICINGS_IN_CDN: 'Tarifes pujades al CDN',
  PRICINGS_IN_CDN_STATUS: 'Estat de les tarifes al CDN',
  NO_PRICINGS_UPLOADED_TO_CDN: "No s'han pujat tarifes al CDN",
  DOWNLOAD_PRICINGS_FROM_CDN: 'Veure tarifes al CDN',
  UPLOADED_TO_CDN: 'Pujades al CDN',
  NOT_UPLOADED_TO_CDN: 'No pujades al CDN',
  COPY_PRICING_ID: 'Copiar ID de tarifa',
  PRICING_NAME: 'Nom de la tarifa',
  RANGE_PRINCIPAL: 'Principal',
  RANGE_PERIOD: 'Termini',
  LENDERS: 'Entitats',
  TAGS: 'Etiquetes',
  SEE_PRICING_DETAIL: 'Veure detall de la tarifa',

  [Program.FREE_PROGRAM]: 'Programa estàndard',
  [Program.ZERO_PROGRAM]: 'Programa zero',
  [Program.NO_PURCHASE]: 'Alta sense compra',
  [Program.CAMPAIGN]: 'Campanya',

  [FeePaymentType.TYPE_UPFRONT]: 'apertura',
  [FeePaymentType.TYPE_FINANCED]: 'finançat',
  [FeePaymentType.TYPE_FIXED_AMOUNT]: '/quota',

  RANGE_PRINCIPAL_MIN: 'Import mín.',
  RANGE_PRINCIPAL_MAX: 'Import màx.',
  RANGE_PERIOD_MIN: 'Plaç mín.',
  RANGE_PERIOD_MAX: 'Plaç màx.',
  ANNUAL_INTEREST: 'Interès',
  EXPENSES: 'Despeses',
  COST_MERCHANT: 'Cost merchant',
  MERCHANT_FEE: 'Comissió',
  GRACE_PERCENTAGE_PERIOD: 'Carència (mesos)',
  LENDER_PRICING_NAME: 'Codis',

  SEE_SELECTED_PRICINGS: 'Veure seleccionades',
  SET_PRICINGS_DIALOG: 'Modificar tarifes assignades',
  SET_PRICINGS_DIALOG_TEXT: 'Resum de la modificació a realitzar:',
  SET_PRICINGS_DIALOG_BTN: 'Modificar',
  UNCHANGED_PRICINGS: 'Tarifes sense canvis',
  PRICINGS_TO_ADD: 'Tarifes noves',
  PRICINGS_TO_REMOVE: 'Tarifes eliminades',

  REQUEST_PATCH_SET_PRICING_IDS_TO_AGENT_FULFILLED: "S'han modificat les tarifes assignades correctament",
  REQUEST_PATCH_SET_PRICING_IDS_TO_AGENT_REJECTED: 'Ha sorgit un problema en intentar modificar les tarifes assignades',

  EDIT_AGENT_PRICINGS_RANGES: 'Editar límits de tarifes',
  EDIT_AGENT_PRICINGS_RANGES_DIALOG: 'Editar límits de tarifes',
  EDIT_AGENT_PRICINGS_RANGES_DIALOG_TEXT: "Si us plau, selecciona els nous límits de les tarifes de l'agent:",
  EDIT_AGENT_PRICINGS_RANGES_DIALOG_BTN: 'Editar límits',
  MIN_PERIOD: 'Termini mínim',
  MAX_PERIOD: 'Termini màxim',
  MIN_PRINCIPAL: 'Import mínim',
  MAX_PRINCIPAL: 'Import màxim',
  [RangeType.PERIOD]: 'Termini',
  [RangeType.PRINCIPAL]: 'Import',

  MIN_PERIOD_CANNOT_BE_GREATER_THAN_MAX_PERIOD: 'El termini mínim no pot ser superior al termini màxim',
  MIN_PRINCIPAL_CANNOT_BE_GREATER_THAN_MAX_PRINCIPAL: "L'import mínim no pot ser superior a l'import màxim",
  MIN_PERIOD_CANNOT_BE_LOWER_THAN_MIN_ALLOWED_PERIOD: 'El termini mínim no pot ser inferior a $v1',
  MIN_PRINCIPAL_CANNOT_BE_LOWER_THAN_MIN_ALLOWED_PRINCIPAL: "L'import mínim no pot ser inferior a $v1",
  MAX_PERIOD_CANNOT_BE_GREATER_THAN_MAX_ALLOWED_PERIOD: 'El termini màxim no pot ser superior a $v1',
  MAX_PRINCIPAL_CANNOT_BE_GREATER_THAN_MAX_ALLOWED_PRINCIPAL: "L'import màxim no pot ser superior a $v1",
  REQUEST_PATCH_SET_RANGES_FOR_AGENT_FULFILLED: "Els rangs de les tarifes de l'agent s'han modificat correctament.",
  REQUEST_PATCH_SET_RANGES_FOR_AGENT_REJECTED:
    "S'ha produït un problema en intentar modificar els rangs de les tarifes de l'agent",

  // Usuaris
  ADD_USER: "Afegir credencials d'accés",
  BLOCK_ALL_USERS: 'Bloquejar totes les credencials',
  COPY_USER_ID: "Copiar ID de l'usuari",
  BLOCK_STATUS: 'Estat',
  BLOCKED: 'Bloquejat',
  UNBLOCKED: 'Habilitat',
  ROLES: 'Rols',
  SEND_FORGOT_PASSWORD_EMAIL: 'Enviar correu per generar contrasenya oblidada',
  CHANGE_ROLES: 'Canviar rols',
  BLOCK_USER: 'Bloquejar credencials',
  UNBLOCK_USER: 'Habilitar credencials',
  DO_YOU_WANT_TO_BLOCK_THE_FOLLOWING_USERS: 'Vols bloquejar les següents credencials?',
  DO_YOU_WANT_TO_BLOCK_THE_USER: 'Vols bloquejar les credencials $v1?',
  DO_YOU_WANT_TO_UNBLOCK_THE_USER: 'Vols habilitar les credencials $v1?',
  PASSWORD_RECOVERY_LIST: 'Correus electrònics de recuperació de contrasenya enviats',
  SEE_PASSWORD_RECOVERY_LIST: 'Veure correus electrònics enviats',
  CAN_BE_USED_TO_CHANGE_PASSWORD: 'Pot ser utilitzat per canviar la contrasenya',
  HAS_BEEN_USED: "S'ha utilitzat",
  COPY_EMAIL_ID: 'Copiar identificador de recuperació de contrasenya',
  CHANGE_USER_BY_ID: "Canviar les credencials d'usuari a través d'ID",
  CHANGE_USER_BY_ID_TEXT:
    "Introdueix l'ID de l'agent, canal o comerciant al qual vols moure aquestes credencials. Si us plau, assegura't que l'ID sigui correcte.",
  NEW_USER_ID: "Nou ID d'usuari",
  BLOCK: 'Bloquejar',
  UNBLOCK: 'Habilitar',
  BLOCK_USERS: 'Bloquejar credencials',
  OLD_PASSWORD: 'Contrasenya actual',
  FORGOT_PASSWORD_EMAIL_RECOVERY_WILL_BE_SEND_TO_USER:
    "Vols enviar un correu de recuperació de contrasenya a l'usuari $v1?",
  SEND_EMAIL: 'Enviar correu',
  CHANGING_PASSWORD_FOR_USER: 'Canvi de contrasenya de $v1:',
  NO_ACTIONS_AVAILABLE: 'No hi ha accions disponibles',
  USER_ROLE: "Rol d'usuari",
  GENERATE_RANDOM_PASSWORD: 'Generar contrasenya aleatòria',
  TWO_FACTOR_AUTH: '2FA',
  [UserRowActionType.ADD_TWO_FACTOR_AUTH]: 'Activar verificació en dos passos',
  [UserRowActionType.REMOVE_TWO_FACTOR_AUTH]: 'Desactivar verificació en dos passos',
  [`${UserRowActionType.ADD_TWO_FACTOR_AUTH}_DESCRIPTION`]:
    "Esteu segur que voleu activar la verificació en dos passos per a l'usuari $v1?",
  [`${UserRowActionType.REMOVE_TWO_FACTOR_AUTH}_DESCRIPTION`]:
    "Esteu segur que voleu desactivar la verificació en dos passos per a l'usuari $v1?",
  [`${UserRowActionType.ADD_TWO_FACTOR_AUTH}_BUTTON`]: 'Activar',
  [`${UserRowActionType.REMOVE_TWO_FACTOR_AUTH}_BUTTON`]: 'Desactivar',

  SPY_USER: 'Escoltar usuari',
  [`SPY_USER_${UserType.AGENT}`]: 'Escoltar aquest agent',
  [`SPY_USER_${UserType.CHANNEL}`]: 'Escoltar aquest canal',
  [`SPY_USER_${UserType.MERCHANT}`]: 'Escoltar aquest merchant',

  [`DO_YOU_WANT_TO_SPY_THIS_USER_${UserType.AGENT}`]:
    "Vols escoltar aquest agent? Es crearan unes credencials especials per poder empersonar aquest agent. Caldrà utilitzar l'email: spy@nemuru.com i la contrasenya mestra.",
  [`DO_YOU_WANT_TO_SPY_THIS_USER_${UserType.CHANNEL}`]:
    "Vols escoltar aquest canal? Es crearan unes credencials especials per poder empersonar aquest canal. Caldrà utilitzar l'email: spy@nemuru.com i la contrasenya mestra.",
  [`DO_YOU_WANT_TO_SPY_THIS_USER_${UserType.MERCHANT}`]:
    "Vols escoltar aquest merchant? Es crearan unes credencials especials per poder empersonar aquest merchant. Caldrà utilitzar l'email: spy@nemuru.com i la contrasenya mestra.",

  DO_YOU_WANT_TO_SPY_THIS_USER:
    "Vols escoltar a $v1? Per poder empersonar aquest usuari caldrà utilitzar l'email: spy@nemuru.com i la contrasenya mestra.",

  CHANGE_USER: "Canviar credencials d'usuari",
  CHANGE_USER_BTN: "Canviar credencials d'usuari",
  NO_USERS_FOUND: "No s'han trobat usuaris",
  SEARCH_FOR_MERCHANT_CHANNEL_AGENT_NAME: 'Cerca el nom o ID de Comerç, Canal o Agent...',
  CONFIRM_CHANGE_TEXT: "Esteu segur que voleu realitzar el següent canvi d'usuari?",
  SELECTED_USER: 'Usuari seleccionat',
  SELECT_WHERE_TO_MOVE: 'Seleccioneu on voleu moure-ho',
  CONFIRM_CHANGE: "Confirmar canvi d'usuari",
  CONFIRM_CHANGE_BTN: 'Confirmar',
  YOU_WILL_CHANGE_THE_FOLLOWING_USER: 'Esteu a punt de canviar el següent usuari:',

  // Detall del préstec
  LOAN_ID: 'ID de la sol·licitud:',
  LOAN_OVERVIEW: 'Resum',
  PURCHASE_COUNTRY_TITLE: 'País de compra:',
  [PurchaseCountry.ESP]: 'Espanya',
  [PurchaseCountry.FRA]: 'França',
  [PurchaseCountry.MEX]: 'Mèxic',
  [PurchaseCountry.BRA]: 'Brasil',
  [PurchaseCountry.ZAF]: 'Sud-àfrica',
  [PurchaseCountry.PRT]: 'Portugal',
  [PurchaseCountry.DEU]: 'Alemanya',
  APPLICATION: 'Sol·licitud',
  CONSUMER_LOAN: 'Préstec consum',
  PERSONAL_FINANCE: 'Informació financera',
  CONTENTS: 'Contingut',
  ALERTS: 'Alertes',
  USERS: 'Usuaris',
  USERS_OF: 'Usuaris de $v1',
  USER_CREDENTIALS: "Credencials d'accés",
  [`USER_CREDENTIALS_${UserType.AGENT}`]: "Credencials de l'agent",
  [`USER_CREDENTIALS_${UserType.CHANNEL}`]: 'Credencials del canal',
  [`USER_CREDENTIALS_${UserType.MERCHANT}`]: 'Credencials del merchant',
  ACCOUNT: 'Compte',
  FUNNEL: 'Funnel',
  MERCHANT_CHANNEL_AGENT_POS: 'Punt de venda',
  PARTICIPANTS: 'Cotitulars',
  ADD_PARTICIPANT: 'Afegir cotitular',
  BORROWER: 'Titular',
  CO_BORROWER: 'Cotitular',
  GUARANTOR: 'Avalista',
  [OnboardingDetailsRole.BORROWER]: 'Titular',
  [OnboardingDetailsRole.CO_BORROWER]: 'Cotitular',
  [OnboardingDetailsRole.GUARANTOR]: 'Avalista',
  PROGRESS: 'Progrés',
  X_DAYS_LEFT: '$v1 dies restants',
  X_MONTHS: '$v1 mesos',
  MONTHS: 'Mesos',
  SHOW_MORE: 'Mostrar més',
  SHOW_LESS: 'Amagar',
  DESCRIPTION: 'Descripció',
  ADDRESS: 'Adreça',
  INTEREST: 'Interès',
  TOTAL_COST: 'Cost total',
  TOTAL_COST_WITH_UPFRONT_PERCENTAGE: 'Cost total ($v1 comissió apertura)',
  TOTAL_COST_WITH_FINANCED_PERCENTAGE: 'Cost total ($v1 finançat)',
  TOTAL_COST_WITH_FIXED_AMOUNT_VALUE: 'Cost total ($v1 per quota)',
  INTERESTS_TO_PAY: 'Total interessos',
  TIN: 'TIN',
  TAE: 'TAE',
  PRODUCT: 'Producte',
  TERM: 'Termini',
  MONTHLY_QUOTA: 'Quota mensual',
  DOWN_PAYMENT: 'Entrada',
  CASH_PRICE: 'Preu comptat',
  TOTAL_DISCOUNT: 'Descompte',
  DISCOUNT: 'Descompte ($v1)',
  MERCHANT_TOTAL_TO_COLLECT: 'Total a cobrar',
  PRINCIPAL_AMOUNT: 'Import del préstec',
  TOTAL_AMOUNT_TO_PAY: 'Total a pagar',
  CREDIT_LINE_AMOUNT: 'Import de la línia de crèdit',
  CREDIT_LINE: 'Línia de crèdit',
  CREDIT_LINE_WITH_PURCHASE: 'Alta amb compra',
  WITH_ANNUAL_INTERESTS: 'Amb interessos',
  NO_ANNUAL_INTERESTS: 'Sense interessos',
  SETUP_FEE: "Comissió d'apertura",
  SPLIT_PAY: 'Dividir en 3',
  INSTALMENTS: 'Pagar a terminis',
  COPY_LOAN_ID: 'Copiar ID del préstec',
  COPY_CONSUMER_LOAN_ID: 'Copiar ID del préstec consum',
  COPY_AUTO_ID: 'Copiar ID del préstec auto',
  COPY_CREDIT_LINE_ID: 'Copiar ID de la línia de crèdit',
  COPY_ORDER_ID: 'Copiar ID de la comanda',
  COPY_ARTICLE_ID: "Copiar ID de l'article",
  ID_COPIED_SUCCESSFULLY: 'ID copiat amb èxit',
  COPY_SUCCESSFUL: 'Copiat al porta-retalls',
  COPY_LENDER_REQUEST_ID: 'Copiar ID sol·licitud entitat financera',
  FILE_NOT_FOUND: 'Fitxer no trobat',
  RESPONSE: 'Resposta',
  DESIST: 'Desistir',
  DESIST_LOAN: 'Desistir la sol·licitud',
  DESIST_LOAN_BTN: 'Desistir',
  REFUND: 'Processar devolució',
  CANCEL_TEST: 'Cancel·lar com a prova',
  CANCEL_TEST_BTN: 'Cancel·lar com a prova',
  CANCEL_LOAN: 'Cancel·lar sol·licitud',
  CANCEL_LOAN_BTN: 'Cancel·lar sol·licitud',
  DO_YOU_WISH_TO_SET_THIS_LOAN_STATUS_AS_STATUS_CANCELLED: 'Vols marcar aquesta sol·licitud com a cancel·lada?',
  DO_YOU_WISH_TO_SET_THIS_LOAN_STATUS_AS_STATUS_CANCELLED_TEST:
    'Vols marcar aquesta sol·licitud com a prova cancel·lada?',
  DO_YOU_WISH_TO_SET_THIS_LOAN_STATUS_AS_STATUS_DESISTED: 'Vols marcar aquesta sol·licitud com a desistida?',
  PLEASE_SELECT_THE_REASON_WHY_YOU_ARE_DESISTING_THIS_LOAN:
    "Si us plau, selecciona el motiu d'abandonament d'aquesta sol·licitud.",
  DESIST_REASON: "Motiu d'abandonament",
  RESEND_CONTRACT_SIGNATURE_TO_BORROWER: 'Reenviar contracte per signar',
  ARE_YOU_SURE_YOU_WANT_TO_RESEND_CONTRACT_SIGNATURE_TO_BORROWER: 'Vols reenviar el contracte per signar al titular?',
  RESEND_CONTRACT: 'Reenviar contracte',
  ARE_YOU_SURE_YOU_WANT_TO_SEND_CONTRACT_SIGNATURE_TO_BORROWER: 'Vols enviar el contracte per signar al titular?',
  SEND_CONTRACT_SIGNATURE_TO_BORROWER: 'Enviar contracte per signar al titular',
  SEND_CONTRACT: 'Enviar contracte per signar',
  SET_CONTRACT_SIGNED: 'Marcar el contracte com a signat',
  ARE_YOU_SURE_YOU_WANT_TO_SET_LOAN_LENDER_BORROWER_CONTRACT_TO_SIGNED: '¿Vols marcar el contracte com a signat?',
  SET_CONTRACT_SIGNED_BUTTON: 'Marcar com a signat',
  FORMALIZE_APPLICATION: 'Formalitzar sol·licitud',
  DO_YOU_WISH_TO_FORMALIZED_THIS_APPLICATION: 'Vols marcar aquesta sol·licitud com a formalitzada?',
  FORMALIZE_APPLICATION_BTN: 'Formalitzar sol·licitud',
  MARK_LOAN_AS_PAID: 'Marcar sol·licitud com a pagada',
  DO_YOU_WISH_TO_MARK_THIS_LOAN_AS_PAID: 'Vols marcar aquesta sol·licitud com a pagada?',
  MARK_LOAN_AS_PAID_BTN: 'Marcar com a pagada',
  GRACE_PERIOD: 'Carència',
  OPT_OUT_NOTIFICATIONS: 'Desactivar notificacions',
  OPT_OUT_NOTIFICATIONS_DESCRIPTION: 'Vols desactivar les notificacions per a $v1?',
  OPT_OUT_NOTIFICATIONS_BTN: 'Desactivar',

  [LoanDesistReason.BANK_READER]: 'Aggregació bancària',
  [LoanDesistReason.DO_NOT_TRUST_IN_NEMURU]: 'No confio en Nemuru',
  [LoanDesistReason.NO_FINANCING_WANTED]: 'No vull finançament',
  [LoanDesistReason.MERCHANT_SERVICE_IS_EXPENSIVE]: 'Servei del comerciant és car',
  [LoanDesistReason.NEMURU_IS_EXPENSIVE]: 'Nemuru és car',
  [LoanDesistReason.DO_NOT_WANT_THE_SERVICE]: 'No vull el servei del comerciant',
  [LoanDesistReason.NEMURU_APP_IS_NOT_WORKING]: "L'aplicació de Nemuru no funciona",
  [LoanDesistReason.NEMURU_PROCESS_IS_COMPLICATED]: 'El procés de Nemuru és complicat',
  [LoanDesistReason.ALTERNATIVE_FINANCIAL_INSTITUTION]: 'Finançaré amb una altra institució',
  [LoanDesistReason.WILL_DO_IT_LATER]: 'Ho faré més tard',
  [LoanDesistReason.WILL_DO_IT_WITH_ANOTHER_MERCHANT]: 'Ho faré amb un altre comerciant',
  [LoanDesistReason.NOT_CONTACTABLE]: 'No contactable',
  [LoanDesistReason.CANNOT_AFFORD]: "No puc permetre'm el servei",
  [LoanDesistReason.LOAN_CONTRACT_TERMS]: 'Termes del contracte del préstec',
  [LoanDesistReason.MERCHANT_BAD_SERVICE]: 'Servei dolent del comerciant',
  [LoanDesistReason.MERCHANT_CURN_BEHAVIOUR]: 'Comerciant expulsat',
  [LoanDesistReason.WRONG_BUDGET_MANAGEMENT]: 'Mala gestió pressupostària',
  [LoanDesistReason.LENDER_PROCEDURES]: 'Procediments del prestador',
  [LoanDesistReason.OTP_NOT_RECEIVED]: 'No he rebut el codi via SMS',
  [LoanDesistReason.SCA_ERROR]: "La pantalla queda en blanc després d'introduir les dades de la meva targeta",
  [LoanDesistReason.ORDER_CONFIRMATION_NOT_COMPLETED]:
    "He autoritzat la compra amb l'aplicació del meu banc, però no la vaig poder completar",
  [LoanDesistReason.DO_NOT_UNDERSTAND_FUTURE_PAYMENTS]: 'No entenc com es cobraran els pagaments futurs',
  [LoanDesistReason.UNKNOWN]: 'Desconegut',

  // Detall de la vista de la comanda
  ORDER_OVERVIEW: 'Detall de la comanda',
  MERCHANT_REFERENCE_1: 'Referència #1 del comerciant',
  REFERENCE_1: 'Referència #1:',
  CREATED_AT: 'Data de creació:',
  CLIENT_CONTACT_EMAIL: 'Correu electrònic del client:',
  UNITS: 'Unitats',
  UNIT_PRICE_WITH_TAX: 'Preu unitari amb IVA',
  AMOUNT_WITH_TAX: 'Import amb IVA',
  SEE_DETAIL: 'Veure detall',
  REFERENCE: 'Referència',
  ARTICLE: 'Article',
  FLIGHT: 'Vol',
  ONLINE_PRODUCT: 'Producte en línia',
  SERVICE: 'Servei',
  ACCOMMODATION: 'Allotjament',
  TRAVEL: 'Viatge',
  TRAVEL_CATEGORY: 'Categoria de viatge',
  DESTINATION: 'Destinació',
  START_DATE: "Data d'inici",
  END_DATE: 'Data de fi',
  TRAVELLERS: 'Nombre de viatgers',
  CARRIER_CODE: 'Codi de la companyia',
  FLIGHT_CODE: 'Número de vol',
  CABIN_CLASS: 'Classe',
  FARE_BASIS: 'Tarifa',
  ORDER_LINES: 'Línies de la comanda',
  REFERENCES: 'Referències',
  MERCHANT_ORDER_REFERENCE_1: 'Referència 1 del comerciant',
  MERCHANT_ORDER_REFERENCE_2: 'Referència 2 del comerciant',
  SERVICE_END_DATE: 'Data de fi del servei',
  SUMMARY: 'Resum',
  CAPTURES_AND_REFUNDS: 'Captures i devolucions',
  TRANSACTION_HISTORY: 'Historial de transaccions',
  DETAILS: 'Detalls',
  PROCESSING: 'Processant',
  PROCESSING_WITH_DOTS: 'Processant...',
  CONTINUE: 'Continuar',
  CONTINUE_BY: 'Continuar per $v1',
  NO_CART_INFORMATION_AVAILABLE: 'No hi ha informació disponible de la comanda',
  NO_ACTIVITY_INFORMATION_AVAILABLE: "No hi ha informació disponible d'activitat",
  CHECK_IN_DATE: "Data d'entrada",
  CHECK_OUT_DATE: 'Data de sortida',
  NUMBER_OF_GUESTS: "Nombre d'hostes",

  LAST_CARTS: 'Darreres cistelles',
  LAST_THREE_DAYS: 'Darrers 3 dies',
  LAST_TWO_WEEKS: 'Darreres 2 setmanes',
  REMOVE_CART: 'Eliminar comanda',
  REMOVE_CART_DESCRIPTION: 'Estàs segur que vols eliminar aquesta comanda amb els següents ítems?',

  // Pagament per enllaç
  PAY_BY_LINK_DETAIL: 'Detall de la comanda',

  // Mètode de pagament
  PAYMENT_METHOD: 'Mètode de pagament',
  PAYMENT_ATTEMPTS: 'Pagament amb targeta',
  PAYMENT_ATTEMPT_STATUS: 'Esdeveniment',
  PAYMENT_ATTEMPT_FAIL_REASON: 'Motiu de rebuig',
  PAYMENT_ATTEMPT_CREATED_AT: 'Data',
  [PaymentAttemptStatus.PAYMENT_SUCCESSFUL]: 'Pagament acceptat',
  [PaymentAttemptStatus.PAYMENT_FAILED]: 'Pagament rebutjat',
  [PaymentAttemptStatus.SCA_LOADED]: 'Obertura SCA',
  [PaymentAttemptStatus.SCA_CLOSED]: 'Tancament SCA',
  [PaymentAttemptStatus.PAYMENT_CANCELLED]: 'Pagament cancel·lat',
  [`PAYMENT_ATTEMPT_FAIL_REASON_${PaymentAttemptFailReason.AUTHENTICATION}`]:
    "Hi va haver un problema en el pas de l'SCA",
  [`PAYMENT_ATTEMPT_FAIL_REASON_${PaymentAttemptFailReason.SERVICE}`]: 'No es va poder fer el càrrec',
  [`PAYMENT_ATTEMPT_FAIL_REASON_${PaymentAttemptFailReason.GENERIC}`]: 'Va ocórrer algun altre error',
  [`PAYMENT_ATTEMPT_FAIL_REASON_${PaymentAttemptFailReason.SERVICE_PROCESSING}`]:
    "L'autorització o tokenització no va ser possible",
  [`PAYMENT_ATTEMPT_FAIL_REASON_${PaymentAttemptFailReason.USE_A_DIFFERENT_CARD}`]:
    'Hi ha algun problema amb la targeta',
  CASH_IN_CASH_OUT_METHOD_TYPE: 'Tipus de mètode de pagament',
  [CashInCashOutType.BANK_ACCOUNT]: 'Compte corrent',
  [CashInCashOutType.SAVING_BANK_ACCOUNT]: "Compte d'estalvi",
  [CashInCashOutType.FLYWIRE]: 'Flywire',
  HOLDER: 'Tenedor',

  // Pla de pagament
  PAYMENT_PLAN: 'Pla de pagament',
  PAYMENT_PLAN_TABLE: 'Quotes',
  DUE_DATE: 'Data de venciment',
  PAYMENT_DATE: 'Data de pagament',
  OVERDUE: 'Vençut',
  PAYMENT_PLAN_LINE_ID: 'ID quota',
  PAYMENT_PROVIDER: 'Mètode de pagament',
  PAYMENT_PLAN_STATUS: 'Estat del pla de pagament',
  [PaymentProvider.DIRECT_DEBIT]: 'Domiciliació bancària',
  [`PAYMENT_PLAN_LINE_${PaymentPlanLineStatus.PENDING}`]: 'Pendent',
  [`PAYMENT_PLAN_LINE_${PaymentPlanLineStatus.PROCESSING}`]: 'Pagament iniciat',
  [`PAYMENT_PLAN_LINE_${PaymentPlanLineStatus.PAID}`]: 'Pagat',
  [`PAYMENT_PLAN_LINE_${PaymentPlanLineStatus.CANCELLED}`]: 'Cancel·lat',
  [`PAYMENT_PLAN_LINE_${OverduePlanLineStatus.OVERDUE}`]: 'Vençut',
  NO_PAYMENT_PLAN_AVAILABLE: 'No existeix pla de pagament per a aquesta sol·licitud',
  NO_PAYMENT_ATTEMPTS_REGISTERED: 'No hi ha intents de pagament registrats',
  ROWS_PER_PAGE: 'Files per pàgina',
  SENT_DATE: 'Data sol·licitud pagament',
  COPY_PAYMENT_LINE_ID: 'Copiar ID de la quota',
  SEND_PAYMENT_NOTIFICATION: 'Enviar correu electrònic de sol·licitud de pagament',
  PAYMENT_NOTIFICATION: 'Enviar correu electrònic de sol·licitud de pagament',
  PAYMENT_NOTIFICATION_TEXT: "Vols enviar un correu electrònic per sol·licitar el pagament d'aquesta quota al client?",
  PAYMENT_NOTIFICATION_BTN: 'Enviar correu electrònic',
  QUOTA_NUMBER: 'Número de quota',
  SEE_PAYMENT_ATTEMPTS: 'Veure intents de pagament',
  UPDATE_PAYMENT_PLAN_LINE_DUE_DATE: 'Canviar data de venciment',
  UPDATE_PAYMENT_PLAN_LINE_DUE_DATE_TEXT: 'Selecciona la nova data de venciment de la quota',
  UPDATE_PAYMENT_PLAN_LINE_DUE_DATE_BTN: 'Canviar data',
  UPDATE_PAYMENT_PLAN_LINE_PAYMENT_DATE: 'Canviar data de pagament',
  UPDATE_PAYMENT_PLAN_LINE_PAYMENT_DATE_TEXT: 'Selecciona la nova data de pagament de la quota',
  UPDATE_PAYMENT_PLAN_LINE_PAYMENT_DATE_BTN: 'Canviar data',
  UPDATE_PAYMENT_PLAN_LINE_QUOTA_AMOUNT: 'Canviar import',
  UPDATE_PAYMENT_PLAN_LINE_QUOTA_AMOUNT_TEXT: 'Introdueix el nou import de la quota',
  UPDATE_PAYMENT_PLAN_LINE_QUOTA_AMOUNT_BTN: 'Canviar import',
  UPDATE_PAYMENT_PLAN_LINE_STATUS: 'Canviar estat',
  UPDATE_PAYMENT_PLAN_LINE_STATUS_TEXT: 'Selecciona el nou estat de la quota',
  UPDATE_PAYMENT_PLAN_LINE_STATUS_BTN: 'Canviar estat',
  PAYMENT_LINE_STATUS: 'Estat de la quota',

  // Activitat
  TOTAL_ORDER: 'Total de la comanda',
  PENDING_CAPTURE: 'Pendent de capturar️',
  PENDING_TO_CAPTURE: 'Pendent de capturar️',
  TOTAL_CAPTURED: 'Total capturat',
  TOTAL_REFUNDED: 'Total reemborsat',
  BILLED: 'Facturat',
  TOTAL_FEES: 'Total comissions',
  TOTAL_PAID: 'Total pagat',
  PENDING: 'Pendent',
  PENDING_INFORMATION: 'Pendent...',
  AMOUNT: 'Import',
  TOTAL: 'Total️',
  CAPTURED: 'Capturat',
  CAPTURE: 'Captura',
  ORDER_APPROVED: 'Aprovat',
  APPROVED: 'Preaprovat',
  REFUNDED: 'Reemborsat',
  PRODUCTS: 'Productes️',
  SALE: 'Venda',
  ORDER_ACTIVITY: 'Activitat',
  REFUNDED_AMOUNT: 'Import reemborsat',
  CAPTURE_NUMBER: 'Captura nº $v1',
  REFUND_NUMBER: 'Devolució nº $v1',
  PAYOUT_NUMBER: 'Pagament nº $v1',
  ORDER_CREATED: 'Comanda creada',
  REFERENCE_1_TOOLTIP_TEXT: 'Referència principal de la comanda del comerciant',
  REFERENCE_2_TOOLTIP_TEXT: 'Referència opcional de la comanda del comerciant',
  PASSENGERS: 'Passatgers ($v1)',
  SEGMENTS: 'Segments ($v1)',
  IN_REFERENCE_TO: 'En referència a:',
  CANCEL_PAYMENT_PLAN: 'Cancel·lar pla de pagament',
  CANCEL_PAYMENT_PLAN_TEXT: 'Estàs segur que vols cancel·lar el pla de pagament?',

  //PAYOUTS

  PAYMENTS: 'Pagaments',
  PAYOUT: 'Pagament',
  PAYOUTS: 'Pagaments',
  PAYER: 'Pagador',
  issue_date: "Data d'emissió",
  VAT_ON_FEES: 'IVA sobre comissions ($v1)',
  VAT_ON_ADJUSTMENTS: 'IVA sobre ajustos ($v1)',
  PAYOUTS_LIST: 'Llista de pagaments',
  MERCHANT_ID: 'ID del comerciant',
  ADJUSTMENTS_AMOUNT: "Import d'ajustos",
  DISBURSED_AMOUNT: 'Import pagat',
  PAYOUT_STATUS: 'Estat del pagament',
  [PayoutStatus.DISBURSED]: 'Pagat',
  [PayoutStatus.IN_REVIEW]: 'En revisió',
  [PayoutStatus.PUBLISHING]: 'Publicant',
  [PayoutStatus.PUBLISHED]: 'Publicat',
  PAYMENT: 'Pagament',
  PAYOUT_DETAILS_OVERVIEW: 'Resum del pagament',
  TRANSACTIONS: 'Transaccions',
  TRANSACTIONS_VIEW: 'Vista de transaccions',
  SALES: 'Vendes',
  REFUNDS: 'Devolucions',
  FIXED_FEES: 'Comissions fixes',
  VARIABLE_FEES: 'Comissions variables',
  ADJUSTMENTS: 'Ajustos',
  TOTAL_ADJUSTMENTS: "Total d'ajustos",
  LENDER_NAME: "Nom de l'entitat financera",
  PAYOUT_REFERENCE: 'Referència del pagament',
  PAYOUT_DATE: 'Data del pagament',
  MERCHANT_NAME: 'Nom del merchant',
  VAT: 'IVA',
  COPY_PAYMENT_ID: 'Copiar ID de pagament',
  PAYOUT_DETAILS_NOT_FOUND: "No s'han trobat detalls del pagament",

  //REPORTS

  REPORTS: 'Conciliacions',
  REPORTS_LIST: 'Llistat de conciliacions',
  REPORT: 'Conciliació',
  REPORT_DATE: 'Data conciliació',
  REPORT_DETAILS_OVERVIEW: 'Resum',
  ENTITY: 'Entitat',
  BATCH_NUMBER: 'Núm. batch',
  DOWNLOAD: 'Descarregar',
  TOTAL_DISBURSED_AMOUNT: 'Import total pagat',

  // TRANSACTIONS
  TRANSACTIONS_LIST: 'Llista de transaccions',
  TRANSACTION_TYPE: 'Tipus de transacció',
  VAT_RATE: "Tipus d'IVA",
  VAT_AMOUNT: "Import d'IVA",
  COPY_TRANSACTION_ID: 'Copiar ID de transacció',
  ORDER_ID: 'ID de la comanda',
  [TransactionType.REFUND]: 'Devolució',
  [TransactionType.DEBT_BALANCE]: 'Saldo deute',
  [TransactionType.FIXED_FEE]: 'Comissió fixa',
  [TransactionType.VARIABLE_FEE]: 'Comissió variable',
  [TransactionType.COST_OF_CREDIT]: 'Cost del crèdit',
  [TransactionType.FEE_CORRECTION]: 'Correcció de comissió',

  // Sol·licituds de préstecs de prestadors
  LENDER_APPLICATIONS: "Respostes d'entitats financeres",
  LENDER_X_APPLICATION: 'Resposta de $v1',
  LENDER_STATE: "Estat de l'entitat financera",
  LENDER_CONTRACT_SENT: 'Contracte enviat',
  LENDER_CONTRACT_SIGNED: 'Contracte signat',
  SENT_AT: "Data d'enviament de contracte",
  SIGNED_AT: 'Data de signatura de contracte',
  LENDER_REQUEST_ID: 'ID sol·licitud',
  LENDER_REQUEST_ID_2: 'ID sol·licitud entitat',
  LAST_UPDATED_AT: 'Data última actualització',
  PROCESSING_SUCCESSFUL: 'Processat correctament',
  PROCESSING_DID_NOT_ALTER_APPLICATION: 'El resultat no va alterar aquesta sol·licitud',
  PROCESSING_DID_UPDATE_THE_APPLICATION_SUCCESSFULLY: "La sol·licitud s'ha actualitzat.",
  PROCESS: 'Processar',
  SELECTED_LENDER: 'Entitat seleccionada',
  NO_RESPONSE_FROM_LENDER: "Sense resposta de l'entitat.",
  LENDER_IS_PROCESSING_THE_APPLICATION: "L'entitat està processant la sol·licitud",
  LENDER_IS_PROCESSING_THE_APPLICATION_TRY_AGAIN_LATER:
    "L'entitat està processant la sol·licitud en aquests moments. Actualitza aquesta pàgina en uns instants per veure l'estat actualitzat.",
  SELECTED_LENDER_APPLICATION: 'Seleccionada',
  [`LOAN_APPLICATION_STATUS_${LoanApplicationStatus.NOT_PROCESSED}`]: 'No processada',
  [`LOAN_APPLICATION_STATUS_${LoanApplicationStatus.PROCESSED}`]: 'Processada',
  [`LOAN_APPLICATION_STATUS_${LoanApplicationStatus.SELECTED}`]: 'Seleccionada',
  PENDING_TO_COMPLETE_PAYMENT: 'Pendent completar',
  PENDING_TO_SELECT_PAYMENT_METHOD: 'Pendent mètode de pagament',
  NO_RESPONSE: 'Sense resposta',
  ANSWERED_YES: 'Acceptada',
  ANSWERED_NO: 'Denegada',
  IN_STUDY: 'En estudi',
  SELECT_A_LOAN_APPLICATION: 'Selecciona una entitat',
  SELECT_A_LOAN_APPLICATION_TEXT:
    "Fes click en el botó per seleccionar l'entitat financera i completar el procés de sol·licitud.",
  LENDER_X_ANSWERED_X_TO_APPLICATION: 'L\'entitat financera $v1 ha respost "$v2" a la sol·licitud',
  PROCESS_TOOLTIP: "Processar manualment la sol·licitud a l'entitat financera",
  loan_application_error: "Error de l'entitat financera",
  UN_SIGN: 'Anul·lar',
  MODIFY: 'Modificar',
  UN_SIGN_LOAN_LENDER_BORROWER_CONTRACT: 'Anul·lar signatura de contracte',
  UN_SIGN_LOAN_LENDER_BORROWER_CONTRACT_DESCRIPTION:
    "Vols anul·lar la signatura del contracte existent? La sol·licitud tornarà a l'estat anterior i les dades d'enviament i signatura del contracte seran eliminades.",
  SELECTED_LOAN_APPLICATION: 'Sol·licitud seleccionada',
  ERROR_FETCHING_ERROR_RESPONSE:
    "Error en obtenir la resposta de l'entitat financera. Si us plau, intenta-ho més tard.",
  ANALYSING_ERROR_RESPONSE: 'Analitzant error en $v1...',

  OPEN_PROCESS_RESPONSE_FOLDER: 'Obre fitxers de resposta',
  SET_LENDER_REQUEST_ID: 'Modificar ID sol·licitud',
  SET_LENDER_REQUEST_ID_DESCRIPTION:
    "Vols modificar l'ID de la sol·licitud a l'entitat financera? En modificar l'ID, es tornaran a processar les dades de la sol·licitud per aquest nou ID",
  CHANGE_LENDER_APPROVAL_STATUS: "Modificar estat d'aprovació",
  CHANGE_LENDER_APPROVAL_STATUS_DESCRIPTION: "Selecciona el nou estat d'aprovació de l'entitat financera",
  LENDER_APPROVAL_STATUS: "Estat d'aprovació de l'entitat financera",
  [LenderApprovalStatus.MAYBE]: 'En estudi',
  UPDATE_LOAN_APPLICATION: 'Modificar',
  UPDATE_LOAN_APPLICATION_IN_LENDER: 'Modificar cotitular en entitat',
  UPDATE_LOAN_APPLICATION_IN_LENDER_DESCRIPTION:
    "Vols modificar les dades del cotitular(s) de la sol·licitud a l'entitat financera?",

  [LenderName.ABANCA]: 'Abanca',
  [LenderName.APLAZAME]: 'Aplazame',
  [LenderName.ATRATO]: 'Atrato',
  [LenderName.BBVA]: 'BBVA Consumer Finance',
  [LenderName.BS]: 'Sabadell Consumer Finance',
  [LenderName.CAIXABANK]: 'CaixaBank P&C',
  [LenderName.CETELEM]: 'Cetelem',
  [LenderName.CETELEM_PF_CONNECT]: 'Cetelem PF Connect',
  [LenderName.COFIDIS]: 'Cofidis',
  [LenderName.FINONLINE]: 'Finonline',
  [LenderName.FLOA]: 'FLOA',
  [LenderName.KOIN]: 'Koin',
  [LenderName.KUESKI]: 'Kueski',
  [LenderName.NEMURU]: 'Nemuru finance',
  [LenderName.PEPPER]: 'Pepper',
  [LenderName.SANTANDER_CONSUMER]: 'Santander Consumer Finance',
  [LenderName.SEQURA]: 'SeQura',
  [LenderName.SEQURA_QUIX]: 'Quix',
  [LenderName.SOYOU]: 'Sofinco',

  RISK_ANALYSIS: 'Anàlisi de risc',
  ASSESSMENT_RESULT: 'Recomanació',
  UNPAID_OPERATIONS: 'Operacions impagades',
  NO_RISK_SCORING_AVAILABLE: 'No existeix un anàlisi de risc disponible',
  WHAT_IS_RECOMMENDATION: (
    <>
      <p>
        Resultat de l'avaluació de risc del client a partir de les regles establertes. Pot prendre els següents valors:
      </p>
      <li>Verd: Anàlisi favorable, client amb un bon perfil de risc.</li>
      <li>Groc: A revisar, client amb un perfil de risc dolent però sense impagaments.</li>
      <li>Vermell: Anàlisi desfavorable, client amb un perfil de risc dolent i amb impagaments.</li>
    </>
  ),
  WHAT_IS_SCORING: (
    <>
      <p>Indica el nivell de risc d'impagament del client. Pot prendre els següents valors:</p>
      <ul>
        <li>Molt Alt Risc (1)</li>
        <li>Alt Risc (2)</li>
        <li>Mitjà Risc (3)</li>
        <li>Mitjà/Baix Risc (4)</li>
        <li>Baix Risc (5)</li>
        <li>Molt Baix Risc (6)</li>
      </ul>
    </>
  ),

  RISK_ASSESSMENT_FAILED_DUE_TO_THE_FOLLOWING_REASONS: ' no ha estat superat pels motius següents:',
  RESULTS: 'Resultats',
  NO_RISK_INFORMATION: "No s'ha trobat informació de riscos",
  NO_REASONS_GIVEN: "No s'han trobat motius",
  RISK_SCORE: 'Anàlisi de riscos',
  PASSED: 'Aprovat',
  RISK_SCORE_FAILED: 'Rebutjat',
  AML_RISK: 'AML',
  BANK_READER_RISK: 'Lector de banc',
  CHECK_FAILED_REASONS: 'Veure motius de rebuig',
  ASSESSMENT_FAILURE_REASONS: "Motius de rebuig de l'anàlisi de riscos",
  aml_reject_FoundInLists: 'El prestatari figura a les llistes AML',
  br_reject_lifestyle_indebtedness: 'Endeutament per estil de vida',
  br_reject_lowPositiveBalanceLastMonth: 'Baixa puntuació pel saldo positiu del últim mes.',
  br_reject_lowPositiveBalanceAntiquity: 'Baixa puntuació per antiguitat de saldo positiu.',
  br_reject_lastMontsIncomingStatementLessThan3: 'Menys de 3 ingressos.',

  // STATUS back
  status_initial: 'Iniciat',
  status_analysing: 'Sol·licitat',
  status_lender_has_been_selected: 'Preaprovat',
  status_contract_signed: 'Signat per formalitzar',
  status_docs_approved: 'Confirmat',
  status_active_trial: 'Pagat',
  status_active: 'Pagat',
  status_denied: 'Denegat',
  status_desisted: 'Desistit',
  status_ended: 'Finalitzat',
  status_expired: 'Caducat',
  status_unpaid: 'Impagat',
  status_cancelled: 'Cancel·lat',
  status_cancelled_test: 'Test cancel·lat',

  //FUNNEL
  TOTAL_AMOUNT: 'Import total',
  TOTAL_NUMBER: 'Nombre total',
  SEARCH_BY_LENDER: 'Entitat financera',
  MINIMUM_AMOUNT: 'Import mín.',
  MAXIMUM_AMOUNT: 'Import màx.',
  ALL_PRODUCTS: 'Tots els productes',
  MORE_THAN_24_H: 'Més de 24h',
  MORE_THAN_3_DAYS: 'Més de 3 dies',
  MORE_THAN_A_WEEK: "Més d'1 setmana",
  MORE_THAN_A_MONTH: "Més d'1 mes",
  LOAN_APPLICATION_ERRORS: "Errors en respostes d'entitats financeres",
  DOCUMENTATION_INCIDENCES: 'Incidències documentals',
  FILTER_LOANS_WITH: 'Filtrar sol·licituds amb:',
  NO_FUNNEL_DATA: 'Encara no hi ha dades per mostrar',
  WITH_INCIDENCE: 'Amb incidència',
  WITH_ERROR: 'Amb error',
  SCHEDULED_DELIVERY_DATE: 'Data de lliurament',
  SCROLL_TO_SELECTION_RESULTS_SHORT: 'Veure resultats',
  SCROLL_TO_SELECTION_RESULTS: 'Fer scroll fins als resultats de la sel·lecció',

  // Table filters
  STATE: 'Estat',
  OTHER_FILTERS: 'Altres filtres',
  RESET_FILTERS: 'Restablir filtres',
  WITH_DOCUMENTARY_INCIDENCE: 'Amb incidència documental',
  VIN_INFORMED: 'Bastidor informat',
  DELIVERY_DATE_INFORMED: 'Data de lliurament informada',

  // STEPS
  NO_RESULTS_TO_SHOW: 'Sense resultats',
  CUSTOM_GROUP: 'Grup personalitzat',

  // STEPS
  UNOPENED: 'Sense obrir',
  OPENED: 'SMS obert',
  // PERSONAL_INFORMATION: 'Informació personal',
  FINANCIAL_INFORMATION: 'Informació financera',
  PROFESSIONAL_INFORMATION: 'Informació professional',
  RISK_INFORMATION: 'Informació de risc',
  CONTRACT_NOT_SENT: 'Contracte per enviar',
  CONTRACT_SENT: 'Contracte enviat',
  VALIDATING_DOCUMENTATION: 'Signat per formalitzar',

  // STATUS front
  status_opened: 'SMS obert',
  status_kyc_set: 'Informació personal',
  status_income_set: 'Informació financera',
  status_professional_details_set: 'Informació professional',
  status_risk_set: 'Informació de risc',
  status_contract_sent: 'Contracte enviat',

  //STATUS Order
  started: 'Iniciat',
  initial: 'Iniciat',
  approved: 'Preaprovat',
  confirmed: 'Confirmat',
  captured: 'Capturat',
  on_hold: 'Pendent',
  denied: 'Denegat',
  cancelled: 'Cancel·lat',
  cancelled_test: 'Cancel·lat',
  desisted: 'Desistit',
  expired: 'Caducat',
  paid: 'Pagat',

  LOAN_STATUS_EXTERNAL: 'Estat',
  DEFAULT_STATUSES: 'Estats per defecte',

  //ORDER
  ORDER: 'Comanda',
  ORDER_STATUS_INITIAL: 'Informació personal',
  ORDER_STATUS_ANALYSING: 'Pendent OTP',
  ORDER_STATUS_LENDER_HAS_BEEN_SELECTED: 'Pendent pagament targeta',
  TOTAL_ORDER_AMOUNT: 'Total de la comanda',
  TOTAL_CAPTURED_AMOUNT: 'Total capturat',
  TOTAL_REFUNDED_AMOUNT: 'Total reemborsat',
  FROM_X_CAPTURES_AND_X_REFUNDS: 'De $v1 captura(s) i $v2 reemborsament(s)',
  CATEGORY: 'Categoria',
  FROM: 'De',
  NO_ASSOCIATED_ITEMS: 'Sense articles associats',
  OTP: 'Codi via SMS',
  MOBILE_VERIFICATION: 'Verificació mòbil',
  OTP_PENDING: 'Pendent OTP',
  DOWNPAYMENT: 'Primer pagament',
  requested: 'Sol·licitat',

  PERSONAL_INFO_PENDING: 'Pendent omplir info personal',
  RESPONSE_PENDING: 'Pendent resposta entitat financera',
  CONFIRMATION_PENDING: 'Pendent confirmació',
  CAPTURE_PENDING: 'Pendent captura',
  PAYMENT_PENDING: 'Pendent pagament',
  APPLICATION_COMPLETED: 'Sol·licitud completada',

  //ASSET DETAILS
  BRAND: 'Marca',
  MODEL: 'Model',
  version: 'Versió',
  LICENSE_PLATE_NUMBER: 'Matrícula',
  IDENTIFICATION_NUMBER: 'Número bastidor',
  IDENTIFICATION_NUMBER_MUST_BE_17_CHARACTERS: 'El número de bastidor ha de tenir 17 caràcters',
  INVALID_SPANISH_LICENSE_PLATE: 'La matrícula introduïda no és vàlida.',
  REGISTRATION_DATE: 'Data matriculació',
  VEHICLE_TYPE: 'Tipus de vehicle',
  ODOMETER: 'Comptakilòmetres',
  MAX_POWER: 'Potència màxima',
  ENGINE: 'Cilindrada',
  BODY_TYPE: 'Carrosseria',
  KM: 'Km',
  CM_3: 'cm3',
  CV: 'Cv',
  FUEL_TYPE: 'Tipus de combustible',
  GEAR_TYPE: 'Tipus de canvi',
  IS_NEW_VEHICLE: 'Vehicle nou',
  IMPORTED: 'Vehicle importat',
  manual: 'Manual',
  automatic: 'Automàtic',
  gasoline: 'Gasolina',
  diesel: 'Dièsel',
  electric: 'Elèctric',
  hybrid: 'Híbrid',
  compressed_natural_gas: 'GNC',
  ethanol: 'Etanol',
  others: 'Altres',
  electric_hybrid: 'Híbrid elèctric',
  type_of_vehicle: 'Tipus de vehicle',
  calculate_loan: 'Calcular préstec',
  hatchback: 'Compacte',
  sedan: 'Sedà 4 portes',
  suv: 'SUV',
  coupe: 'Coupé',
  convertible: 'Descapotable',
  wagon: 'WAGON',
  station_wagon: 'Cotxe familiar',
  minivan: 'Minivan',
  four_by_four: '4X4',
  cabrio: 'Cabrio',
  pick_up: 'Pick-up',
  camper_van: 'Furgoneta camperitzada',
  car: 'Automòbil',
  off_road: '4x4',
  industrial: 'Industrial',

  ASSET_DETAILS: 'Informació de producte',
  AUTO_ASSET_DETAILS: 'Informació del vehicle',
  AUTO_DETAILS: 'Detalls del vehicle',
  VEHICLE_AMOUNT: 'Import del vehicle',
  DOWN_PAYMENT_DOCUMENT: 'Justificant primer pagament',
  TOTAL_COURSE_AMOUNT: 'Import del curs',
  SCHOLARSHIP: 'Beques i ajudes',
  COURSE_DOWNPAYMENT: 'Import de la matrícula',
  COURSE_START_DATE: "Data d'inici del curs",
  COURSE_END_DATE: 'Data de fi del curs',
  WORKSITE_ADDRESS: 'Adreça de la reforma',
  [AssetType.EDUCATION]: 'Educació',
  [AssetType.HOME_IMPROVEMENT]: 'Llar',
  [AssetType.UTILITIES_SUPPLY]: 'Punt de subministrament',
  [AssetType.HEALTH]: 'Salut',
  [AssetType.TRAVEL]: 'Viatges',
  BORROWER_INVITATION: 'Dades de contacte',
  EDIT_BORROWER_INVITATION: 'Editar dades de contacte',
  NO_INFORMATION_PROVIDED: 'Sense informació',
  PENDING_INFORMATION_FROM_BORROWER_ONBOARDING: "Encara no s'ha proporcionat informació del client",
  PENDING_DOCUMENTATION_FROM_BORROWER_ONBOARDING: "Encara no s'ha proporcionat documentació del client",
  PENDING_FOR_FINANCIAL_INFORMATION_FROM_BORROWER_ONBOARDING:
    "Encara no s'ha proporcionat informació financera del client",
  PENDING_FOR_ADDRESS_INFORMATION: "Encara no s'ha proporcionat informació de l'adreça",
  DOCUMENT_NUMBER: 'Número de document',
  EXPIRES_ON: "Data d'expiració",
  RELATION: 'Relació',
  [Relation.SPOUSE]: 'Cònjuge',
  [Relation.SIBLING]: 'Germà/germana',
  [Relation.PARENT]: 'Pare/mare',
  [Relation.SON]: 'Fill/filla',
  [Relation.REST_OF_FAMILY]: 'Altres familiars',
  [Relation.OTHER]: 'Altres',
  PHONE_VERIFICATION: 'Verificació del telèfon mòbil',
  PHONE_VERIFICATION_SHORT: 'Verificació mòbil',
  OTP_STATUS: 'Estat de la verificació',
  RECEIVED_CODE: 'Codi introduït',
  RECEIVED_CODE_DATE: 'Data',
  [OtpStatus.ACCEPTED]: 'Acceptat',
  [OtpStatus.NOT_PROCESSED]: 'No processat',
  [OtpStatus.REJECTED]: 'Rebutjat',
  SENT_CODES: 'Codis enviats',
  SENT_CODE_CODE: 'Codi',
  SENT_CODE_STATUS: 'Estat SMS',
  SENT_CODE_STATUS_SHORT: 'Estat',
  SENT_CODE_PROVIDER_NAME: 'Proveïdor SMS',
  SENT_CODE_DATE: 'Data',

  FIRST_INSTALMENT_PAID: 'Primer pagament realitzat',

  [SentCodeStatus.PENDING]: 'Pendent',
  [SentCodeStatus.DELIVERED]: 'Lliurat',
  [SentCodeStatus.FAILED]: 'Fallit',
  NO_IMAGE: 'Sense imatge',
  LOADING_IMAGE: 'Obtenint imatge...',
  NO_DOCUMENT: 'Sense document',
  LOADING_DOCUMENT: 'Obtenint document  ...',
  ONBOARDING_DETAILS: 'Informació del client',
  FULFILLED_BY_MERCHANT_POS_DESCRIPTION:
    'La informació personal del client ha sigut proporcionada pel comerç autoritzat',
  DOCUMENT_ID: "Document d'identitat",
  FIRST_NAME: 'Nom',
  LAST_NAME: 'Cognoms',
  FULL_NAME: 'Nom complet',
  DOCUMENT_TYPE: 'Tipus de document',
  DOCUMENT_ID_NUMBER: 'Número de document',
  DOCUMENT_ID_NUMBER_SHORT: 'Document',
  GENDER: 'Gènere',
  [Gender.M]: 'Masculí',
  [Gender.F]: 'Femení',
  NATIONALITY: 'Nacionalitat',
  BIRTH_DATE: 'Data de naixement',
  EXPIRATION_DATE: 'Data de caducitat',
  NIE_DATA: 'Dades del NIE',
  NATIONALITY_PERIOD: 'Antiguitat de nacionalitat',
  RESIDENCE_CARD_TYPE: 'Tipus de targeta de residència',
  RESIDENCE_CARD_EXPIRATION_DATE: 'Data de caducitat de la targeta de residència',
  SOCIAL_SECURITY_REGISTRATION_DATE: "Data d'alta a la seguretat social",
  NUMBER_OF_WORK: 'Nombre de feines des de la nacionalització',
  NATIONALITY_PERIOD_unknown: 'Desconeguda',
  NATIONALITY_PERIOD_less_than_3_months: 'Menys de 3 mesos',
  NATIONALITY_PERIOD_between_3_and_11_months: 'De 3 a 11 mesos',
  NATIONALITY_PERIOD_between_12_and_35_months: 'De 12 a 35 mesos',
  NATIONALITY_PERIOD_between_36_and_59_months: 'De 36 a 59 mesos',
  NATIONALITY_PERIOD_sixty_or_more_months: '60 mesos o més',
  CARD_ID_initial: 'Inicial',
  CARD_ID_first_renewal: 'Primera renovació',
  CARD_ID_second_renewal: 'Segona renovació',
  CARD_ID_permanent: 'Permanent',
  DOCUMENT_ADDRESS: 'Adreça del document',
  STREET_NAME: 'Nom carrer',
  STREET_NUMBER: 'Número carrer',
  CITY: 'Ciutat',
  COUNTRY: 'País',
  FLOOR_AND_DOOR: 'Planta i porta',
  DOOR_NUMBER: 'Porta',
  FLOOR_NUMBER: 'Planta',
  BIRTH_PLACE: 'Lloc de naixement',
  INVALID_DATE: 'Data no vàlida',
  DATE_SHOULD_NOT_BE_BEFORE_MINIMAL_DATE: 'Data anterior a la data mínima permesa',
  DATE_SHOULD_NOT_BE_AFTER_MAXIMAL_DATE: 'Data posterior a la data màxima permesa',
  ['Date should not be before minimal date']: 'Data anterior a la data mínima permesa',
  ['Date should not be after maximal date']: 'Data posterior a la data màxima permesa',
  INVALID_DOCUMENT_NUMBER: 'Número de document no vàlid',
  ID_FRONT: 'Part frontal del document',
  ID_BACK: 'Part posterior del document',
  NIF: 'DNI',
  NIE: 'NIE',
  NIE_EU: 'NIE (Dins la UE)',
  NIE_NON_EU: 'NIE (Fora de la UE)',
  nif: 'DNI',
  nie: 'NIE',
  nie_eu: 'NIE (Dins la UE)',
  nie_non_eu: 'NIE (Fora de la UE)',
  passport: 'Passaport',
  CART: 'Cistella',
  DIAL_CODE: 'Prefix',
  PHONE_NUMBER: 'Telèfon',
  DOCUMENT_EXPIRATION_DATE: 'Data de caducitat del document',
  PERSONAL_INFORMATION: 'Informació personal',
  SHIPPING_AND_BILLING: 'Enviament i facturació',
  SHIPPING_ADDRESS: "Adreça d'enviament",
  BILLING_ADDRESS: 'Adreça de facturació',
  SHIPPING_METHOD: "Mètode d'enviament",
  SHIPPING_NAME: "Nom del mètode d'enviament",
  STREET_ADDRESS: 'Adreça',
  STREET_ADDRESS_2: 'Adreça addicional',
  COMPANY_VAT: "CIF de l'empresa",
  COMPANY_VAT_DESCRIPTION:
    "Requerit per l'entitat Sabadell Consumer, una de les entitats seleccionades per a l'operació",
  SELECT_KYC: 'Selecciona VideoID',
  SHOW_KYC_DATA: 'Mostra les dades VideoID',
  SIMILARITY_LEVEL: 'Nivell de semblança',
  [SimilarityLevel.HIGH]: 'Alt',
  [SimilarityLevel.MEDIUM]: 'Mitjà',
  [SimilarityLevel.LOW]: 'Baix',
  [SimilarityLevel.VERY_LOW]: 'Molt baix',
  AUTOMATIC_SECURITY_CHECKS: 'Comprovacions de seguretat automàtiques',
  MANUAL_CHECK: 'Comprovació manual',
  VIDEO_ID: 'VideoID',
  KYC_DATA: 'Dades VideoID',
  PENDING_FOR_KYC_VERIFICATION: 'Pendent de verificació manual',
  VERIFIER: 'Verificador/ra',
  VERIFICATION_DATE: 'Data de verificació',
  DURATION: 'Durada',
  SEND_REPEAT_KYC_EMAIL: 'Envia una nova sol·licitud VideoID',
  SEND_REPEAT_KYC_EMAIL_TEXT: 'Vols enviar una nova sol·licitud VideoID a $v1 ($v2)?',
  SEND_REPEAT_KYC_EMAIL_BTN: 'Envia',
  [SecurityCheckName.DATA_INTEGRITY]: 'Integritat de les dades',
  [SecurityCheckName.LIVENESS]: 'Prova de vida',
  [SecurityCheckName.NON_EXPIRED]: 'Document en vigor',
  [SecurityCheckName.NOT_BW_COPY]: 'Document en color',
  [SecurityCheckName.NOT_UNDERAGE]: "Major d'edat",
  [SecurityCheckName.SIDES_MATCH]: 'Compatibilitat entre anvers i revers',
  [SecurityCheckName.UNTAMPERED_DOCUMENT]: 'Document sense alteracions',
  [SecurityCheckName.UNTAMPERED_VIDEO]: 'Vídeo sense alteracions',
  [SecurityCheckName.REFLECTIVE_SURFACE]: 'Document sense reflexos',
  [SecurityCheckName.NOT_FACE_SPOOFING]: 'Rostre no falsificat',

  //DIGITAL FOOTPRINT

  BROWSER: 'Navegador',
  DEVICE: 'Dispositiu',
  OPERATING_SYSTEM: 'SO',
  LOCALE: 'Idioma',

  SAVE: 'Desar',
  // DOCUMENTATION
  OWNER_NUM_X: 'Titular #$v1',
  LOAN_DOCUMENTATION: 'Documentació de la sol·licitud',
  FILE_DOCUMENT_STATUS: 'Estats',
  DOCUMENTATION: 'Documentació',
  DOCUMENTATION_MANAGER: 'Gestor documental',
  DOCUMENTS: 'Documents',
  UPLOADED: 'Carregat',
  INCIDENCE: 'Incidència',
  SENT: 'Enviat',
  UPLOAD_PENDING: 'Pendent de carregar',
  DOCUMENTATION_SENT_ON: 'Enviat el $v1',
  ALL_DOCUMENTS_UPLOADED: 'Tota la documentació carregada',
  INCIDENCE_IN_DOCUMENTS: 'Incidència en la documentació',
  ALL_DOCUMENTS_SENT: 'Tota la documentació enviada',
  NO_REQUIRED_DOCUMENTS: 'Sense documents requerits',
  documentation_incidence: 'Incidència documental',
  SEND_ALL_DOCUMENTS: 'Enviar tots els documents',
  SEND_ALL_DOCUMENTS_DESCRIPTION: "Vols enviar tots els documents carregats a l'entitat financera seleccionada?",
  SYNCHRONIZE_DOCUMENTS: 'Sincronitzar documents',
  SYNCHRONIZE_DOCUMENTS_DESCRIPTION: "Vols sincronitzar la documentació amb l'entitat financera seleccionada?",
  SYNCHRONIZE: 'Sincronitzar',
  SET_ARE_DOCUMENTS_CONFIRMED: 'Confirmar tots els documents',
  SET_ARE_DOCUMENTS_CONFIRMED_DESCRIPTION: 'Vols confirmar tota la documentació del titular?',
  SEND_INCIDENCE_NOTIFICATION: "Enviar notificació d'incidència",
  SEND_INCIDENCE_NOTIFICATION_DESCRIPTION:
    'Vols enviar un correu de notificació de la incidència documental a la part implicada?',
  ADD_REQUIRED_FILE_TYPE: 'Sol·licitar nou document',
  ADD_REQUIRED_FILE_TYPE_DESCRIPTION: 'Selecciona el nou document que vols sol·licitar',
  REQUIRED_DOCUMENT_TYPE: 'Tipus de document',
  UPLOADED_DOCUMENTS: 'Documents pujats',
  REQUEST: 'Sol·licitar',
  CONFIRM: 'Confirmar',
  LOADING_FILE_TYPES: 'Carregant tipus de documents...',
  REMOVE_REQUIRED_FILE_TYPE_FROM_DOCUMENTATION_REQUIRED: 'Eliminar document sol·licitat',
  REMOVE_REQUIRED_FILE_TYPE_FROM_DOCUMENTATION_REQUIRED_DESCRIPTION:
    'Vols eliminar el document sol·licitat al titular?',
  REMOVE: 'Eliminar',
  COMMENT: 'Comentari',
  SET_DOCUMENT_STATUS: 'Canviar estat del document',
  SET_DOCUMENT_STATUS_REQUIRED_DESCRIPTION: 'Selecciona el nou estat amb què vols marcar el document.',
  SET_DOCUMENT_REQUIRED_IS_NOT_SENT: 'Marcar el document com a no enviat',
  SET_DOCUMENT_REQUIRED_IS_NOT_SENT_DESCRIPTION: "Voleu marcar el document com a no enviat a l'entitat financera?",
  SET_NOT_SENT: 'Marcar com a no enviat',
  DOCUMENT_VALIDATED: 'Documentació validada',
  CHANGE_STATUS: 'Canviar estat',
  UPLOAD_FILE: 'Pujar document',
  DOWNLOAD_FILE: 'Descarregar document',
  DOWNLOAD_INSURANCE_OFFER: "Descarregar oferta d'assegurança",
  INSURANCE_OFFER_NOT_AVAILABLE_YET: "L'oferta d'assegurança encara no està disponible per a les condicions actuals",
  VALIDATED: 'Validat',
  UPLOAD_FILE_TEXT: 'Pujar document/s de tipus: ',
  ADD_FILE_ACTION: 'Seleccionar document',
  UPLOADED_DOCUMENTATION: 'Documentació carregada',
  DOCUMENTS_TO_UPLOAD: 'Documentació pendent de carregar',
  UPLOAD_FILES: 'Pujar documentació',
  FILE_WILL_BE_OVERWRITTEN:
    'Els documents pendents de carregar reemplaçaran els documents ja carregats que tinguin el mateix nom',
  THIS_MIME_FILE_TYPE_IS_NOT_POSSIBLE_TO_DOWNLOAD: "No és possible descarregar un document d'aquest tipus",
  //DOCUMENTATION FILETYPE
  PROFORMA_INVOICE: 'Factura proforma',
  BANK_ACCOUNT_OWNERSHIP_DOCUMENTATION: 'Certificat de titularitat',
  PAYROLL: 'Nòmines',
  PERSONAL_INCOME_TAX: 'IRPF anual',
  BIOMETRICS_DOCUMENT: 'Document biomètric del procés KYC',
  DOCUMENT_ID_FRONT: 'Part frontal del DNI / NIE',
  DOCUMENT_ID_BACK: 'Part posterior del DNI / NIE',
  PASSPORT: 'Passaport',
  PENSION_DOCUMENT: 'Document pensió',
  DOCUMENT_ID_FACE: "Imatge facial extreta del document d'identitat",
  KYC_VIDEO: 'Vídeo extret durant el procés de KYC',
  DOCUMENT_ID_SIGNATURE: "Signatura extreta del document d'identitat",
  BIOMETRICS_FACE: 'Imatge facial extreta durant el procés de KYC',
  LOAN_LENDER_BORROWER_CONTRACT: "Contracte de finançament entre el client final i l'entitat financera",
  [IncomeType.BORROWER_BANK_READER]: 'Aggregació bancària',
  [IncomeType.DECLARED_INCOME]: 'Ingressos declarats',
  [NetIncomeType.SALARY]: 'Salari',
  [NetIncomeType.PENSION]: 'Pensió',
  [NetIncomeType.UNEMPLOYMENT_BENEFIT]: 'Atur',
  [NetIncomeType.OTHER_PAYMENT]: 'Altres',
  [BorrowerFileType.BORROWER_AML]: "Resultats de la cerca d'AML/PEP",
  [BorrowerFileType.BORROWER_ASNEF]: 'Resultat de la cerca del DNI al llistat de morositat (ASNEF)',
  [LoanFileType.VEHICLE_INSPECTION_DOCUMENT]: "Targeta d'inspecció tècnica del vehicle",
  [LoanFileType.INE_NEMURU_DOCUMENT]: 'INE (Informació Normalitzada Europea) del préstec intermediació',
  [LoanFileType.INE_LENDER_NEMURU_DOCUMENT]: 'INE (Informació Normalitzada Europea) del préstec Nemuru Finance',
  [LoanFileType.DRIVING_PERMIT]: 'Permís de circulació',
  [LoanFileType.CARFAX]: 'Document Carfax del vehicle',
  [LoanFileType.DEED_OF_SALE]: 'Escriptura de compravenda',
  [LoanFileType.OWNERSHIP_DOCUMENTATION]:
    'Justificant de propietat (IBI o escriptura o nota simple o últim rebut hipoteca)',
  [LoanFileType.IBI]: 'Impost sobre béns immobles',
  [LoanFileType.PROOF_OF_INCOME]:
    "Justificant d'ingressos (nòmina o revalorització pensió o acord de prejubilació o certificat bancari de cobrament de pensió o IRPF últim exercici)",
  [LoanFileType.PROPERTY_REGISTRY_EXTRACT]: 'Nota simple del registre de la propietat',
  [LoanFileType.LAST_MORTGAGE_PAYMENT]: 'Últim rebut hipoteca',
  [LoanFileType.TRAFFIC_REPORT]: 'Informe trànsit / Informe matricula / Informe càrregues',
  [MerchantFileType.F_036]: 'Model 036 Alta autònom',
  [BorrowerFileType.UNEMPLOYMENT_INCOME_DOC]: "Documentació d'ingressos per prestació per desocupació",
  [MerchantFileType.MERCHANT_DOCUMENT]: 'Document de merchant',
  [MerchantFileType.MERCHANT_CONTRACT_AUDIT_TRAIL]: 'Traça de signatura digital del contracte de merchant',
  [BorrowerFileType.SEPE_DOCUMENT]: "Document SEPE, confirmació de l'ERTE",
  [BorrowerFileType.LAST_FULL_PAYROLL]: "Última nòmina completa rebuda abans de l'ERTE",
  [BorrowerFileType.PENSION_REVALUATION_LETTER]: 'Carta revalorització pensió de la seguretat social',
  [BorrowerFileType.LAST_PENSION_INCOME]: 'Últim ingrés per pensió (rebuda)',
  [BorrowerFileType.WORK_LEAVE]: 'Certificat de baixa laboral',
  [BorrowerFileType.WORKING_LIFE_REPORT]: 'Certificat de vida laboral',
  [BorrowerFileType.CALLING_LETTER]: 'Carta de crida (per treball temporal)',
  [BorrowerFileType.CONTRIBUTION_BASE]: 'Base de cotització',
  [BorrowerFileType.TAX_DATA]: 'Dades Fiscals',
  [BorrowerFileType.OTHER_1]: 'Altres 1',
  [BorrowerFileType.OTHER_2]: 'Altres 2',
  [BorrowerFileType.OTHER_3]: 'Altres 3',
  [BorrowerFileType.OTHER_4]: 'Altres 4',
  [BorrowerFileType.OTHER_5]: 'Altres 5',
  [BorrowerFileType.DRIVING_LICENCE]: 'Carnet de conduir',
  [BorrowerFileType.ADDRESS_EVIDENCE]: "Justificant d'adreça",
  [BorrowerFileType.SELF_EMPLOYMENT_FEE_VERIFIER]: 'Justificant quota autònoms',
  [BorrowerFileType.MODEL_130_1T]: 'Model 130 1T',
  [BorrowerFileType.MODEL_130_2T]: 'Model 130 2T',
  [BorrowerFileType.MODEL_130_3T]: 'Model 130 3T',
  [BorrowerFileType.MODEL_130_4T]: 'Model 130 4T',
  [BorrowerFileType.MODELO_300_1T]: 'Modelo 300 1T',
  [BorrowerFileType.MODELO_300_2T]: 'Modelo 300 2T',
  [BorrowerFileType.MODELO_300_3T]: 'Modelo 300 3T',
  [BorrowerFileType.MODELO_300_4T]: 'Modelo 300 4T',
  [BorrowerFileType.MODEL_390_LAST_YEAR]: "Declaració de l'últim any IVA (Model 390)",
  [BorrowerFileType.PAYROLL_TWO_PREVIOUS_MONTHS]: 'Nòmina de fa dos mesos',
  [BorrowerFileType.PAYROLL_THREE_MONTHS_EARLIER]: 'Nòmina de fa tres mesos',
  [LoanFileType.SALES_INVOICE]: 'Factura de venda',
  [LoanFileType.BILL_SERVICES]: 'Factura serveis',
  [BorrowerFileType.BANK_READER_INCOME]: "Ingrés detectat a través de l'agregació bancària",
  [BorrowerFileType.CAIXABANK_INCIDENCE_DOCUMENT]: 'Documentació addicional',
  [BorrowerFileType.INSURANCE_BORROWER_CONTRACT]:
    "Original de la Pòlissa de l'assegurança signada pel titular de la pòlissa",
  [BorrowerFileType.PHONE_OR_ENERGY_INVOICE]: 'Factura domiciliada de telèfon o llum a nom del titular',
  [BorrowerFileType.CREDIT_CARD_FRONT]: 'Targeta de crèdit (no dèbit) cara frontal',
  [BorrowerFileType.CREDIT_CARD_BACK]: 'Targeta de crèdit (no dèbit) cara posterior',
  [BorrowerFileType.ENROLLMENT_OF_THE_STUDENT]: "Matrícula de l'estudiant de l'any en curs",
  [BorrowerFileType.TAXI_LICENCE]: 'Llicència de taxi en vigor',
  [BorrowerFileType.PROPERTY_CERTIFICATE]: 'Justificant de propietat',
  [BorrowerFileType.TAX_VAT_LAST_QUARTER]: "IVA de l'últim trimestre",
  [BorrowerFileType.TAX_VAT_PREVIOUS_QUARTER]: 'IVA del trimestre anterior',
  [BorrowerFileType.ATTORNEY_1_DOCUMENT_ID_BACK]: 'Part posterior del document del procurador 1',
  [BorrowerFileType.ATTORNEY_2_DOCUMENT_ID_BACK]: 'Part posterior del document del procurador 2',
  [BorrowerFileType.ATTORNEY_1_DOCUMENT_ID_FRONT]: 'Part davantera del document del procurador 1',
  [BorrowerFileType.ATTORNEY_2_DOCUMENT_ID_FRONT]: 'Part davantera del document del procurador 2',
  [BorrowerFileType.BALANCE_SHEET_AND_INCOME_STATEMENT_CURRENT_YEAR]: "Balanç de pèrdues i guanys de l'exercici actual",
  [BorrowerFileType.BALANCE_SHEET_AND_INCOME_STATEMENT_LAST_YEAR]: "Balanç de pèrdues i guanys de l'exercici passat",
  [BorrowerFileType.CORPORATE_IDENTIFICATION_NUMBER]: 'CIF de la companyia',
  [BorrowerFileType.POWERS_OF_ATTORNEY]: 'Escriptures de poders del procurador',
  [BorrowerFileType.MODEL_200_LAST_YEAR]: 'Impost de Societats - Model 200 (exercici passat)',
  [BorrowerFileType.MODELO_303_CURRENT_YEAR]: "Declaració trimestral de l'IVA - Model 303 (exercici actual)",
  [BorrowerFileType.ABANCA_ADHESION_BULLETIN]: "Butlletí d'adhesió a Abanca",
  [LoanFileType.INCOME_AND_OWNERSHIP_CERTIFICATION_BS]: 'Nòmina i certificat de titularitat BS',
  [LoanFileType.INCOME_AND_OWNERSHIP_CERTIFICATION_COFIDIS]: 'Nòmina i certificat de titularitat Cofidis',
  [LoanFileType.INCOME_AND_OWNERSHIP_CERTIFICATION_NEMURU]: 'Nòmina i certificat de titularitat Nemuru',
  [LoanFileType.INCOME_AND_OWNERSHIP_CERTIFICATION_SOYOU]: 'Nòmina i certificat de titularitat Sofinco',
  [BorrowerFileType.NIE_EU_DOCUMENT_ID]: "Document d'identitat NIE (Europeu)",

  //MAIN RESIDENCE DETAILS:
  MAIN_RESIDENCE: 'Domicili principal',
  OWNERSHIP_TYPE: 'Tipus de propietat',
  CONTRACT_TYPE: 'Tipus de contracte',
  HOME_EXPENSES: 'Despeses mensuals',
  ENTRANCE_DATE: "Data d'entrada al domicili",
  MORTGAGE: 'Hipoteca',
  public_deed: 'Amb escriptura pública',
  private_contract: 'Amb contracte privat',
  social_housing: 'Habitatge social',
  ownership: 'De la meva propietat',
  rent: 'Llogat',
  leasing: "Propietat/lloguer d'empresa",
  usufruct: 'Usufructe',
  partner: 'Propietat de cònjuge',
  parents: 'Propietat de pares',
  FORMATTED_ADDRESS_WILL_BE_GEOLOCATED_WARNING:
    "L'adreça proporcionada serà geolocalitzada automàticament a través de Google i podria ajustar-se per a una major precisió. Si us plau, revisa el resultat final després de desar-la.",
  BUILDING_LABEL: 'Escala / Bloc',
  AUTOCOMPLETE_ADDRESS: 'Autocompletar adreça',
  COMPLETE_ADDRESS_MANUALLY: "Completar l'adreça manualment",
  AUTOCOMPLETE_HINT: 'Comença a introduir la teva adreça y sel.lecciona una opció de la llista',
  SELECTED_ADDRESS: 'Adreça sel.leccionada',
  SEARCH_AGAIN: 'Tornar a cercar',
  UPDATING_ADDRESS: 'Actualitzant adreça',
  EDIT_ADDRESS: 'Editar adreça',
  ADDITIONAL_DETAILS: 'Detalls adicionals',
  CONFIRM_CHANGES: 'Confirmar canvis',
  HOME_EXPENSES_MUST_BE_GREATER_THAN_0: 'Les despeses mensuals han de ser superiors a 0',

  //FAMILIAR SITUATION DETAILS
  FAMILIAR_SITUATION: 'Situació familiar',
  MARITAL_STATUS: 'Estat civil',
  MARITAL_REGIME: 'Règim matrimonial',
  CHILD_SUPPORT_NUMBER: 'Nombre de fills a càrrec',
  married: 'Casat/ada',
  separated: 'Separat/ada',
  single: 'Solter/a',
  widowed: 'Vidu/da',
  divorced: 'Divorciat/ada',
  separated_in_fact: 'Separat/ada de fet',
  similar_situation_to_married: 'Situació similar al matrimoni',
  matrimonial_assets: 'Amb règim de guanys',
  separate_property: 'Amb separació de béns',

  //PROFESSIONAL DETAILS
  PROFESSIONAL_DETAILS: 'Informació professionals',
  EMPLOYMENT_STATUS: 'Professió',
  PROFESSIONAL_POSITION: 'Posició professional',
  COMPANY: 'Empresa',
  COMPANY_NAME: 'Nom de la companyia',
  COMPANY_ACTIVITY: 'Activitat de la companyia',
  COMPANY_CITY: 'Ciutat',
  INDIVIDUAL_FINANCIAL_DATA_PRICE: "Import net de l'exercici anterior",
  INDIVIDUAL_FINANCIAL_DATA_DATE: "Any de l'exercici anterior",
  SENIORITY_YEARS: 'Anys a la companyia',
  SENIORITY_MONTHS: 'Mesos a la companyia',
  SENIORITY: 'Antiguitat',
  SELF_EMPLOYMENT_NET_INCOME: "Import net de l'exercici anterior",
  SELF_EMPLOYMENT_NET_INCOME_DATE: "Data de l'exercici anterior",
  DATE_CONTRACT_END: 'Data de finalització de contracte',
  TIME_IN_THE_COMPANY: 'Temps a la companyia',
  MIN_NUMBER_ERROR: 'El valor no supera el mínim exigit',
  MAX_NUMBER_EXCEEDED: 'Número màxim excedit',
  INVALID_POSTAL_CODE: 'Codi postal no vàlid',

  [EmploymentStatus.SELF_EMPLOYED]: 'Autònom/a',
  [EmploymentStatus.INDEFINITE_EMPLOYED]: 'Treball amb contracte indefinit',
  [EmploymentStatus.TEMPORARY_EMPLOYED]: 'Treball amb contracte temporal',
  [EmploymentStatus.FIXED_DISCONTINUOUS_EMPLOYED]: 'Treball amb contracte fix discontinu',
  [EmploymentStatus.CIVIL_SERVANT]: 'Funcionari/ària',
  [EmploymentStatus.TRAINEE]: 'Becari/ària / En pràctiques',
  [EmploymentStatus.CASUALTY_WORKER]: 'Treballador/a eventual',
  [EmploymentStatus.UNEMPLOYED]: "A l'atur",
  [EmploymentStatus.RETIRED]: 'Jubilat/ada',
  [EmploymentStatus.PENSIONER]: 'Pensionista',
  [EmploymentStatus.STUDENT]: 'Estudiant',
  [EmploymentStatus.RENTIER]: 'Rendista',
  [EmploymentStatus.WITHOUT_WORK]: 'Sense treball',
  [EmploymentStatus.WIDOWS_INCOME]: 'Pensió de viduïtat',
  [ProfessionalPosition.ADMINISTRATIVE]: 'Administratiu/iva',
  [ProfessionalPosition.MANAGING_DIRECTOR]: 'Directiu/iva',
  [ProfessionalPosition.MANAGER]: 'Gerent',
  [ProfessionalPosition.COMPANY_OWNER]: 'Propietari/ària / Administrador/a empresa',
  [ProfessionalPosition.TECHNICIANS_AND_PROFESSIONAL]: 'Tècnic/a o Professional',
  [ProfessionalPosition.SHOP_ASSISTANT]: 'Dependent/a / Cambrer/a',
  [ProfessionalPosition.COMMERCIAL_AND_SALES_PERSON]: 'Comercial / Vendes',
  [ProfessionalPosition.LABOR_WORKER]: 'Operari/a / Obrer/a',
  [ProfessionalPosition.ENGINEER]: 'Enginyer/era',
  [ProfessionalPosition.ARCHITECT]: 'Arquitecte/ta',
  [ProfessionalPosition.LAWYER_OR_NOTARY_ATTORNEY]: 'Advocat/ada o notari/ària',
  [ProfessionalPosition.DOCTOR_OR_DENTIST]: 'Professionals de la salut',
  [ProfessionalPosition.PHARMACEUTICAL]: 'Farmacèutic/a',
  [ProfessionalPosition.VETERINARY]: 'Veterinari/ària',
  [ProfessionalPosition.TEACHER]: 'Mestre/tra',
  [ProfessionalPosition.JOURNALIST]: 'Periodista',
  [ProfessionalPosition.FARMER_OR_RANCHER]: 'Agricultor/ra o ramader/ra',
  [ProfessionalPosition.TRANSPORTER]: 'Transportista',
  [ProfessionalPosition.PROFESSIONAL_ATHLETE]: 'Atleta professional',
  [ProfessionalPosition.ARTIST]: 'Artista',
  [ProfessionalPosition.WRITER]: 'Escriptor/a',
  [ProfessionalPosition.RELIGIOUS]: 'Religiós/osa',
  [ProfessionalPosition.POLICE_AND_MILITARY]: 'Policia / Exèrcit',
  [ProfessionalPosition.DIPLOMATIC]: 'Diplomàtic/a',
  [ProfessionalPosition.CIVIL_SERVANT_A1]: 'Adm. públic - Funcionari A1',
  [ProfessionalPosition.CIVIL_SERVANT_A2]: 'Adm. públic - Funcionari A2',
  [ProfessionalPosition.CIVIL_SERVANT_B]: 'Adm. públic - Funcionari B',
  [ProfessionalPosition.CIVIL_SERVANT_C1]: 'Adm. públic - Funcionari C1',
  [ProfessionalPosition.CIVIL_SERVANT_C2]: 'Adm. públic - Funcionari C2',
  [ProfessionalPosition.CIVIL_SERVANT_E]: 'Adm. públic - Funcionari E',
  [ProfessionalPosition.LABOR_STAFF_G1]: 'Adm. públic - Funcionari G1',
  [ProfessionalPosition.LABOR_STAFF_G2]: 'Adm. públic - Funcionari G2',
  [ProfessionalPosition.LABOR_STAFF_G3]: 'Adm. públic - Funcionari G3',
  [ProfessionalPosition.LABOR_STAFF_G4]: 'Adm. públic - Funcionari G4',
  [ProfessionalPosition.LABOR_STAFF_G5]: 'Adm. públic - Funcionari G5',
  [IberiaEmploymentStatus.EMPLOYEE_PERMANENT]: 'Treball amb contracte indefinit',
  [IberiaEmploymentStatus.EMPLOYEE_CIVIL_SERVANT]: 'Administració pública',
  [IberiaEmploymentStatus.EMPLOYEE_INTERN]: 'Becari/ària',
  [IberiaEmploymentStatus.EMPLOYEE_TEMPORARY]: 'Treball amb contracte temporal',
  [IberiaEmploymentStatus.EMPTY]: '-',
  [IberiaEmploymentStatus.EXECUTIVE_DIRECTOR]: 'Director executiu',
  [IberiaEmploymentStatus.INACTIVE]: "A l'atur",
  [IberiaEmploymentStatus.INVESTOR_SHAREHOLDER]: 'Inversor',
  [IberiaEmploymentStatus.PENSIONER_RETIRED_WIDOW]: 'Pensionista / jubilat/da / viu/da',
  [IberiaEmploymentStatus.SELF_EMPLOYED_BUSINESS_OWNER]: 'Empresari/ra',
  [IberiaEmploymentStatus.SELF_EMPLOYED_FREELANCER]: 'Autònom/a',
  [CompanyActivity.AGRICULTURE_LIVESTOCK_FISHERIES]: 'Agricultura / Ramaderia / Pesca',
  [CompanyActivity.MINING_METALLURGY]: 'Mineria / Metal·lúrgia',
  [CompanyActivity.GROCERY]: 'Comestibles',
  [CompanyActivity.TEXTILE_MANUFACTURE]: 'Tèxtil',
  [CompanyActivity.WOOD]: 'Fusteria',
  [CompanyActivity.GRAPHICS_ARTS_EDITION]: 'Art gràfic / Edició',
  [CompanyActivity.CHEMISTRY]: 'Química',
  [CompanyActivity.MECHANICAL_MACHINERY]: 'Maquinària mecànica',
  [CompanyActivity.ENERGY_DISTRIBUTION_ELECTRICAL_SUPPLY]: 'Energètica',
  [CompanyActivity.OTHER_UNQUALIFIED_SERVICES]: 'Altres serveis no qualificats',
  [CompanyActivity.OTHER_QUALIFIED_SERVICES]: 'Altres serveis qualificats',
  [CompanyActivity.BUILDING]: 'Construcció',
  [CompanyActivity.COMMERCE]: 'Comerç',
  [CompanyActivity.PEDDLING]: 'Venda ambulant',
  [CompanyActivity.TRANSPORT_TERRESTRIAL_MESSAGING]: 'Missatgeria per transport terrestre',
  [CompanyActivity.OTHER_TRANSPORTS]: 'Altres tipus de transportista',
  [CompanyActivity.TAXI_DRIVER]: 'Servei de xofer / Taxi',
  [CompanyActivity.TELECOMMUNICATIONS_MAIL]: 'Telecomunicació / Correu',
  [CompanyActivity.BARS_SERVICES]: 'Serveis / Gastronomia',
  [CompanyActivity.I_PLUS_D]: 'Investigació i desenvolupament',
  [CompanyActivity.ADVOCACY_JOURNALISM]: 'Periodisme / Advocacia',
  [CompanyActivity.SECURE_FINANCIAL_SERVICES]: 'Serveis financers segurs',
  [CompanyActivity.FINANCIAL_SERVICES_INSURANCE]: 'Assegurança',
  [CompanyActivity.IT_CONSULTANT_AUDITOR]: 'IT / Consultoria / Auditoria',
  [CompanyActivity.ARCHITECTURE_ENGINEERING]: 'Enginyeria / Arquitectura',
  [CompanyActivity.VETERINARY_MEDICINE]: 'Medicina / Veterinària',
  [CompanyActivity.PUBLIC_ADMINISTRATIONS]: 'Administracions públiques',
  [CompanyActivity.ARMED_FORCES]: 'Forces armades',
  [CompanyActivity.HOLIDAY_SHOWS_SHOWS]: 'Vacances / Entreteniment',
  [CompanyActivity.SPORTS]: 'Esports',
  [IberiaCompanyActivity.AERONAUTICS_TRANSPORT_NAUTICAL]: 'Aeronàutica, Transport i Nàutica',
  [IberiaCompanyActivity.AGRICULTURE_GARDENING_MINERALOGY_GEOLOGY]: 'Agricultura, Jardineria, Mineralogia i Geologia',
  [IberiaCompanyActivity.BANKING_FINANCIAL_INSTITUTIONS]: 'Banca i Entitats Financieres',
  [IberiaCompanyActivity.EXPERIMENTAL_SCIENCES_MATHEMATICS_PHYSICS]: 'Ciències Experimentals, Matemàtiques i Física',
  [IberiaCompanyActivity.COMMUNICATION_ADVERTISING_PUBLIC_RELATIONS]: 'Comunicació, Publicitat i Relacions Públiques',
  [IberiaCompanyActivity.CONSTRUCTION_BUILDING]: 'Construcció i Edificació',
  [IberiaCompanyActivity.SECURITY_FORCES_CRIMINOLOGY]: 'Cuerpos de Seguretat i Criminologia',
  [IberiaCompanyActivity.SPORTS_PHYSICAL_EDUCATION]: 'Esports i Educació Física',
  [IberiaCompanyActivity.LAW_POLITICS]: 'Dret i Política',
  [IberiaCompanyActivity.DESIGN_GRAPHIC_TEXTILE_INDUSTRIAL_INTERIOR]: 'Disseny: Gràfic Textil, Industrial i Interiors',
  [IberiaCompanyActivity.ECONOMICS_BUSINESS_ADMINISTRATION]: "Economia i Administració d'Empreses",
  [IberiaCompanyActivity.EDUCATION_TRAINING]: 'Educació i Formació',
  [IberiaCompanyActivity.HOSPITALITY_TOURISM_CATERING]: 'Hosteleria, Turisme i Restauració',
  [IberiaCompanyActivity.HUMANITIES_PSYCHOLOGY]: 'Humanitats, Psicòleg',
  [IberiaCompanyActivity.LANGUAGES_PHILOLOGY_TRANSLATION]: 'Idiomes, Filologia i Traducció',
  [IberiaCompanyActivity.PERSONAL_IMAGE]: 'Imatge Personal',
  [IberiaCompanyActivity.IMAGE_SOUND]: 'Imatge i Son',
  [IberiaCompanyActivity.INDUSTRY_MECHANICS_ELECTRICITY_ELECTRONICS]: 'Indústria, Mecànica, Electricitat i Electrònica',
  [IberiaCompanyActivity.IT_TELECOMMUNICATIONS]: 'Informàtica i Telecomunicacions',
  [IberiaCompanyActivity.ENVIRONMENT_VETERINARY_SCIENCE]: 'Medi Ambient i Veterinària',
  [IberiaCompanyActivity.MUSIC_FILM_DANCE_THEATRE]: 'Música, Cinema, Dança i Teatre',
  [IberiaCompanyActivity.HEALTHCARE_HEALTH]: 'Sanitat i Salut',
  [IberiaCompanyActivity.CRAFT_ARTISTIC_TECHNIQUES]: 'Tècniques Artístiques i Artístiques',

  //BUSINESS DETAILS

  BUSINESS_IDENTIFICATION: "Detalls de l'empresa",
  NATIONAL_ID_TYPE: "Tipus de document d'identificació nacional",
  NATIONAL_ID_NUMBER: "Número d'identificació nacional",
  BUSINESS_FINANCIAL_DETAILS: 'Detalls financers',
  CAPITAL_STOCK: 'Capital social',
  OWN_FUNDS: 'Fons propis',
  TAX_BASE: "Benefici abans d'impostos",
  INDIVIDUAL_FINANCIAL_NET_AMOUNT: 'Facturació',
  BIRTH_COUNTRY: 'País de naixement',
  HOLDER_TYPES: 'Tipus de titulars',
  GRANTING_POWERS_DATE: 'Data de concessió de poders',
  HOLDER_PERCENTAGE: 'Percentatge de participació',
  RELATIONSHIP_WITH_OWNER: 'Relació amb el propietari',
  [HolderType.ATTORNEY]: 'Apoderat',
  [HolderType.ADMINISTRATOR]: 'Administrador',
  [HolderType.SHAREHOLDER]: 'Soci',
  attorneys: 'Apoderats',
  shareholders: 'Socis',
  administrators: 'Administradors',
  EDIT_BUSINESS_IDENTIFICATION: "Editar detalls d'empresa",
  EDIT_BUSINESS_FINANCIAL_DETAILS: 'Editar detalls financers',
  EDIT_BUSINESS_ADDRESS: "Editar adreça d'empresa",
  edit_attorney_details: "Editar detalls d'apoderat",
  edit_shareholder_details: 'Editar detalls de soci',
  edit_administrator_details: "Editar detalls d'administrador",

  //BUSINESS TYPE
  [BusinessType.AEI]: "Agrupació Europea d'Interès Econòmic",
  [BusinessType.AIE]: "Agrupació d'Interès Econòmic",
  [BusinessType.CB]: 'Comunitat de Béns',
  [BusinessType.CP]: 'Comunitat de Propietaris',
  [BusinessType.ECR]: 'Entitats de Capital Risc',
  [BusinessType.ESJ]: 'Entitat Sense Personalitat Jurídica',
  [BusinessType.MUT]: 'Mutualitat',
  [BusinessType.OTR]: 'Altres',
  [BusinessType.PRI]: 'Associació/Organització Privada',
  [BusinessType.PUB]: 'Administració Pública',
  [BusinessType.SA]: 'Societat Anònima',
  [BusinessType.SAL]: 'Societat Anònima Laboral',
  [BusinessType.SAT]: 'Societat Agrària de Transformació',
  [BusinessType.SAU]: 'Societat Anònima Unipersonal',
  [BusinessType.SCA]: 'Societat en Comandita per Accions',
  [BusinessType.SCE]: 'Societat Cooperativa Europea',
  [BusinessType.SCL]: 'Societat en Comandita Simple',
  [BusinessType.SCO]: 'Societat Cooperativa',
  [BusinessType.SCP]: 'Societat Civil Privada',
  [BusinessType.SCS]: 'Societat en Comandita Simple',
  [BusinessType.SE]: 'Societat Europea',
  [BusinessType.SGR]: 'Societat de Garantia Recíproca',
  [BusinessType.SL]: 'Societat Limitada',
  [BusinessType.SLL]: 'Societat Limitada Laboral',
  [BusinessType.SLN]: 'Societat Limitada Nova Empresa',
  [BusinessType.SLU]: 'Societat Limitada Unipersonal',
  [BusinessType.SPD]: 'Sucursals en Països Diferents',
  [BusinessType.SRL]: 'Societat de Responsabilitat Limitada',

  //NET INCOME
  NET_INCOME: 'Ingressos',
  BANK_NAME: 'Entitat financera',
  ACCOUNT_NUMBER: 'Número de compte bancari',
  IBAN: 'IBAN',
  DETECTED_INCOMES: 'Ingressos detectats',
  LAST_12_MONTHS: 'Últims 12 mesos',
  MONTHLY: 'Mensual',
  ANNUAL: 'Anual',
  INCOME_TYPE: "Tipus d'ingrés",
  ORIGIN: 'Origen',
  LOADING_INCOME: 'Obtenint ingressos detectats...',
  ANNUAL_NET_INCOME: 'Ingressos nets anuals',
  MONTHLY_NET_INCOME: 'Ingressos nets mensuals',
  EDIT_DECLARED_INCOME: 'Editar ingressos declarats',
  INVALID_IBAN: 'Número de compte no vàlid',
  NUMBER_OF_YEARLY_PAYMENTS: 'Nombre de pagues anuals',

  // ROLES
  [APP_ROLES.SUPER_ADMIN]: 'Superadministrador',
  [APP_ROLES.ADMIN]: 'Administrador',
  [APP_ROLES.LENDER]: 'Prestamista',
  [APP_ROLES.MERCHANT]: 'Comerciant',
  [APP_ROLES.CHANNEL]: 'Canal',
  [APP_ROLES.AGENT]: 'Agent',
  [APP_ROLES.PARTNER]: 'Soci',
  [APP_ROLES.THIRD_PARTY_VALIDATION]: 'Agent de validació externa',

  //USER TYPE
  [`user_${UserType.SUPER_ADMIN}`]: 'Superadministrador',
  [`user_${UserType.ADMIN}`]: 'Administrador',
  [`user_${UserType.LENDER}`]: 'Lender',
  [`user_${UserType.MERCHANT}`]: 'Comerç',
  [`user_${UserType.CHANNEL}`]: 'Canal',
  [`user_${UserType.AGENT}`]: 'Agent',
  [`user_${UserType.MERCHANT_GROUP}`]: 'Grup',
  [`user_${UserType.PARTNER}`]: 'Partner',
  [`user_${UserType.THIRD_PARTY_VALIDATION}`]: 'Agent de validació',
  [`user_${UserType.CPC_BACK_OFFICE}`]: 'Atenció al client CPC',

  // ACCOUNT

  USER_NAME: "Nom d'usuari",
  USER_TYPE: "Tipus d'usuari",
  PROFILE: 'Perfil',
  USER_INFO: "Informació d'usuari",
  ACCOUNT_TYPE: 'Tipus de compte',
  APPLICATION_LANGUAGE: "Idioma de l'aplicaciò",
  CHANNEL_AGENTS_NUMBER: "Nombre d'agents al canal",
  BUSINESS_PHONE: 'Telèfon',
  BUSINESS_ADDRESS: 'Adreça',
  THEME: 'Apariència',
  DARK_MODE_TOGGLE: 'Mode fosc',

  // SNACKBAR NOTIFICATIONS
  ACTION_GENERIC_ERROR: "Ups! S'ha produït un error.",
  ACTION_GENERIC_INFO: "L'acció s'ha realitzat correctament",
  ACTION_GENERIC_SUCCESS: "L'acció s'ha realitzat correctament",
  ACTION_GENERIC_ERROR_TITLE: "No s'ha pogut realitzar l'acció",
  REQUEST_GET_LOAN_BY_ID_REJECTED: "No s'han pogut carregar les dades del préstec sol·licitat",

  //PRICINGS
  PRICINGS_LIST: 'Llistat de tarifes',
  LOADING_PRICINGS: 'Carregant tarifes...',
  LOADING_PRICINGS_DETAILS: 'Carregant tarifa...',
  FILTERS: 'Filtres',
  AVAILABLE_PRICINGS: 'Tarifes disponibles',
  SELECT_THE_PAYMENT_METHOD: 'Selecciona el mètode de pagament desitjat.',
  WITH_GRACE_PERIOD_FILTER: 'Amb carència',
  WITHOUT_GRACE_PERIOD_FILTER: 'Sense carència',
  GRACE_PERIOD_NO_FILTER: 'Carència no filtrada',
  NO_FILTER: 'Sense filtre',
  WITH_SETUP_FEE_FILTER: "Amb comissió d'obertura",
  WITHOUT_SETUP_FEE_FILTER: "Sense comissió d'obertura",
  SETUP_FEE_NO_FILTER: "Comissió d'obertura no filtrada",
  [`INSURANCE_TYPE_${InsuranceType.EXTENSION_GARANTIA}`]: 'Extensió garantia',
  [`INSURANCE_TYPE_${InsuranceType.NO}`]: 'Sense assegurança',
  [`INSURANCE_TYPE_${InsuranceType.RETIRADA_CARNET}`]: 'Retirada del carnet',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_AUTO}`]: 'Assegurança de cotxe',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_DESEMPLEO}`]: "Assegurança d'atur",
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_PPP}`]: 'Assegurança PPP',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_VIDA}`]: 'Assegurança de vida',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_VIDA_IPA}`]: 'Assegurança vida IPA',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_VIDA_IPA_PPP}`]: 'Assegurança vida IPA PPP',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_VIDA_PLUS}`]: 'Assegurança vida+',
  [`INSURANCE_TYPE_${InsuranceType.SINIESTRO_TOTAL}`]: 'Sinistre total',
  [`INSURANCE_TYPE_${InsuranceType.VEHICULO_SUSTITUCION}`]: 'Vehicle de substitució',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_VIDA_SENIOR}`]: 'Assegurança de vida senior',
  NO_INSURANCE: 'Sense assegurança',

  INSURANCE_PROVIDER: 'Proveïdor',
  INSURANCE_TYPE_NONE: 'Sense assegurança',
  [`INSURANCE_PROVIDER_${InsuranceProvider.BBVA}`]: 'BBVA',
  [`INSURANCE_PROVIDER_${InsuranceProvider.CAIXABANK}`]: 'CaixaBank',
  [`INSURANCE_PROVIDER_${InsuranceProvider.SANTANDER_CONSUMER}`]: 'Santander Consumer',
  [`INSURANCE_PROVIDER_${InsuranceProvider.BS}`]: 'BS',
  [`INSURANCE_PROVIDER_${InsuranceProvider.SOYOU}`]: 'SoYou',
  [`INSURANCE_PROVIDER_${InsuranceProvider.ABANCA}`]: 'Abanca',
  [`INSURANCE_PROVIDER_${InsuranceProvider.COFIDIS}`]: 'Cofidis',
  [`INSURANCE_PROVIDER_${InsuranceProvider.WEE_COVER}`]: 'Wee Cover',
  INSURANCE_COST: 'Import assegurança',
  INSURANCE_PERCENTAGE: 'Percentatge assegurança',

  MERCHANT_FEE_COMMISSION: 'Comissió del comerç',
  SETUP_FEE_COST: 'Cost per al client',
  INSURANCE: 'Assegurança',
  INSURANCES: 'Assegurança(es)',
  AVAILABLE_INSURANCES: 'Assegurances disponibles',
  NO_AVAILABLE_INSURANCES: 'Cap assegurança disponible',
  REGISTRATION: 'Matriculació',
  YEARS_SINCE_REGISTRATION: 'Anys des de la matriculació',
  ANNUAL_INTEREST_AND_DISCOUNT: 'TIN i descompte',

  [`FEE_TYPE_${FeeType.FIX_AMOUNT}`]: 'Import fix',
  [`FEE_TYPE_${FeeType.PERCENTAGE}`]: 'Percentatge',
  [`FEE_PAYMENT_TYPE_${FeePaymentType.TYPE_FINANCED}`]: 'Comissió finançada',
  [`FEE_PAYMENT_TYPE_${FeePaymentType.TYPE_FIXED_AMOUNT}`]: 'Comissió fixa per quota',
  [`FEE_PAYMENT_TYPE_${FeePaymentType.TYPE_UPFRONT}`]: "Comissió d'obertura",

  LESS_OPTIONS: 'Menys opcions',
  MORE_OPTIONS: 'Més opcions',
  REQUIRED: 'obligatori',

  //PAGE LOADING
  LOADING: 'Carregant',
  STILL_LOADING: 'Encara es carregant...',
  IT_SEEMS_THAT_SOME_FEATURES_ARE_TAKING_LONGER_THAN_USUAL_TO_LOAD:
    'Sembla que algunes funcionalitats triguen més del normal a carregar. Pots esperar o **LINK**mostrar la pàgina parcialment**LINK** mentre es carreguen.',

  //CUSTOMER SUPPORT
  CUSTOMER_SUPPORT: 'Atenció al client',
  DAY: 'dia',
  DAYS: 'dies',
  HOUR: 'hora',
  HOURS: 'hores',
  MINUTE: 'minut',
  MINUTES: 'minuts',
  SECOND: 'segon',
  SECONDS: 'segons',
  AFTER: 'després',
  DONE: 'Realitzades',
  LOADING_TICKETS: 'Carregant històric de gestió...',
  TIME_PASSED_SINCE_LAST_ACTION: "Temps des de l'última acció",
  TOTAL_ACTIONS_TIME: 'Temps total de gestió',
  UPDATED_AT: "Data d'actualització:",
  TICKET_STATUS: 'Estat:',
  PRIORITY: 'Prioritat:',
  SELECT_TICKET: 'Seleccionar tiquet',
  TICKET_SOLVED: 'Resolt',
  TICKET_OPENED: 'Obert',
  TICKET_PENDING: 'Pendent',
  TICKET_CLOSED: 'Tancat',
  NO_TICKETS_AVAILABLE: "No hi ha informació d'incidències del servei d'atenció al client",
  SINCE_LOAN_RESOLUTION: 'Des de la resolució del tiquet',
  [Priority.URGENT]: 'Urgent',
  [Priority.NORMAL]: 'Normal',
  ACTIVITY_LOG: 'Activitat',
  TOTAL_ACTIONS: "Total d'accions",
  SELECTED_CHANNELS: 'Canals seleccionats',
  [PendingDataType.NO_CHANNELS_SELECTED]: 'No hi ha canals seleccionats',
  [PendingDataType.PASSWORD_RECOVERY_NOT_FOUND]: "No s'han enviat correus electrònics de recuperació de contrasenya",

  // New Application General
  NEW_APPLICATION: 'Nova sol·licitud',
  RESTART: 'Reiniciar',
  RESTART_NOTICE: 'Les dades es perdran si reinicies la sol·licitud.',
  BACK_NOTICE: 'Les dades de la comanda es perdran si tornes enrere.',
  RESTART_APPLICATION: 'Reiniciar sol·licitud',
  LEAVE: 'Abandonar',
  LEAVE_NOTICE: 'Les dades de la comanda es perdran si abandones la sol·licitud.',
  LEAVE_APPLICATION: 'Abandonar sol·licitud',
  ORDER_DATA: 'Dades de la comanda',
  SHOW_SUMMARY: 'Veure resum',

  NOT_POSSIBLE_CREATING_NEW_APPLICATION: 'No és possible crear una nova sol·licitud',
  NO_PAYMENT_METHODS_AVAILABLE_FOR_AMOUNT: 'No hi ha mètodes de pagament disponibles per al import de la sol·licitud',
  NO_PAYMENT_METHODS_AVAILABLE_FOR_USER: 'El teu usuari no disposa de mètodes de pagament activats.',
  NO_PAYMENT_METHODS_AVAILABLE_FOR_SELECTED_AGENT: "L'agent seleccionat no disposa de mètodes de pagament activats.",
  CONTACT_NEMURU_FOR_SERVICE_ACTIVATION_OR_ERROR: (
    <>
      {'Si vols activar aquest servei o creus que és un error, si us plau contacta amb nosaltres escrivint a '}
      <a href="mailto:hola@nemuru.com">{'hola@nemuru.com'}</a>
      {'.'}
    </>
  ),

  // AGENT SELECTION
  SALES_PROFILE: 'Perfil de vendes',
  SALES_PROFILE_SELECT: 'Asigna un vendedor per aquesta comanda',
  SEARCH_BY_NAME: 'Cerca per nom...',
  SELECT_AN_AGENT: 'Selecciona un agent',
  SELECT_A_CHANNEL: 'Selecciona un canal',
  SELECT_A_MERCHANT: 'Selecciona un merchant',
  SELECT_NEW_AGENT: 'Selecciona un nou agent',
  SELECT_NEW_AGENT_NOTICE: 'Vols seleccionar un nou agent? Es perdran les dades introduïdes a la sol·licitud.',
  // -- ALREADY EXISTS -- CHANNEL: 'Channel',
  NO_AGENTS_AVAILABLE: 'No hi ha agents disponibles',

  // CUSTOMER CONTACT DATA:
  CUSTOMER_CONTACT_DATA: 'Dades del client',
  FILL_CUSTOMER_CONTACT_DATA: 'Omple el formulari amb les dades del client',
  CUSTOMER_NAME: 'Nom del client',
  REFERENCES_SUBTITLE:
    'Introdueix la referència de la comanda en el teu sistema. No es pot utilitzar una referència que ja hagi estat usada prèviament.',

  //AUTO DETAILS
  LAST_VEHICLES: 'Últims vehicles',
  AUTO_DETAILS_DESCRIPTION: 'Introdueix les dades del vehicle a finançar',
  VEHICLE_CONDITION: 'Tipus de vehicle',
  NEW_VEHICLE_CONDITION: 'Nou',
  USED_VEHICLE_CONDITION: 'Ocasió',
  VEHICLE_MODEL_SECTION: 'Model',
  VEHICLE_USAGE_AND_IDENTIFICATION_SECTION: 'Ús i identificació',
  VEHICLE_IDENTIFICATION_SECTION: 'Identificació',
  EUROTAX_CODE_HINT: 'Codi Eurotax $v1',
  NEW_VEHICLE_PLATE_NUMBER_HINT: 'Si ja està matriculat',
  NEW_VEHICLE_IDENTIFICATION_NUMBER_HINT: 'Si encara no el tens, es pot afegir més endavant',
  IDENTIFICATION_NUMBER_ALREADY_USED_HINT: 'Ja existeix una sol·licitud amb aquest bastidor',
  MODEL_DATE_SUFFIX_TOOLTIP:
    "El número final indica l'any i el mes del model (AAAAMM). Per exemple, 201607 és el model de juliol de 2016.",
  VERSION_DATE_SUFFIX_TOOLTIP:
    "El número final indica l'any i el mes de la versió (AAAAMM). Per exemple, 201607 és la versió de juliol de 2016.",
  PREVIOUS_VALUE: 'Abans: $v1',
  VEHICLE_CONDITION_NOT_EDITABLE: 'No es pot canviar en una sol·licitud ja creada',
  FINANCING_RESELECTION_REQUIRED: 'Cal triar-la de nou',
  FINANCING_RESELECTION_REQUIRED_DESCRIPTION:
    "Canviar l'import o la data de matriculació invalida la quota actual ($v1, $v2 mesos).",
  LOADING_AUTO_DETAILS: 'Carregant dades del vehicle...',
  // Cart
  // -- JA EXISTEIX -- ORDER_LINES: 'Ítems del pedido',
  CART_TEXT: 'Completa els articles de la comanda',
  CART_TEXT_KTUIN: "Selecciona el producte i l'import a finançar",
  ORDER_REFERENCE_1_TOOLTIP:
    'Referència al teu sistema per a aquesta comanda. No es pot utilitzar una referència que ja hagi estat usada prèviament en una sessió de pagament confirmada.',
  ORDER_REFERENCE: 'Referència',
  ORDER_REFERENCE_DETAILS: 'Referencia al teu sistema per a aquesta comanda',
  REFERENCE_NOT_VALID: "Aquesta referència ja s'ha utilitzat abans",
  ORDER_REFERENCE_1: 'Referència de la comanda',
  ORDER_REFERENCE_2: 'Referència de la comanda 2',
  ORDER_REFERENCE_LABEL: 'Referència comanda',
  DISABLED_TOOLTIP_CART_ERROR: 'Per continuar, revisa la comanda. Està incomplet o té errors.',
  DISABLED_TOOLTIP_REFERENCE_ERROR: 'Per continuar, revisa la referència de la comanda 1.',
  DISABLED_TOOLTIP_REFERENCE_AND_CART_ERROR: 'Per continuar, revisa la referència de la comanda 1 i la comanda.',

  // -- JA EXISTEIX -- UNITS: 'Unidades',
  UNITS_SHORT: 'Unitats',
  UNIT_PRICE: 'Preu unitari',
  // -- JA EXISTEIX -- UNIT_PRICE_WITH_TAX: 'Precio unitario con IVA incluido',
  VAT_TOOLTIP: 'En cas de ser operativa en les Illes Canàries es consideraria IGIC',
  ADD_NEW_ITEM: 'Afegeix ítem',
  NEW_ITEM: 'Nou ítem',
  EDIT_ITEM: 'Edita ítem',
  DELETE_ITEM: 'Elimina ítem',
  SUBTOTAL: 'Subtotal',
  // -- JA EXISTEIX -- TOTAL: 'Total',
  // -- JA EXISTEIX -- VAT_AMOUNT: 'Import IVA',
  TOTAL_PRICE: 'Import total',
  TOTAL_PRICE_WITH_TAX: 'Import total (preu unitari x unitats) amb IVA inclòs',
  TOTAL_PRICE_WITH_INFO: 'Incl. impostos i descomptes',
  ACCEPT: 'Acceptar',
  IN: 'a',
  OR: 'o',

  // CartDialog
  ARTICLE_INFORMATION: "Dades de l'article",
  ARTICLE_TYPE: "Tipus d'article",
  SAVE_AND_NEW_ITEM: 'Desa i afegeix nou ítem',
  CART_DIALOG_CANCEL_CONFIRM: 'Estàs segur que vols tancar la finestra?',
  CART_DIALOG_CANCEL_CONFIRM_TEXT: 'Els canvis introduïts es perdran',
  CART_DIALOG_SUCCESS: "S'ha actualitzat correctament la comanda",
  // -- JA EXISTEIX -- SAVE: 'Guardar',
  [ArticleType.FLIGHT]: 'Vol',
  [ArticleType.ACCOMMODATION]: 'Allotjament',
  [ArticleType.SERVICE]: 'Servei',
  [ArticleType.ONLINE_PRODUCT]: 'Producte',
  [ArticleType.AUTOMOBILE]: 'Vehicle',
  [ArticleTypeExternal.PRODUCT]: 'Producte',

  // Product
  PRODUCT_DETAILS: 'Detalls del producte',
  ARTICLE_DESCRIPTION: 'Descripció del producte',
  ARTICLE_CATEGORY: 'Categoria',
  [`ARTICLE_CATEGORY_${ArticleCategory.PHYSICAL}`]: 'Físic',
  [`ARTICLE_CATEGORY_${ArticleCategory.DIGITAL}`]: 'Digital',
  [`ARTICLE_CATEGORY_${ArticleCategory.DISCOUNT}`]: 'Descompte',
  [`ARTICLE_CATEGORY_${ArticleCategory.SHIPPING_FEE}`]: "Cost d'enviament",
  [`ARTICLE_CATEGORY_${ArticleCategory.GIFT_CARD}`]: 'Targeta regal',

  // Service
  SERVICE_DETAILS: 'Detalls del servei',
  SERVICE_DESCRIPTION: 'Descripció del servei',
  SERVICE_ENDS_ON: 'Data fi del servei',
  ARTICLE_SERVICE_CATEGORY: 'Categoria',
  [`ARTICLE_SERVICE_CATEGORY_${ArticleCategory.DIGITAL}`]: 'Digital',
  [`ARTICLE_SERVICE_CATEGORY_${ArticleCategory.PHYSICAL}`]: 'Presencial',

  // Accommodation
  // -- JA EXISTEIX -- ACCOMMODATION: 'Allotjament',
  ACCOMMODATION_NAME: "Nom de l'allotjament",
  ACCOMMODATION_NAME_PLACEHOLDER: 'Hotel Boutique Chaplin',
  ACCOMMODATION_DETAILS: "Detalls de l'allotjament",
  CHECKIN_DATE: "Data d'entrada",
  CHECKOUT_DATE: 'Data de sortida',

  // Flight
  FLIGHT_DETAILS: 'Detalls del vol',
  FLIGHT_ONE_WAY: 'Només anada',
  FLIGHT_OUTBOUND: 'Anada',
  FLIGHT_INBOUND: 'Tornada',
  FLIGHT_REFERENCE: 'Referència del vol',
  FLIGHT_REFERENCE_PLACEHOLDER: 'VY6760',
  DEPARTURE_AIRPORT: 'Aeroport de sortida (IATA)',
  DESTINATION_AIRPORT: "Aeroport d'arribada (IATA)",
  DATE: 'Data',
  IS_ROUND_TRIP: 'Anada i tornada',
  PASSENGERS_DETAILS: 'Detalls dels passatgers',
  PASSENGER_DOCUMENT_NUMBER: 'Número de document del passatger #$v1',
  ADD_ANOTHER_PASSENGER: 'Afegeix un altre passatger',

  // Travel
  TRAVEL_DETAILS: 'Detalls del viatge',
  TRAVEL_DESTINATION: 'Destinació',
  TRAVEL_DESTINATION_PLACEHOLDER: 'Egipte',
  TRAVEL_DESCRIPTION: 'Descripció',
  TRAVEL_DESCRIPTION_PLACEHOLDER: 'Ruta per les Piràmides de Giza',
  [`TRAVEL_CATEGORY_${TravelCategory.SENIOR_TRAVEL_PROGRAMS}`]: 'Programa per a gent gran',
  [`TRAVEL_CATEGORY_${TravelCategory.BUS}`]: 'Autobús',
  [`TRAVEL_CATEGORY_${TravelCategory.CIRCUITS}`]: 'Circuits',
  [`TRAVEL_CATEGORY_${TravelCategory.CARS}`]: 'Cotxes',
  [`TRAVEL_CATEGORY_${TravelCategory.CRUISE}`]: 'Creuer',
  [`TRAVEL_CATEGORY_${TravelCategory.DISNEY}`]: 'Disney',
  [`TRAVEL_CATEGORY_${TravelCategory.TICKETS}`]: 'Entrades',
  [`TRAVEL_CATEGORY_${TravelCategory.EXCURSIONS}`]: 'Excursions',
  [`TRAVEL_CATEGORY_${TravelCategory.FERRY}`]: 'Ferries',
  [`TRAVEL_CATEGORY_${TravelCategory.GRAND_TOURS}`]: 'Grans tours',
  [`TRAVEL_CATEGORY_${TravelCategory.PACKAGE}`]: 'Paquet',
  [`TRAVEL_CATEGORY_${TravelCategory.INSURANCE}`]: 'Assegurança',
  [`TRAVEL_CATEGORY_${TravelCategory.THEMATIC}`]: 'Temàtic',
  [`TRAVEL_CATEGORY_${TravelCategory.TRANSFERS}`]: 'Transfers',
  [`TRAVEL_CATEGORY_${TravelCategory.TRAINS}`]: 'Trens',
  [`TRAVEL_CATEGORY_${TravelCategory.OTHER}`]: 'Altres',
  TRAVEL_TRAVELLERS: 'Nombre de viatgers',

  // Cart Validation
  REFERENCE_CHARACTER_NOT_ALLOWED: 'Els únics caràcters especials permesos son /, \\, -, _, + i @.',
  AMOUNT_MUST_BE_NEGATIVE: "L'import ha de ser negatiu",
  AMOUNT_MUST_BE_POSITIVE: "L'import ha de ser positiu",
  VALUE_MUST_BE_POSITIVE: 'El valor ha de ser positiu',
  DOWN_PAYMENT_AMOUNT_MUST_BE_LESS_THAN_CART_AMOUNT:
    "L'import de l'entrada ha de ser inferior a l'import de la comanda",
  AMOUNT_NOT_ZERO: "L'import ha de ser diferent de 0",
  MORE_THAN_ONE_UNIT_ERROR: 'Article limitat a 1 unitat',
  AT_LEAST_ONE_UNIT_ERROR: 'Mínim 1 unitat',
  INVALID_PERCENTAGE: 'Percentatge no vàlid',
  INVALID_NEGATIVE_PERCENTAGE: 'Percentatge negatiu no vàlid',
  PAST_DATE_NOT_ALLOWED: 'Data passada no permesa',
  FUTURE_DATE_NOT_ALLOWED: 'Data futura no permesa',
  CHECKOUT_DATE_CANNOT_BE_PRIOR_TO_CHECKIN_DATE: "La data de sortida no pot ser anterior o igual a la data d'entrada",
  RETURN_DATE_CANNOT_BE_PRIOR_TO_DEPARTURE_DATE:
    "La data del vol de tornada no pot ser anterior o igual a la data del vol d'anada",
  END_DATE_CANNOT_BE_PRIOR_TO_START_DATE: "La data d'inici no pot ser anterior o igual a la data de finalització",
  FLIGHT_REFERENCE_SHOULD_HAVE_AT_LEAST_3_CHARACTERS: 'El codi de referència del vol ha de tenir almenys 3 caràcters',
  FLIGHT_REFERENCE_SHOULD_HAVE_MAX_8_CHARACTERS: 'El codi de referència del vol no pot tenir més de 8 caràcters',
  DOCUMENT_NUMBER_SHOULD_HAVE_AT_LEAST_4_CHARACTERS: 'El número de document ha de tenir com a mínim 4 caràcters',
  DOCUMENT_NUMBER_SHOULD_HAVE_MAX_15_CHARACTERS: 'El número de document no pot tenir més de 15 caràcters',
  AT_LEAST_ONE_TRAVELLER_ERROR: 'Mínim 1 passatger',

  // Cart Alerts
  CART_ALERT_ARTICLE_TOTAL: (
    <>
      El total de la comanda ha de ser <strong>positiu</strong>. Revisa l'import dels teus productes i descomptes.
    </>
  ),
  CART_ALERT_ARTICLE_INCOMPLETE: (
    <>
      Algun dels elements de la comanda és <strong>incomplet</strong>. Revisa els detalls de cada línia de la comanda.
    </>
  ),
  CART_ALERT_ITEM_ERROR: (
    <>
      La comanda o algun dels seus items presenta un <strong>error</strong>. Revisa-ho per poder continuar.
    </>
  ),
  CART_ALERT_ARTICLE_CATEGORY: (
    <>
      No hi ha cap producte amb categoria <strong>física</strong> o <strong>digital</strong>. Si us plau, revisa les
      categories dels productes introduïts.
    </>
  ),
  CART_ALERT_ARTICLE_TYPE_START: 'Es necessita incloure com a mínim un ítem de tipus',
  CART_ALERT_ARTICLE_TYPE_END: 'per poder continuar',
  CART_ALERT_ARTICLE_TYPE_SERVICE_ADDITIONAL: 'Només es permet 1 servei per comanda.',
  CART_ALERT_ARTICLE_TYPE_AUTO_ADDITIONAL: 'Només es permet 1 vehicle per comanda.',
  CART_ALERT_PAYMENT_METHODS: "No hi ha mètodes de pagament disponibles per a l'import de la comanda.",
  CART_ALERT_AGENT_CONFIGURATION: (
    <>
      Sembla que l'agent necessita <strong>sincronitzar la configuració de mètodes de pagament</strong>. Si us plau,
      contacta amb <a href="mailto:hola@nemuru.com">hola@nemuru.com</a> per informar d'aquest problema.
    </>
  ),

  // Application Payment method
  // -- ALREADY EXISTS -- PAYMENT_METHOD: 'Método de pago'
  PAYMENT_METHOD_INSTRUCTIONS: 'Habilita els mètodes de pagament per a la compra del teu client',
  PAYMENT_PROPOSAL_DETAILS: 'Detalls de la sol·licitud de pagament',

  // Application Distribution
  APPLICATION_DISTRIBUTION_TITLE: "Distribució de l'enllaç de pagament",
  APPLICATION_DISTRIBUTION_INSTRUCTIONS: "Comparteix l'enllaç de pagament amb el teu client",
  APPLICATION_DISTRIBUTION_DETAILS:
    "Envia l'enllaç per correu electrònic o SMS, mostra un codi QR o copia i distribueix l'enllaç pels teus canals.",
  SMS: 'SMS',
  SEND_LINK: 'Enviar enllaç',
  APPLICATION_SUCCESS_MESSAGE: (
    <>
      La sol·licitud ha estat enviada al teu client pel(s) mètode(s) d'enviament escollit(s). Recorda que disposa de{' '}
      <strong>30&nbsp;dies</strong> per accedir a l'enllaç i realitzar el procés de pagament. Passat aquest temps,
      l'enllaç caducarà.
    </>
  ),
  APPLICATION_DISTRIBUTION_ALERT:
    'El teu client disposa de 30 dies per accedir i completar el pagament de la primera quota.',

  // NEW CHECKOUT SESSION APPLICATION :
  SELECTED: 'Sel.leccionat',
  FOR: 'Per',
  AND: 'I',
  LOWERCASE_AND: 'i',
  FROM_AMOUNT: 'Des de',
  CONFIGURE: 'Configurar',
  PAYMENT_METHODS_TITLE: 'Mètodes de pagament',
  PAYMENT_METHODS_TEXT: 'Configura els mètodes de pagament disponibles per al teu client',
  SEE_FILTERS: 'Veure filtres',
  QUOTA: 'Quota',
  SETUP_FEE_SHORT: 'Comissió',
  [`SETUP_FEE_SHORT_${FeePaymentType.TYPE_FINANCED}`]: 'Comissió (finançada)',
  [`SETUP_FEE_SHORT_${FeePaymentType.TYPE_FIXED_AMOUNT}`]: 'Comissió (fixa/quota)',
  [`SETUP_FEE_SHORT_${FeePaymentType.TYPE_UPFRONT}`]: 'Comissió (apertura)',
  [`SETUP_FEE_TYPE_SHORT_${FeePaymentType.TYPE_FINANCED}`]: '(finançats)',
  [`SETUP_FEE_TYPE_SHORT_${FeePaymentType.TYPE_FIXED_AMOUNT}`]: '(fixes/quota)',
  [`SETUP_FEE_TYPE_SHORT_${FeePaymentType.TYPE_UPFRONT}`]: '(apertura)',

  MERCHANT_COST: 'Cost comerç',
  MERCHANT_COST_SHORT: 'Cost',
  FREE: 'Gratis',
  CONDITIONS_GROUP_NOT_FOUND_START:
    'No hi ha opcions disponibles per al termini seleccionat. Per als filtres seleccionats, els terminis disponibles van entre',
  [FilterType.WITH_GRACE_PERIOD]: 'Amb carència',
  [FilterType.WITH_MERCHANT_DISCOUNT_PERCENTAGE]: 'Amb cost de comerç',
  [FilterType.WITH_SETUP_FEE]: 'Amb comissió per el client',
  VALUE_MUST_BE_BETWEEN: "El valor ha d'estar entre",
  START_PAYMENT_METHOD: 'Iniciar mètode de pagament',
  START_PAYMENT_METHOD_DESCRIPTION: 'Fes clic en el botó per iniciar aquest mètode de pagament.',
  CREDIT_CARD_START_PAYMENT_METHOD: 'Iniciar contratació',
  CREDIT_CARD_START_PAYMENT_METHOD_DESCRIPTION:
    "Fes clic en el botó per iniciar el procés de contratació de la targeta d'Iberia Cards.",

  //CHECKOUT SESSION CREATION
  CHECKOUT_SESSION_CREATION: 'Completa el procés de pagament',
  CHECKOUT_SESSION_CREATION_DESCRIPTION: 'Selecciona com vols completar el procés de pagament',
  COMPLETE_PAYMENT_PROCESS: 'Completa el procés de pagament',
  SELECT_HOW_TO_COMPLETE_PAYMENT_PROCESS: 'Selecciona com vols completar el procés de pagament',
  SEND_TO_MY_CLIENT: 'Enviar al meu client',
  SHARE_PAYMENT_LINK: 'Compartir enllaç de sol·licitud',
  SHARE_PAYMENT_LINK_WITH_YOUR_CLIENT:
    "Comparteix l'enllaç de pagament amb el teu client. El teu client durà a terme el procés de pagament des del seu dispositiu.",
  START_MERCHANT_POS_PROCESS: 'Inicia el procés',
  MERCHANT_POS_PROCESS_DESCRIPTION:
    'Completa el procés de pagament en nom del teu client. En fer clic a continuar, consents i afirmes que el teu client es troba al punt de venda i que la seva identitat ha estat validada.',
  START_NOW: 'Inicia ara',
  LOADING_CHECKOUT_SESSION_CREATION: 'Creant la sol·licitud de pagament...',
  LOADING_CHECKOUT_SESSION_RESTORING: 'Recueperant dades de la sol·licitud de pagament...',
  MERCHANT_POS_PROCESS_NOT_ALLOWED_BY_PAYMENT_METHODS_DESCRIPTION:
    'Els mètodes de pagament seleccionats no permeten completar el procés de pagament en nom del teu client.',
  MERCHANT_POS_PROCESS_NOT_ALLOWED_BY_AGENT_DESCRIPTION:
    "La configuració de l'agent seleccionat per a la sol·licitud no permet completar el procés de pagament en nom del teu client.",
  FILL_IN_INTERVENERS_DATA: 'Omple la informació del titular (i altres intervinents)',
  FILL_IN_INTERVENER_DATA: 'Omple la informació de $v1',
  INTERVENERS: 'Intervinents',
  DOCUMENT_ID_FORM_INFO:
    "Més endavant, hauràs de pujar una foto del document d'identitat del client. Assegura't que les dades introduïdes a continuació coincideixin amb la informació que apareix en aquest document.",
  NET_INCOME_FORM_INFO:
    "Si us plau, declara els ingressos reals de $v1. Serà necessari aportar un justificant d'ingressos, com ara una nòmina, pensió o un altre document vàlid, per confirmar aquesta informació.",
  BANK_ACCOUNT_FORM_INFO:
    "Recorda que el titular ha d'aparèixer com a titular del compte bancari. Es sol·licitarà un justificant de titularitat més endavant per confirmar la veracitat de la informació.",
  RECENT_BORROWERS: 'Últims intervinents',

  //CHECKOUT SESSION DETAILS (MERCHANT)
  [`${PaymentMethodType.A2A_PAYMENT}_tab_label`]: 'Transferència immediata',
  [`${PaymentMethodType.B2B_LOAN}_tab_label`]: 'Préstec B2B',
  [`${PaymentMethodType.BNPL_INSTALMENTS}_tab_label`]: 'Pagament en quotes',
  [`${PaymentMethodType.BNPL_SPLIT_PAY}_tab_label`]: 'Fracciona el pagament',
  [`${PaymentMethodType.CONSUMER_LOAN_INSTALMENTS}_tab_label`]: 'Finançament',
  [`${PaymentMethodType.CONSUMER_LOAN_SPLIT_PAY}_tab_label`]: 'Finançament sense interessos',
  [`${PaymentMethodType.CARD_PAYMENT}_tab_label`]: 'Pagament amb targeta',
  [`${PaymentMethodType.SUBSCRIPTION}_tab_label`]: 'Subscripción',
  [`${PaymentMethodType.CREDIT_LINE}_tab_label`]: 'Línea de crédito',
  [`${PaymentMethodType.AUTO_LOAN}_tab_label`]: 'Crèdit auto',
  [`${PaymentMethodType.CARD_ONBOARDING}_tab_label`]: 'Targeta de crèdit',
  NEXT_STEPS: 'Pròxims passos',
  EDIT_BORROWER: 'Editar titular',
  EDIT_CO_BORROWER: 'Editar cotitular',
  EDIT_DATA: 'Editar dades',
  [`ADD_${OnboardingDetailsRole.CO_BORROWER}`]: 'Afegir cotitular',
  [`ADD_${OnboardingDetailsRole.GUARANTOR}`]: 'Afegir avalista',
  INVALID_PROGRESS: 'Progrés no disponible',
  ALL_ACTIONS_COMPLETED: 'Totes les accions completades',
  SEE_PROGRESS_HISTORY: 'Veure historial complet',
  SEE_PROGRESS_HISTORY_MOBILE: 'Historial',
  UPLOAD: 'Pujar',
  SEE_CLIENT_HISTORY: 'Veure historial',
  CLIENT_HISTORY: 'Historial de $v1',
  SIGNATURE_LENDER_CONTRACT: 'Contracte de $v1',
  SIGNATURE_LENDER_CONTRACT_SANTANDER: 'Redirecció a Santander',
  SIGN_CONTRACT: 'Signar',
  SIGN_BORROWER_CONTRACT: 'Signar titular',
  SIGN_CO_BORROWER_CONTRACT: 'Signar cotitular',
  CONTRACT_SIGNED_SUCCESSFULLY: 'Contracte signat correctament',
  CONTRACT_SIGNED_SUCCESSFULLY_DESCRIPTION:
    'El contracte amb l’entitat financera ha estat signat digitalment correctament. Pots tancar aquesta finestra de forma segura.',

  SIGNATURE_GENERIC_MESSAGE: 'Fes clic en signar per iniciar el procés de firma. ',
  REDIRECT_SIGNATURE_BS:
    'Abans de poder signar el contracte, el teu client ha de descarregar la informació del crèdit que rebrà mitjançant un SMS. Una vegada completat aquest pas, podràs signar digitalment el contracte.',
  REDIRECT_SIGNATURE:
    "Fes clic en signar per ser redirigit al procés de firma digital. El teu client rebrà un SMS amb el codi que hauràs d'introduir per completar la firma.",
  REDIRECT_SIGNATURE_SANTANDER:
    'Fes clic en completar, per ser redirigit a la plataforma de Santander Consumer Finance, on podràs completar la sol·licitud de finançament del teu client.',
  EMBEDDED_REDIRECT_SIGNATURE:
    'Fes clic en signar per obrir el procés de firma digital. El teu client rebrà un SMS amb el codi que hauràs d’introduir per completar la firma.',
  SAML_SIGNATURE:
    "Fes clic en signar per iniciar el procés de firma. El teu client rebrà un SMS amb el codi que hauràs d'introduir per completar la firma.",
  ASYNC_SIGNATURE_EMAIL:
    "El teu client rebrà pròximament un correu electrònic amb les instruccions per signar el contracte. Podeu indicar-li que estigueu atent a la seva safata d'entrada i revisi també la carpeta de spam o promocions.",
  ASYNC_SIGNATURE_SMS:
    'El teu client rebrà un SMS amb un enllaç per poder signar el contracte. Podeu indicar-li que revisi el seu telèfon per completar el procés.',
  SIGNATURE_FROM_CAIXABANK_APP_MESSAGE:
    'La signatura d’aquest contracte s’ha de fer des de l’app de signatura de CaixaBank P&C. Accedeix a l’app des del teu dispositiu i facilita la signatura al client.',
  RESIGNATURE_MESSAGE:
    'El contracte requereix una nova signatura. Fes clic a resignar per iniciar el procés de signatura digital',
  RESIGNATURE_CONTRACT: 'Resignar',
  LOAN_RETENTION_INTERNAL_REVIEW: "Sol·licitud en revisió interna per l'entitat financera",
  LOAN_RETENTION_CONTRACT_RESIGNATURE: 'El contracte requereix ser signat de nou',
  LOAN_RETENTION_DOCS_INCIDENCE: 'Hi han incidències documentals que cal resoldre',

  NO_CONDITIONS_AVAILABLE: 'Oops! No hi ha condicions disponibles',
  NO_CONDITIONS_AVAILABLE_DESCRIPTION:
    "Sembla que aquest mètode de pagament no té condicions disponibles per a aquesta compra. Si us plau, selecciona un altre mètode de pagament o contacta amb el teu agent per a que t'ajudi.",
  IN_ONE_CARD_PAYMENT: 'en un sol pagament amb targeta',
  IN_ONE_A2A_PAYMENT: 'en un sol pagament amb transferència bancària',

  MORE_ACTIONS: 'Més accions',
  AVAILABLE: 'Disponible',
  NOT_AVAILABLE: 'No disponible',
  NOT_STARTED: 'No començat',

  // MERCHANT POS FORM
  ID_ALREADY_USED: 'Número de document ja utilitzat',
  FULL_NAME_ALREADY_USED: 'Nom complet ja utilitzat',
  EMAIL_ALREADY_USED: 'Correu electrònic ja utilitzat',
  PHONE_NUMBER_ALREADY_USED: 'Número de telèfon ja utilitzat',

  // DISTRIBUTION DIALOG
  SHARE_PAYMENT_LINK_DESCRIPTION: "Escull com vols compartir l'enllaç de sol·licitud amb el teu client:",
  [DistributionMethod.COPY_LINK]: 'Copiar enllaç',
  [DistributionMethod.SEND_LINK]: 'Enviar enllaç',
  [DistributionMethod.SHOW_QR]: 'Mostrar QR',
  [`${DistributionMethod.COPY_LINK}_SHORT`]: 'Copiar',
  [`${DistributionMethod.SEND_LINK}_SHORT`]: 'Enviar',
  [`${DistributionMethod.SHOW_QR}_SHORT`]: 'QR',
  SHARE: 'Compartir',
  SHARE_WITH_CUSTOMER: 'Compartir link',
  SENT_TO: 'Enviat a',
  SENT_AT_TIME: "Data d'enviament",
  VIEWED_AT: 'Obert a',
  SENDING: 'Enviant...',
  MAX_DISTRIBUTIONS_ALERT_DESCRIPTION:
    "S'ha assolit el límit màxim d'enviaments de l'enllaç de pagament disponibles. Pots copiar l'enllaç i enviar-lo per altres canals, o mostrar el codi QR al teu client.",
  MAX_DISTRIBUTIONS_ALERT_DESCRIPTION_CREDIT_CARD:
    'S’ha assolit el límit màxim d’enviaments de l’enllaç de pagament disponibles.',
  AN_ERROR_OCURRED: "S'ha produït un error",
  SEE_DISTRIBUTIONS: 'Veure enviaments',
  DISTRIBUTIONS_HISTORY: "Historial d'enviaments",
  DISTRIBUTIONS_HISTORY_DESCRIPTION:
    "Aquí pots veure l'historial d'enviaments de l'enllaç de pagament a aquesta sol·licitud de pagament.",

  // CHECKOUT SESSION DETAILS
  CHECKOUT_SESSIONS: 'Sol·licituds',
  CHECKOUT_SESSION: 'Sol·licitud',
  SESSIONS: 'Sessions',
  CHECKOUT_SESSIONS_OVERVIEW: 'Vista general sol·licituds',
  CHECKOUT_SESSION_DETAIL: 'Detall de la sol·licitud',
  CHECKOUT_SESSION_DETAILS: 'Detalls de la sol·licitud',
  CHECKOUT_SESSION_OVERVIEW: 'Resum',
  CHECKOUT_SESSION_ID: 'Id sol·licitud:',
  CANCEL_CHECKOUT_SESSION: 'Cancel·lar sol·licitud de pagament',
  CANCEL_CHECKOUT_SESSION_SHORT: 'Cancel·lar sol·licitud',
  CANCEL_CHECKOUT_SESSION_DESCRIPTION: 'Vols cancel·lar la sol·licitud de pagament del teu client?',
  [DownPaymentCollection.NONE]: 'Cap',
  [DownPaymentCollection.BEFORE_CONFIRM]: 'Abans de confirmar',
  [DownPaymentCollection.UPFRONT]: 'Per avançat',
  PURCHASE_COUNTRY: 'País de compra:',
  EXPIRES_IN: 'Caduca en:',
  CONTACT_DATA: 'Dades de contacte',
  OWNER: 'Titular',
  ACTIVE_PAYMENT_METHODS: 'Mètodes de pagament habilitats',
  PAYMENT_INTENTS: 'Sol·licituds de pagament',
  PAYMENT_INTENTS_LIST_TITLE: 'Intents de pagament',
  NO_PAYMENT_INTENTS: "Encara no s'han generat sol·licituds de pagament",
  ARTICLE_IN_CART: '$v1 x $v2',
  TOTAL_TO_FINANCE: 'Total a finançar',
  TOTAL_TO_PAY: 'Total a pagar',
  [HppStatus.COMPLETED]: 'Completada',
  [HppStatus.CHALLENGE]: 'Challenge',

  // CHECKOUT SESSION DETAIL (MERCHANT EDITION)
  PROPOSAL_FOR: 'Sol·licitud per',
  EVALUATE_AND_CONFIRM: 'Mètodes de pagament',
  EVALUATE_AND_CONFIRM_TEXT: 'Processa i confirma el mètode de pagament seleccionat pel teu client',
  NOT_PROCESSED: 'No processat',
  PROCESSED: 'Processat',
  PAY: 'Pagar',
  EVALUATE: 'Avaluar',
  REEVALUATE: 'Reavaluar',
  COMPLETE: 'Completar',
  PENDING_ACTIONS: 'Accions pendents',
  [Action.COMPLETE_ONBOARDING]: 'Completar el procés de sol·licitud',
  [Action.NO_LENDER_REQUEST_ID]: "Esperant resposta de l'entitat",
  [Action.PAY]: 'Completar el pagament',
  [Action.UPLOAD_DOCUMENTS]: 'Pujar els documents requerits',
  [Action.REVIEW_DOCUMENTS]: 'Revisar els documents pujats',
  [Action.SIGN_CONTRACT]: 'Signar el contracte digitalment',
  [Action.COMPLETE_PROCESS_SANTANDER]: 'Finalitzar el procés a Santander',
  [Action.PAY_FIRST_INSTALMENT]: 'Pagar la primera quota amb targeta',
  [Action.CAPTURE_ORDER]: 'Capturar comanda',
  [Action.COMPLETE_KYC]: 'Completar la verificació d’identitat',
  [Action.VALIDATE_CARD_DATA]: 'Validar les dades de la targeta amb l’agent',
  [Action.PRINT_CARD]: 'Expedició de la targeta',
  VALIDATE_CARD_DATA_DESCRIPTION:
    'Obre el flux de validació perquè un agent revisi i validi les dades del client.',
  VALIDATE_CARD_DATA_CTA: 'Obrir validació',
  PRINT_CARD_DESCRIPTION:
    'Reenvia el QR d’expedició de la targeta al client per email perquè el comerç la pugui imprimir.',
  PRINT_CARD_CTA: 'Reenviar QR per email',
  PRINT_CARD_QR_STUB: 'El QR d’expedició de la targeta s’envia per email.',
  PRINT_CARD_SENT_SUCCESS: 'El QR d’expedició de la targeta s’ha enviat per email.',
  PAYMENT_INTENT_APPROVED_BY: 'Aprovada per',
  PAYMENT_INTENT_ON_HOLD_IN: 'En estudi a',
  PAYMENT_INTENT_TO_BE_COMPLETED: "Pots completar el procés o compartir l'enllaç perquè el vostre client el finalitzi.",
  PAYMENT_INTENT_CANCELLED: 'La sol·licitud ha estat denegada per les entitats financeres.',
  PAYMENT_INTENT_PROCESSING:
    'Si us plau, espera. La teva sol·licitud està sent processada per les entitats financeres.',
  NO_LENDER_REQUEST_ID_TITLE: 'Sense resposta de $v1',
  NO_LENDER_REQUEST_ID_TITLE_TEXT:
    "No ha estat possible obtenir una resposta de l'entitat financera en aquest moment. Una vegada s'hagi processat correctament la sol·licitud, el procés continuarà automàticament.",
  NO_SIGNATURE_AVAILABLE_TITLE: 'Firma no disponible',
  NO_SIGNATURE_PROCESS_AVAILABLE_AT_THE_MOMENT:
    'El procés de firma digital en $v1 no està disponible en aquest moment. Quan estigui disponible, podràs signar el contracte digitalment.',
  PAY_TITLE: 'Pendent pagament amb targeta',
  PAY_DESCRIPTION:
    'Has de compartir l’enllaç de pagament amb el teu client perquè pugui accedir al procés i completar el pagament. Una vegada realitzat el pagament, el procés es completarà automàticament.',

  // PROCESSING STRATEGY
  PROCESSING_STRATEGY: 'Respostes entitats financeres',
  PROCESSING_STRATEGY_MOBILE: 'Respostes entitats',
  SELECT_LOAN_APPLICATION_MANUAL_CHOOSE: 'Seleccionar entitat',
  SELECT_LOAN_APPLICATION_MANUAL_CHOOSE_TEXT:
    'Selecciona manualment l’entitat financera desitjada per continuar amb el procés de sol·licitud.',

  PROCESSING_SUMMARY_SINGLE: 'Una sola entitat disponible',
  PROCESSING_SUMMARY_SINGLE_AUTOMATIC_TEXT:
    'La sol·licitud s’envia automàticament a l’única entitat disponible. No has de fer res.',
  PROCESSING_SUMMARY_SINGLE_MANUAL_TEXT: 'Envia la sol·licitud a l’única entitat disponible des de la seva fila.',

  PROCESSING_SUMMARY_PARALLEL: 'Es consulten totes les entitats alhora',
  PROCESSING_SUMMARY_PARALLEL_TEXT:
    'La sol·licitud surt al mateix temps per a totes les entitats de la llista. Quan responen, la plataforma es queda amb la millor oferta. No has de fer res.',

  PROCESSING_SUMMARY_WATERFALL_AUTOMATIC: 'La plataforma consulta les entitats una a una',
  PROCESSING_SUMMARY_WATERFALL_AUTOMATIC_TEXT:
    'S’envia a la primera de la llista i s’espera la seva resposta abans de passar a la següent. La plataforma avança sola per l’ordre que veus a sota. No has de fer res.',

  PROCESSING_SUMMARY_WATERFALL_MANUAL: 'Tu decideixes a quina entitat enviar',
  PROCESSING_SUMMARY_WATERFALL_MANUAL_TEXT:
    'No s’envia res de forma automàtica. L’ordre de sota és la recomanació de la plataforma, però pots començar per la que vulguis. Envia la sol·licitud des de cada fila i la seva resposta apareixerà aquí.',

  [`PROCESSING_SUMMARY_STOP_${StopCondition.YES}`]:
    'S’atura quan una entitat aprova. Si una denega o falla, continua amb la següent.',
  [`PROCESSING_SUMMARY_STOP_${StopCondition.MAYBE}`]:
    'S’atura quan una entitat aprova o deixa la sol·licitud en estudi. Si una denega o falla, continua amb la següent.',
  [`PROCESSING_SUMMARY_STOP_${StopCondition.NO}`]:
    'S’atura amb la primera entitat que contesti, encara que denegui. No hi haurà un segon intent automàtic.',
  [`PROCESSING_SUMMARY_STOP_${StopCondition.ERROR}`]:
    'S’atura amb la primera entitat que contesti, sigui quina sigui la resposta. A la pràctica només es consulta una entitat.',

  DOCUMENTATION_SYNC_IN_PROGRESS: 'Un moment...',
  DOCUMENTATION_SYNC_IN_PROGRESS_TEXT:
    'Estem consultant els documents requerits per l’entitat seleccionada. Espereu uns segons.',
  DOCUMENTATION_SYNC_COMPLETED: 'Documentos sincronizados',
  DOCUMENTATION_SYNC_COMPLETED_TEXT:
    'Els documents requerits per l’entitat seleccionada han estat sincronitzats correctament. Pots tancar aquesta finestra i pujar els documents per completar la sol·licitud.',

  SELECTED_PAYMENT_METHOD: 'Mètode de pagament seleccionat',
  OTHER_PAYMENT_METHODS: 'Altres mètodes de pagament',

  // CHECKOUT SESSION DETAIL - EDIT
  EDIT_CHECKOUT_SESSION_ACTION_CART: 'Editar comanda',
  EDIT_CHECKOUT_SESSION_ACTION_CART_AUTO: 'Editar vehicle',
  EDIT_CHECKOUT_SESSION_ACTION_DOWN_PAYMENT: 'Editar entrada',
  EDIT_LEAVE_ALERT_TITLE: 'Abandonar edició',
  EDIT_LEAVE_ALERT_DESCRIPTION: 'Atenció, si tanques el diàleg, les teves modificacions es perdran.',
  EDIT_PAYMENT_METHOD_CONDITIONS: 'Editar configuració del mètode de pagament',
  EDIT_PAYMENT_METHOD_CONDITIONS_INSTRUCTIONS:
    'Selecciona una nova configuració pel mètode de pagament del teu client:',
  CART_EDIT: 'Editar comanda',
  CART_EDIT_INSTRUCTIONS: 'Edita el detall de la comanda de la sol·licitud:',
  EDIT_AUTO_PAYMENT_METHOD: 'Editar dades de sol·licitud',
  CART_EDIT_AUTO: 'Editar vehicle',
  EDIT_VEHICLE_DATA: 'Editar vehicle',
  SPECS_TAB: 'Vehicle',
  FINANCING_TAB: 'Finançament',
  VEHICLE_AMOUNT_REQUIRES_FINANCING_RESELECTION_DESCRIPTION:
    "L'import i/o la data de matriculació del vehicle ha canviat. Selecciona noves condicions al simulador abans de continuar.",
  LIVE_SUMMARY: 'Resum',
  BORROWER_SUMMARY: 'Detalls del titular',
  FINANCING_SUMMARY: 'Finançament',
  EDIT_VEHICLE_DATA_IN_LENDER_PLATFORM:
    "L'entitat financera no permet modificar les dades del vehicle des de la nostra plataforma. Si us plau, accedeix a la plataforma de $v1 per fer els canvis. Disculpa les molèsties.",
  MISSING_VEHICLE_DATA_WARNING: 'Falten dades del vehicle necessàries per signar el contracte',
  SIGNATURE_MISSING_VEHICLE_DATA_EDITABLE:
    'Per signar el contracte, completa les dades del vehicle. Has de **LINK**editar les dades del vehicle**LINK**.',
  SIGNATURE_MISSING_VEHICLE_DATA_NOT_EDITABLE:
    'Les dades del vehicle no es poden modificar des de la nostra plataforma.',
  MISSING_VEHICLE_DATA_WARNING_EDIT_IN_PLATFORM:
    'Recorda que en el moment de realitzar la firma del contracte és necessari haver informat el número de bastidor (VIN) i la matrícula per a la firma. Pots fer-ho des del menú "Editar" a la part superior dreta.',
  MISSING_VEHICLE_DATA_WARNING_EDIT_IN_LENDER:
    'Recorda que en el moment de realitzar la firma del contracte és necessari haver informat el número de bastidor (VIN) i la matrícula per a la firma. Has de fer la modificació a l’aplicatiu de l’entitat financera',
  MISSING_VEHICLE_REGISTRATION_NUMBER_WARNING_EDIT_IN_PLATFORM:
    'Recorda que en el moment de realitzar la firma del contracte és necessari haver informat el número de bastidor (VIN) per a la firma. Pots fer-ho des del menú "Editar" a la part superior dreta.',
  MISSING_VEHICLE_REGISTRATION_NUMBER_WARNING_EDIT_IN_LENDER:
    'Recorda que en el moment de realitzar la firma del contracte és necessari haver informat el número de bastidor (VIN) per a la firma. Has de fer la modificació a l’aplicatiu de l’entitat financera.',
  MISSING_VEHICLE_LICENSE_PLATE_WARNING_EDIT_IN_PLATFORM:
    'Recorda que en el moment de realitzar la firma del contracte és necessari haver informat la matrícula per a la firma. Pots fer-ho des del menú "Editar" a la part superior dreta.',
  MISSING_VEHICLE_LICENSE_PLATE_WARNING_EDIT_IN_LENDER:
    'Recorda que en el moment de realitzar la firma del contracte és necessari haver informat la matrícula per a la firma. Has de fer la modificació a l’aplicatiu de l’entitat financera',
  CHANGE_DATA: 'Modificar dades',
  REQUEST_TO_LENDER_DELAY_WARNING:
    'Aquesta operació pot tardar uns segons a completar-se. Si us plau, espera mentre comuniquem els canvis amb l’entitat financera...',
  AUTO_MODIFICATION_PREVIEW_ERROR: "No s'ha pogut previsualitzar el canvi de les dades del vehicle",
  AUTO_MODIFICATION_SAME_LENDER_INVALID: "L'entitat actual ja no és vàlida",
  AUTO_MODIFICATION_SAME_LENDER_INVALID_DESCRIPTION:
    "Amb les noves condicions, l'entitat financera actual ja no és vàlida. No és possible modificar les condicions.",
  AUTO_MODIFICATION_ORDER_WOULD_CHANGE: 'Condicions no òptimes',
  AUTO_MODIFICATION_ORDER_WOULD_CHANGE_DESCRIPTION:
    "Es modificaran les condicions a l'entitat financera actual. Amb aquest canvi, la sol·licitud deixarà de comptar amb la millor oferta segons les tarifes disponibles.",
  AUTO_MODIFICATION_ORDER_WOULD_CHANGE_OPTIMAL_LENDER: "L'oferta òptima s'aconseguiria amb $v1.",
  CART_EDIT_INSTRUCTIONS_AUTO: 'Edita el detall del vehicle de la sol·licitud:',
  ALERT_CART_NO_CHANGES: 'Per continuar, has de fer canvis a la comanda.',
  ALERT_VEHICLE_NO_CHANGES: 'Per continuar, has de fer canvis al vehicle',
  REVIEW_CHANGES: 'Revisar canvis',
  CHANGES_REVIEW: 'Revisa els canvis',
  CHANGES_REVIEW_DESCRIPTION:
    'Aquestes son les modificacions realitzades en la teva sol·licitud. Revisa atentament els canvis abans de continuar.',
  NEW_FINANCING_CONDITIONS: 'Noves condicions de finançament',
  NEW_VEHICLE_DETAILS: 'Nous detalls del vehicle',
  EDIT_APPLICATION: 'Editar sol·licitud',
  EDIT_APPLICATION_TOOLTIP: 'Editar les condicions de la sol·licitud i dades del vehicle',
  EDIT_FINANCING_DETAILS: 'Editar finançament',
  EDIT_FINANCING_DETAILS_TOOLTIP: 'Selecciona les noves condicions de finançament de la teva sol·licitud.',
  EDIT_VEHICLE_TOOLTIP: 'Editar les dades del vehicle',
  ORIGINAL_CART: 'Comada original',
  ORIGINAL_VEHICLE: 'Vehicle original',
  NEW_CART: 'Comanda nova',
  NEW_VEHICLE: 'Vehicle nou',
  NEW_PAYMENT_METHODS_CONFIRMATION: 'Confirmar nous mètodes de pagament disponibles',
  NOTE: 'Nota',
  NEW_PAYMENT_METHODS_CONFIRMATION_NOTE: (
    <>
      {'Hi ha hagut una variació en el '}
      <b>{'total de la comanda'}</b>
      {' que afectaria a les mètodes de pagament disponibles per al teu client:'}
    </>
  ),
  ORIGINAL_CONDITIONS: 'Configuració original',
  NEW_CONDITIONS: 'Configuració nova',
  NEW_PAYMENT_METHODS_CONFIRMATION_CHANGE_ALERT:
    'Algun dels mètodes de pagament no és compatible amb les teves modificacions.',
  NEW_PAYMENT_METHODS_CONFIRMATION_CHANGE_DESCRIPTION:
    'Estàs segur de que vols continuar?. Els mètodes de pagament indicats es deshabilitaran.',
  NEW_PAYMENT_METHODS_CONFIRMATION_NOT_COMPATIBLE_ALERT:
    'Cap dels mètodes de pagament és compatible amb les teves modificacions.',
  NEW_PAYMENT_METHODS_CONFIRMATION_NOT_COMPATIBLE_DESCRIPTION:
    'Si us plau, per mantenir la sol·licitud és necessari que tornis enrere i revisis el total de la comanda.',
  WARNING: 'Atenció',
  EDIT_CONFIRM_ALERT_DESCRIPTION:
    'Estas segur de que vols enviar sol·litud de canvis?. Aquesta operació no es pot desfer.',
  EDIT_CONFIRM_ALERT_BUTTON: 'Confirmar i enviar',
  PAYMENT_METHOD_RESTORE_ERROR_TITLE: 'Modificació no disponible',
  PAYMENT_METHOD_RESTORE_ERROR_DESCRIPTION: (
    <>
      {'No ha estat possible recuperar les condicions de este mètode de pagament.'}
      <p>{"És possible que ya no estigui disponible per l'agent i l'import a finançar associats a la sol·licitud."}</p>
    </>
  ),
  DOWN_PAYMENT_EDIT: 'Editar entrada',
  DOWN_PAYMENT_EDIT_DESCRIPTION: "Modifica l'import de l'entrada de la sol·licitud:",
  OLD_VALUES: 'Valors antics',
  ALERT_DISABLED_DOWN_PAYMENT_EDIT: "Per continuar, canvia el valor de l'entrada.",

  //SINGLE PAYMENT DETAIL
  SINGLE_PAYMENT: 'Pagament únic',
  PROVIDER: 'Proveïdor',
  CARD_PAYMENT_DETAIL: 'Detall del pagament amb targeta',
  SINGLE_PAYMENT_OVERVIEW: 'Resum',
  A2A_PAYMENT_OVERVIEW: 'Resum pagament per transferència',
  A2A_PAYMENT_DETAIL: 'Detall del pagament per transferència',
  PRODUCT_ID: 'ID producte',
  MERCHANT_KEY: 'Clau comerciant',
  MERCHANT_PASSWORD: 'Contrasenya comerciant',
  EXPIRED_AT: 'Caduca en:',

  //CARD LIST
  CARD: 'Targeta',
  CREDIT_CARD: 'Targeta de crèdit',
  CREDIT_CARD_LIST: 'Targetes de crèdit',
  CARD_LIST: 'Targetes',
  CARD_DETAIL: 'Detall targeta',
  CARD_SUBSECTION_TITLE: 'Llistat de targetes',
  CARD_OVERVIEW: 'Resum targeta',
  [PetitionType.BORROWER]: 'Particular',
  [PetitionType.BUSINESS]: 'Empresa',
  [PaymentMode.END_OF_MONTH]: 'Fi de mes',
  [PaymentMode.FIXED_INSTALLMENT]: 'Quota fixa',
  [PaymentMode.PERCENTAGE_CONTRACT_LIMIT]: 'Percentatge límit contracte',
  [PaymentMode.PERCENTAGE_USED_LIMIT]: 'Percentatge límit utilitzat',
  [PaymentMode.ROUND_INSTALLMENT]: 'Quota redondead',
  PAYMENT_MODE: 'Modo de pagament',
  MONTHLY_STATEMENT_DAY: 'Dia de cobrament',
  CARD_REQUESTED_LIMIT: 'Límit de crèdit',
  FIXED_INSTALMENT_AMOUNT: 'Quota fixa',
  PRE_CARD_REQUESTED: 'Targeta pre-sol·licitada',

  //IBERIA CREDIT CARD
  CREDIT_CARD_ID: 'ID de la targeta de crèdit',
  CREDIT_CARD_OVERVIEW: 'Resum',
  CREDIT_CARD_DETAILS: 'Detalls de la targeta',
  CREDIT_CARD_CONFIGURATION: 'Configuració de la targeta',
  CARD_TYPE: 'Tipus de targeta',
  BRAND_TYPE_AND_PRODUCT: 'Marca/Tipus/Producte',
  MARKETING_CAMPAIGN: 'Campanya de marketing',
  APPLICATION_ORIGIN: 'Origen',
  CORPORATE_GROUP: 'Grup corporatiu',
  CUSTOMER_TYPE: 'Tipus de client',
  PROVIDER_NAME: 'Proveïdor',
  HOLDER_NAME: 'Nom complet en targeta',
  CONTRACT: 'Contracte',
  CONTRACT_DETAILS: 'Detalls del contracte',
  CONTRACT_SIGNATURE: 'Firma de contracte',
  CONTRACT_SIGNATURE_PENDING: 'Firma de contracte pendent',
  CONTRACT_SIGNED: 'Contracte signat',
  CONTRACT_SENT_ON: 'Enviat el $v1',
  CONTRACT_SIGNED_ON: 'Firmat el $v1',
  CONTRACT_SEND: 'Enviament de contracte',
  PENDING_CONTRACT_SEND: "Pendent d'enviament de contracte",
  SIGNATURE_PENDING: 'Firma pendent',
  CREDIT_CARD_CONDITIONS: 'Condicions de la targeta de crèdit',
  [CreditCardName.ZENIT]: 'Iberia Zenit',
  [CreditCardName.AIRE]: 'Iberia Aire',
  [CreditCardName.ICON]: 'Iberia Icon',
  APPLICATION_PROCESS: 'Procés de sol·licitud',
  PERSONAL_DATA: 'Informació personal',
  BIRTH_NATIONALITY: 'País de naixement',
  ADDITIONAL_INFORMATION: 'Informació addicional',
  PROFESSIONAL_DATA: 'Informació professional',
  BANK_ACCOUNT_DATA: 'Informació bancària',
  STEP: 'Pas',
  USER_AGENT: 'Agent',
  IP: 'IP',
  WORKFLOW_TYPE: 'Tipus de procés',
  WORKFLOW_PROGRESS: 'Resum del procés',
  CREDIT_CARD_PROGRESS: 'Progres de la targeta de crèdit',
  CURRENT_STEP_PROGRESS: 'Progres actual',
  COMPLETED_STEPS: 'Passos completats',
  SPOUSE_EMPLOYED: 'La teva parella treballa?',
  MONTHLY_EXPENSES: 'Gast mensual altres crèdits',
  GROSS_INCOME: 'Ingressos bruts anuals',
  IBERIA_CLUB: 'Iberia Club',
  IBERIA_CARD_ID: "ID sol·licitud d'Iberia Cards",
  IBERIA_CLUB_NUMBER: 'Número Iberia Club',
  [WorkflowPlace.INVITATION]: 'Invitació',
  [WorkflowPlace.KYC_OCR]: 'OCR',
  [WorkflowPlace.PERSONAL_INFO]: 'Informació personal',
  [WorkflowPlace.ADDITIONAL_INFO]: 'Informació addicional',
  [WorkflowPlace.ADDRESS]: 'Adreça',
  [WorkflowPlace.PROFESSIONAL_DETAILS]: 'Informació professional',
  [WorkflowPlace.BANK_ACCOUNT]: 'Informació bancària',
  [WorkflowPlace.SUMMARY]: 'Resum',
  [WorkflowPlace.LOW_LIMIT]: 'Límit de crèdit',
  [WorkflowPlace.GDPR]: 'GDPR',
  [WorkflowPlace.INE]: 'INE',
  [WorkflowPlace.CONTRACT_SIGNATURE]: 'Firma de contracte',
  [WorkflowPlace.KYC_ADDITIONAL_DOCUMENTATION]: 'NIE EU',
  [WorkflowPlace.KYC_VIDEO]: 'Vídeo de identificació',
  [WorkflowPlace.DOCUMENTATION]: 'Documentació',
  [WorkflowPlace.IBERIA_CLUB]: 'Iberia Club',
  CREDIT_CARD_STATUS_INITIAL: 'Iniciada',
  CREDIT_CARD_STATUS_ON_HOLD: 'En estudi',
  CREDIT_CARD_STATUS_REQUESTED: 'Sol·licitada',
  CREDIT_CARD_STATUS_APPROVED: 'Preaprovada',
  CREDIT_CARD_STATUS_CONFIRMED: 'Confirmada',
  CREDIT_CARD_STATUS_CAPTURED: 'Capturada',
  CREDIT_CARD_STATUS_SIGNED: 'Signada',
  CREDIT_CARD_STATUS_PAID: 'Completada',
  CREDIT_CARD_STATUS_DESISTED: 'El client ha desistit',
  CREDIT_CARD_STATUS_EXPIRED: 'Caducat',
  CREDIT_CARD_STATUS_CANCELLED: 'Cancel·lada',
  CREDIT_CARD_STATUS_DENIED: 'Denegada',

  // SINGLE PAYMENT LIST
  A2A_PAYMENTS_LIST: 'Transferències immediates',
  A2A_PAYMENT_SUBSECTION_TITLE: 'Llistat de transferències immediates',

  CARD_PAYMENTS_LIST: 'Pagaments amb targeta',
  CARD_PAYMENT_SUBSECTION_TITLE: 'Llistat de pagaments amb targeta',

  // LOADING FEATURES
  AGENT_IN_LENDER_CONTEXT: 'Credencials en entitats financeres',
  MERCHANT_TO_DO_LIST: 'Accions pendents',
  MERCHANT: 'Merchant',
  MERCHANT_IN_LENDER_STRUCTURE: 'Entitats financeres',
  AGENT_PRICINGS: "Tarifes d'agent",
  LOAN_DETAILS_OVERVIEW: 'Detalls del préstec',
  BORROWER_CASH_IN_CASH_OUT_DETAILS: 'Detalls de la banca',
  LOAN_ASSET_DETAILS: "Detalls de l'actiu",
  KYC_LOAN: 'Informació personal',
  BORROWER_KYC: 'Informació del prestatari',
  LOAN_APPLICATIONS: "Respostes d'entitats bancàries",
  PAYOUT_SUMMARY: 'Resum de pagament',
  COMPLETE_CLIENT_DATA: "Escull un mètode per enviar l'enllaç de pagament i completa les dades del teu client:",
  COPY_LINK_AND_SHARE: "Copia l'enllaç i comparteix-lo amb el teu client:",
  PAYMENT_LINK_HAS_BEEN_CREATED: "L'enllaç de pagament ha estat creat!",
  ENABLE_DISTRIBUTION_METHODS: "Habilita els mètodes d'enviament per compartir-ho amb el teu client:",
  OR_SHARE_IT_DIRECTLY: 'o bé comparteix-ho directament:',
  SHOW_QR: 'Mostrar QR',
  SHOW_QR_TO_SHARE: 'Demana al teu client que escanegi el QR per completar el pagament:',
  OPEN_LINK: 'Visitar',
  NO_DATA_TO_DISPLAY: 'No hi ha dades per mostrar',

  INVALID_UUID: 'UUID invàlid',

  // INTEGRATIONS
  INTEGRATIONS: 'Integracions',
  WEBHOOKS: 'Webhooks',
  WEBHOOKS_MERCHANT_TEXT: (
    <>
      <p>
        {
          "La teva aplicació pot subscriure's per rebre notificacions d'esdeveniments a Nemuru a una URL que triïs. Rebràs notificacions dels següents esdeveniments:"
        }
      </p>
      <ul>
        <li>
          <code>{'checkout_session_status_changed'}</code>
          {": L'estat de la sessió de pagament ha canviat."}
        </li>
        <li>
          <code>{'payment_intent_status_changed'}</code>
          {": L'estat de l'intent de pagament ha canviat."}
        </li>
        <li>
          <code>{'conditions_changed'}</code>
          {': Quan canvien les condicions del mètode de pagament.'}
        </li>
        <li>
          <code>{'capture_approved'}</code>
          {': Notificació que la captura ha estat aprovada.'}
        </li>
        <li>
          <code>{'refund_approved'}</code>
          {': Notificació que el reemborsament ha estat aprovat.'}
        </li>
      </ul>
      <p>
        {'Consulta la nostra '}
        <a className="underline" href="https://docs.nemuru.com/webhook-api" target="_blank">
          {'documentació tècnica'}
        </a>
        {' per a més informació sobre les dades que enviem a les notificacions (contrasenya: '}
        <code>{'Nemuru2024!'}</code>
        {').'}
      </p>
    </>
  ),
  WEBHOOKS_LIST: 'Llistat de webhooks',
  CREATE_NEW_WEBHOOK: 'Crear nou webhook',
  NO_WEBHOOK_CONFIGURED: 'No hi ha cap webhook configurat',
  ADD_WEBHOOK: 'Afegir webhook',
  EDIT_WEBHOOK: 'Editar webhook',
  DELETE_WEBHOOK: 'Eliminar webhook',
  THE_FOLLOWING_WEBHOOK_WILL_BE_DELETED: 'El següent webhook serà eliminat:',
  WEBHOOK_URL: 'URL del webhook',
  WEBHOOK_URL_HINT:
    'Enviarem sol·licituds HTTP POST a aquesta URL quan es produeixin esdeveniments. Esperem una resposta positiva amb un estat 2XX; en cas contrari, tornarem a intentar el callback fins a 5 vegades.',
  AUTHORIZATION_TYPE: "Tipus d'autorització",
  AUTHORIZATION_HEADER: "Header d'autorització",
  ADDITIONAL_PAYLOAD: 'Payload addicional',
  REQUIRED_SELECT_FIELD: 'Si us plau, sel·lecciona una opció',
  [`AuthorizationType_${AuthorizationType.NO_AUTH}`]: 'Sense autorització',
  [`AuthorizationType_${AuthorizationType.BASIC}`]: 'Autorització bàsica',
  [`AuthorizationType_${AuthorizationType.OAUTH_2}`]: 'Autorització OAuth 2.0',

  //USERS CONFIGURATION
  LOADING_INFORMATION_NEEDED: 'Carregant informació',
  ADMINS_CREDENTIALS: 'Credencials dels administradors',
  [`${UserCredentialsType.AGENT}_TAB_LABEL`]: 'Agents',
  [`${UserCredentialsType.ADMIN}_TAB_LABEL`]: 'Administradors',
  CREATE_NEW_AGENT: 'Crear nou agent',
  CREATE_NEW_CHANNEL: 'Crear nou canal',
  CREATE_NEW_ADMIN: 'Crear nou administrador',
  [`${UserCredentialsType.CHANNEL}_BTN`]: 'Crear canal',
  [`${UserCredentialsType.AGENT}_BTN`]: 'Crear agent',
  [`${UserCredentialsType.ADMIN}_BTN`]: 'Crear administrador',
  [`${UserCredentialsType.CHANNEL}_TITLE`]: 'Crear nou canal',
  [`${UserCredentialsType.AGENT}_TITLE`]: 'Crear nou agent',
  [`${UserCredentialsType.AGENT}_PASSWORD`]: "Contrasenya de l'agent",
  [`${UserCredentialsType.ADMIN}_TITLE`]: 'Crear nou administrador',
  [`${UserCredentialsType.ADMIN}_PASSWORD`]: "Contrasenya de l'administrador",
  [`${UserCredentialsType.ADMIN}_EMAIL`]: "Correu de l'administrador",
  CHANNEL_USERS: 'Usuaris del canal',
  NO_AGENTS_IN_CHANNEL: 'Encara no hi ha agents al canal',
  USER_CREDENTIALS_AGENTS: "Credencials d'agents",
  LOADING_AGENTS: 'Carregant agents...',

  // SIMULATOR
  SIMULATOR: 'Simulador',
  SELECT_CONDITION_FROM_SIMULATOR: 'Selecciona una condició des del simulador',
  MAXIMIZE: 'Ampliar',

  // DOCUMENTS VALIDATION
  DECLARED_DATA: 'Informació declarada',
  STEP_X_OF_Y: 'Pas $v1 de $v2',
  DOCUMENT: 'Document',
  VALIDATE: 'Validar',
  DO_NOT_VALIDATE: 'Marcar com a no vàlid',
  DOCUMENTS_VALIDATION_ERROR_DESCRIPTION:
    'Si us plau, torna a intentar-ho més tard. Si el problema persisteix, contacta amb el nostre equip de suport a: support@nemuru.com',
  DOCUMENTS_VALIDATION_INITIAL_TITLE: 'Validació documental',
  DOCUMENTS_VALIDATION_INITIAL_DESCRIPTION: "Benvingut/da al procés de validació per a l'emissió d'una nova targeta.",
  ENTER_CLIENT_DATA: 'Introdueix el DNI/NIE del teu client',
  CLIENT_DOCUMENT_ID: 'DNI/NIE del client',
  CLIENT_DOCUMENT_ID_MISMATCH: 'El DNI/NIE introduit no coincideix amb el del client',
  CLIENT_DOCUMENT_ID_ERROR: "No s'han pogut trobar les dades del document d'identitat",
  CLOSE_VALIDATION_TITLE: '¿Vols reiniciar la validació?',
  CLOSE_VALIDATION_DESCRIPTION:
    'Si reinicies, hauràs de tornar a començar el procés de validació, introduïnt el DNI/NIE del titular de la sol·licitud.',
  ID_VALIDATION_CHECKBOX:
    "He validat el document d'identitat proporcionat amb el que s'em presenta i amb la persona. Acredito que els tres coincideixen.",
  ID_VALIDATION_ERROR: "No s'han pogut trobar les dades per a la validació del document d'identitat.",
  DOCUMENT_ID_FACE_PICTURE: "Fotografia del document d'identitat",
  BIOMETRICS_FACE_PICTURE: 'Fotografia de la vídeoidentificació',
  VIDEO_ID_VALIDATION_CHECKBOX:
    'He validat la qualitat de la vídeoidentificació i les seves verificacions automàtiques. Confirmo que els dos rostres proporcionats coincideixen.',
  VIDEO_ID_VALIDATION_ERROR: "No s'han pogut trobar les dades per a la validació de la vídeoidentificació.",
  BANK_ACCOUNT_VALIDATION_CHECKBOX:
    'He validat que el compte bancari i els noms de titularitat facilitats coincideixen amb els del document. Acredito que el document és valid.',
  BANK_ACCOUNT_VALIDATION_ERROR:
    "No s'han pogut trobar les dades per a la validació de la titularitat del compte bancari.",
  INCOME_VALIDATION_CHECKBOX:
    'He validat que les dades proporcionades coincideixin amb les del document. Acredito que el document és vàlid.',
  INCOME_VALIDATION_ERROR: "No s'han pogut trobar les dades per a la validació de les dades socioeconòmiques.",
  DOCUMENTS_VALIDATION_CONFIRMATION: 'Dades validades correctament',
  DOCUMENTS_VALIDATION_CONFIRMATION_SUCCESS: 'Felicitats! Has completat la validació de les dades.',
  DOCUMENTS_VALIDATION_CONFIRMATION_DESCRIPTION:
    "Felicitats! Has completat la validació de les dades. El client rebrà un codi QR al seu correu electrònic per procedir a l'emissió de la targeta de crèdit. En el cas que el client no hagi rebut cap correu, fes clic al botó de més abaix per tornar-lo a enviar.",
  SEND_EMAIL_AGAIN_DESCRIPTION_PART_1: 'En el cas que el client no hagi rebut cap correu, fes clic ',
  SEND_EMAIL_AGAIN_DESCRIPTION_PART_2: ' per tornar-lo a enviar.',
  SEND_EMAIL_AGAIN: 'Tornar a enviar correu',
  SEND_EMAIL_AGAIN_DIALOG: 'Vols tornar a enviar el correu a la direcció $v1?',
  NO_DOCUMENT_FOUND: "No s'ha trobat el document",
  WE_WERE_NOT_ABLE_TO_FIND_THE_DOCUMENT:
    "No hem pogut trobar el document necessari per procedir amb la validació. Confirma amb el client que s'ha pujat correctament el document en qüestió i torna a intentar-ho.",
  HERE: 'aquí',
  DOCUMENTS_VALIDATION_CONFIRMATION_ERROR_TITLE: "No s'ha pogut validar la documentació",
  DOCUMENTS_VALIDATION_CONFIRMATION_ERROR:
    "Al no tenir tota la documentació validada, no és possible realitzar l'emissió de la targeta de crèdit. Per poder avançar en el procés, comunica al client que ha de tornar a pujar els següents documents:",
  CONFIRMATION_NEXT_STEP_1: 'Hem enviat un correu a $v1 amb el codi QR.',
  CONFIRMATION_NEXT_STEP_2: "Escaneja el codi QR des de l'app de captació.",
  CONFIRMATION_NEXT_STEP_3: "Completa el procés a l'app de captació per a l'emissió de la targeta.",
  RESET_VALIDATION: 'Reiniciar validació',
  RESET: 'Reiniciar',
  NO_LOAN_FOUND: 'Solicitud no trobada',
  NO_DOCUMENTATION_FOUND: "No s'ha trobat la documentació associada a aquesta sol·licitud",
  CANCELLED_CARD: 'Aquesta sol·licitud de targeta ha estat cancel·lada',
  CANCEL_CARD: 'Cancel·lar sol·licitud',
  CANCEL_CARD_DESCRIPTION: 'Vols cancel·lar aquesta sol·licitud de targeta de crèdit?',

  // COMPLETE KYC ACTION STEP
  KYC_STEP_FAILED_TITLE: 'Verificació d’identitat rebutjada',
  KYC_STEP_PENDING_TITLE: 'Verificació d’identitat pendent',
  KYC_STEP_INITIAL_TITLE: 'Verificació d’identitat requerida',

  KYC_STEP_HARD_FAILED_DESCRIPTION_P1:
    'S’ha arribat al nombre màxim d’intents permesos per a la verificació d’identitat.',
  KYC_STEP_HARD_FAILED_DESCRIPTION_P2: (
    <>
      Si creus que hi ha hagut un error, pots trucar-nos al <strong>+34 932 200 612</strong> perquè revisem el cas.
    </>
  ),

  KYC_STEP_PENDING_DESCRIPTION_P1_NO_EMAIL:
    'El $v1 rebrà pròximament un correu electrònic amb les instruccions per completar la verificació d’identitat.',
  KYC_STEP_PENDING_DESCRIPTION_P1:
    'El $v2 rebrà pròximament un correu electrònic a $v1 amb les instruccions per completar la verificació d’identitat.',
  KYC_STEP_PENDING_DESCRIPTION_P2:
    'Pots indicar-li que estigui atent a la safata d’entrada i que revisi també la carpeta de correu brossa o promocions.',

  KYC_STEP_PENDING_BUTTON_TEXT: 'Reenviar correu',
  KYC_STEP_SOFT_FAILED_BUTTON_TEXT: 'Reintentar verificació',

  KYC_STEP_DISCLAIMER: 'Recorda que sempre pots verificar la identitat del $v1 de manera presencial.',

  KYC_STEP_SOFT_FAILED_DESCRIPTION_P1: 'La verificació d’identitat ha estat rebutjada.',
  KYC_STEP_SOFT_FAILED_DESCRIPTION_P2: 'Alguns motius habituals són:',
  KYC_STEP_SOFT_FAILED_DESCRIPTION_P3: (
    <>
      <ul style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 32 }}>
        <li>Document caducat o en mal estat</li>
        <li>Imatges poc clares</li>
        <li>Dades que no coincideixen</li>
      </ul>
    </>
  ),
  KYC_STEP_SOFT_FAILED_DESCRIPTION_P4: 'Pots reenviar el correu per tornar-ho a intentar.',

  KYC_STEP_INITIAL_DESCRIPTION_P1:
    'Per continuar amb la sol·licitud, cal enviar al $v1 un correu electrònic amb les instruccions per completar la verificació d’identitat.',
  KYC_STEP_INITIAL_BUTTON_TEXT: 'Enviar correu',

  KYC_STEP_PRESENTIAL_VERIFICATION_TEXT: 'Verificar presencialment',

  KYC_STEP_PRESENTIAL_VERIFICATION_MODAL_TEXT_1:
    'En continuar, confirmes que has verificat presencialment la identitat del $v1 i que les seves dades són correctes.',
  KYC_STEP_PRESENTIAL_VERIFICATION_MODAL_TEXT_2: (
    <>
      <ul
        style={{
          marginTop: 0,
          marginBottom: 0,
          paddingInlineStart: 32,
          display: 'flex',
          gap: '4px',
          flexDirection: 'column',
        }}
      >
        <li>La persona present és qui sol·licita el finançament</li>
        <li>El document d’identitat ha estat comprovat</li>
      </ul>
    </>
  ),
  KYC_ERROR_SENDING_VERIFICATION_EMAIL:
    'No hem pogut enviar el correu en aquest moment. Torna-ho a intentar d’aquí a uns minuts.',
  KYC_ERROR_PERFORMING_MANUAL_VERIFICATION:
    'No hem pogut confirmar la verificació presencial en aquest moment. Torna-ho a intentar d’aquí a uns minuts.',
  KYC_TITULAR: 'Titular',
  KYC_COTITULAR: 'Cotitular',
  KYC_COMPLETED_VERIFICATION_TEXT: 'Verificació d’identitat completada',
  KYC_COMPLETED_VERIFICATION_TEXT_SECTION: 'Verificacions completades',
  KYC_STEP_PRESENTIAL_VERIFICATION_BUTTON_TEXT: 'Confirmar',
  [`KYC_OWNER_LABEL_${KycIntegrationMethodOwner.BORROWER}`]: 'titular',
  [`KYC_OWNER_LABEL_${KycIntegrationMethodOwner.COWORROWER}`]: 'cotitular',

  [`DOCUMENTS_VALIDATION_STEP_${ValidationStep.DOCUMENT_NUMBER_VALIDATION}`]: 'Número de document',
  [`DOCUMENTS_VALIDATION_STEP_${ValidationStep.DOCUMENT_ID_VALIDATION}`]: "Document d'identitat",
  [`DOCUMENTS_VALIDATION_STEP_${ValidationStep.VIDEO_ID_VALIDATION}`]: 'Vídeo identificació',
  [`DOCUMENTS_VALIDATION_STEP_${ValidationStep.BANK_ACCOUNT_VALIDATION}`]: 'Titularitat de compte',
  [`DOCUMENTS_VALIDATION_STEP_${ValidationStep.INCOME_VALIDATION}`]: "Dades d'ingressos",
  [`DOCUMENTS_VALIDATION_STEP_${ValidationStep.CONFIRMATION}`]: 'Confirmació',

  // CREDIT CARD CHECKOUT SESSION
  CREDIT_CARD_PURCHASE_TITLE: 'Continuar amb la contractació',
  CREDIT_CARD_PURCHASE_FIRST_INSTRUCTIONS:
    'Hi ha una sol·licitud de targeta de crèdit en curs. Prem continuar per reprendre el procés amb el client.',
  CREDIT_CARD_PURCHASE_SECOND_INSTRUCTIONS_1: (
    <>
      Per continuar amb la contractació, fes clic a <strong>"Compartir enllaç"</strong> i envia’l al client per correu
      electrònic o SMS.
    </>
  ),
  CREDIT_CARD_PURCHASE_SECOND_INSTRUCTIONS_2: (
    <>
      Assegura’t que el{' '}
      <strong>client completi el procés només a través d’aquest enllaç i des del seu propi dispositiu.</strong>
    </>
  ),
  CREDIT_CARD_PURCHASE_STANDS_SUPERVISOR_PRE_SCORING_INSTRUCTIONS:
    'La sol·licitud encara no ha completat el resum. L’agent de l’estand l’ha de completar amb el client fins a aquest pas; a partir d’aleshores podràs continuar-la o compartir l’enllaç.',
  CREDIT_CARD_PURCHASE_CONTINUE: 'Continuar',
  [`APPLICATION_IBERIA_CARDS_STEP_${ApplicationIberiaCardsStep.SALE_POINT_AND_PRODUCT}`]: 'Nova alta de targeta',
  [`APPLICATION_IBERIA_CARDS_STEP_${ApplicationIberiaCardsStep.SHORT_CONTACT_FORM}`]: 'Dades de contacte del titular',
  [`${postCreditCardIberiaCards.name}_rejected`]: "No s'ha pogut crear la sol·licitud. Torna-ho a provar.",
  [`${postCreatePaymentIntent.name}_rejected`]: "No s'ha pogut iniciar la contractació. Torna-ho a provar.",
  CARD_AND_CAMPAIGN: 'Targeta / Campanya',
  IBERIA_CARDS_CAMPAIGN_GROUP_INDIVIDUALS: 'Particulars',
  IBERIA_CARDS_CAMPAIGN_GROUP_IBERIA_EMPLOYEES: 'Empleats Iberia',
  IBERIA_CARDS_CAMPAIGN_GROUP_CORPORATE_GROUPS: 'Col·lectius',
  MOBILE_PHONE_NUMBER: 'Número de telèfon mòbil',
  IBERIA_CARDS_STANDS_AGENT_NOT_CONFIGURED: 'El teu usuari no està configurat per operar en estands.',
  IBERIA_CARDS_STANDS_AGENT_NOT_CONFIGURED_DESCRIPTION:
    'Contacta amb el teu supervisor perquè et habiliti els punts de venda.',
  IBERIA_CARDS_APPLICATION_NOT_AVAILABLE: 'La creació de sol·licituds no està disponible per al teu usuari.',
  IBERIA_CARDS_APPLICATION_NOT_AVAILABLE_DESCRIPTION:
    "Només els agents d'estands poden crear sol·licituds de targeta. Si creus que hauries de tenir-hi accés, contacta amb el teu supervisor.",
  IBERIA_CARDS_STANDS_SALE_POINT_AND_PRODUCT_INTRO: 'Confirma el punt de venda i el producte a contractar.',
  IBERIA_CARDS_STANDS_SHORT_CONTACT_FORM_INTRO:
    "Introdueix les dades personals del titular exactament com apareixen al seu document d'identitat.",
  IBERIA_CARDS_STANDS_DOCUMENT_MATCH_HINT: 'igual que al DNI/NIE',
  IBERIA_CARDS_STANDS_DOCUMENT_NUMBER: 'DNI/NIE',
  IBERIA_CARDS_DATA_PROTECTION_OPT_IN: (
    <>
      {'Confirmo que Iberia Cards ha posat a la meva disposició la informació bàsica sobre la '}
      <Link
        href="https://www.iberiacards.es/proteccion-datos/"
        target="_blank"
        rel="noopener noreferrer"
        color="inherit"
        underline="always"
      >
        <strong>{'Protecció de Dades'}</strong>
      </Link>
      {' i, en concret, sobre els tractaments de les meves dades que es realitzaran en el procés de contractació.'}
    </>
  ),
  CREDIT_CARD_FETCH_ERROR_TITLE: 'Informació de la targeta no disponible',
  CREDIT_CARD_FETCH_ERROR_DESCRIPTION:
    "No s'ha pogut accedir a les dades de la targeta en aquest moment. Si us plau, torna-ho a intentar.",
  CREDIT_CARD_FETCH_ERROR_BTN_LABEL: 'Torna-ho a intentar',
  CREDIT_CARD_SMS_SENT_TOAST: 'SMS enviat',

  // ERROR BOUNDARY
  ERROR_GENERIC: 'Hi ha hagut un error al processar la teva sol·licitud.',
  ERROR_BOUNDARY_TEXT: 'Hi ha hagut un error al carregar la pàgina. Si us plau, torna a intentar-ho més tard.',
  ERROR_BOUNDARY_TEXT_ASYNC:
    'Hi ha hagut un error al processar la teva sol·licitud. Si us plau, torna a intentar-ho més tard.',
  ERROR_BOUNDARY_TEXT_CONTACT: 'Si el problema persisteix, no dubtis a contactar amb el nostre equip de suport:',
  ERROR_MESSAGE_ZOD_SCHEMA: "Error a la validació de l'esquema de dades",
  RELOAD_PAGE: 'Tornar a carregar pàgina',

  APPLICATION_HISTORY: 'Historial de sol·licitud',
  APPLICATION_PROGRESS: 'Progrés de la sol·licitud',

  //REQUEST NOTIFICATION MESSAGES
  [`${patchSetAgentConfiguration.name}_fulfilled`]: "S'ha actualitzat la configuració de l'agent.",
  [`${patchSetAgentConfiguration.name}_rejected`]: "L'actualització de la configuració de l'agent ha fallat.",
  [`${patchSetPricingIdsToAgent.name}_fulfilled`]: "S'han modificat les tarifes assignades correctament",
  [`${patchSetPricingIdsToAgent.name}_rejected`]: 'Ha sorgit un problema en intentar modificar les tarifes assignades',
  [`${postCreateAgent.name}_fulfilled`]: 'Nou agent creat correctament.',
  [`${postCreateAgent.name}_rejected`]: "Ha surgit un problema en intentar crear l'agent.",
  [`${postSyncPricingsToCdnByAgentId.name}_fulfilled`]: "Les tarifes s'han pujat correctament al CDN",
  [`${postSyncPricingsToCdnByAgentId.name}_rejected`]: 'Ha sorgit un problema en intentar pujar les tarifes al CDN',
  [`${postCreateChannel.name}_fulfilled`]: 'Nou canal creat correctament.',
  [`${postCreateChannel.name}_rejected`]: 'Ha surgit un problema en intentar crear el canal.',
  [`${patchChangeUserId.name}_fulfilled`]: "S'han canviat les credencials d'usuari correctament",
  [`${patchChangeUserId.name}_rejected`]: "S'ha produït un problema a l'intentar canviar les credencials d'usuari",
  [`${patchChangeAgentIdChannel.name}_fulfilled`]: "L'agent s'ha canviat de canal correctament.",
  [`${patchChangeAgentIdChannel.name}_rejected`]: "Ha sorgit un problema en intentar canviar l'agent de canal.",
  [`${patchChangeApprovalStatusByMerchantId.name}_fulfilled`]: 'Canvi realitzat correctament.',
  [`${patchChangeApprovalStatusByMerchantId.name}_rejected`]: 'Ha sorgit un problema en intentar realitzar el canvi.',
  [`${patchChangeMerchantStatusByMerchantId.name}_fulfilled`]: 'Canvi realitzat correctament.',
  [`${patchChangeMerchantStatusByMerchantId.name}_rejected`]: 'Ha sorgit un problema en intentar realitzar el canvi.',
  [`${postCreateMerchant.name}_fulfilled`]: 'Nou comerciant creat correctament.',
  [`${postCreateMerchant.name}_rejected`]: 'Ha sorgit un problema en intentar crear el nou comerciant.',
  [`${postCreateMerchantData.name}_fulfilled`]: 'Nou comerciant creat correctament.',
  [`${postCreateMerchantData.name}_rejected`]: 'Ha sorgit un problema en intentar crear el nou comerciant.',
  [`${patchSetLegalAddress.name}_fulfilled`]: 'Adreça fiscal actualitzada correctament.',
  [`${patchSetLegalAddress.name}_rejected`]: "Ha sorgit un problema en intentar actualitzar l'adreça fiscal.",
  [`${patchSetNieData.name}_fulfilled`]: 'Dades actualitzades correctament.',
  [`${patchSetNieData.name}_rejected`]: 'Ha sorgit un problema en intentar actualitzar les dades NIE.',
  [`${patchUpdateCashInCashOutMethodByMerchantId.name}_fulfilled`]:
    "S'ha actualitzat la informació bancària correctament.",
  [`${patchUpdateCashInCashOutMethodByMerchantId.name}_rejected`]:
    'Ha sorgit un problema en actualitzar la informació.',
  [`${patchAddCashInCashOutMethodByMerchantId.name}_fulfilled`]: "S'ha afegit la informació bancària correctament.",
  [`${patchAddCashInCashOutMethodByMerchantId.name}_rejected`]:
    'Ha sorgit un problema en afegir la informació bancària.',
  [`${patchChangeAcquisitionChannelByMerchantId.name}_fulfilled`]:
    "Canal d'adquisició del comerciant modificat correctament",
  [`${patchChangeAcquisitionChannelByMerchantId.name}_rejected`]:
    "Ha sorgit un problema en modificar el canal d'adquisició",
  [`${patchChangeRegistrationFieldsByMerchantId.name}_fulfilled`]:
    'Dades de registre del comerciant modificades correctament',
  [`${patchChangeRegistrationFieldsByMerchantId.name}_rejected`]:
    'Ha sorgit un problema en modificar les dades de registre.',
  [`${patchUpdateCashInCashOutMethod.name}_fulfilled`]: "S'ha actualitzat la informació bancària correctament.",
  [`${patchUpdateCashInCashOutMethod.name}_rejected`]: 'Ha sorgit un problema en actualitzar la informació.',
  [`${patchBlockUser.name}_fulfilled`]: 'Credencials bloquejades correctament',
  [`${patchBlockUser.name}_rejected`]: 'Ha sorgit un problema en intentar bloquejar les credencials',
  [`${patchUnblockUser.name}_fulfilled`]: 'Credencials habilitades correctament',
  [`${patchUnblockUser.name}_rejected`]: 'Ha sorgit un problema en intentar habilitar les credencials',
  [`${postAgentInLenderContext.name}_fulfilled`]: 'La creació de noves credencials ha fallat',
  [`${postAgentInLenderContext.name}_rejected`]: "S'han creat correctament les noves credencials",
  [`${patchSetAgentIdInLenderContextById.name}_fulfilled`]: "S'han modificat correctament les credencials",
  [`${patchSetAgentIdInLenderContextById.name}_rejected`]: 'La modificació de les credencials ha fallat',
  [`${deleteAgentInLenderContextById.name}_fulfilled`]: "S'han eliminat correctament les credencials",
  [`${deleteAgentInLenderContextById.name}_rejected`]: "No s'han pogut eliminar les credencials",
  [`${patchChangeType.name}_fulfilled`]: 'Tipus de canal modificat correctament',
  [`${patchChangeType.name}_rejected`]: 'Ha surgit un problema en intentar modificar el tipus de canal',
  [`${patchChangeDescription.name}_fulfilled`]: 'Descripció de canal modificada correctament',
  [`${patchChangeDescription.name}_rejected`]: 'Ha surgit un problema en intentar modificar la descripció del canal',
  [`${patchUpdateDeclaredIncome.name}_fulfilled`]: 'Ingressos declarats actualitzats amb èxit',
  [`${patchUpdateDeclaredIncome.name}_rejected`]: "No s'ha pogut actualitzar els ingressos declarats",
  [`${patchUpdateInvitationByType.name}_fulfilled`]: 'Dades de la invitació modificades correctament',
  [`${patchUpdateInvitationByType.name}_rejected`]:
    'Ha sorgit un problema en la modificació de les dades de la invitació',
  [`${patchSetBusinessDetailsToBusinessOnboardingDetails.name}_fulfilled`]:
    "Detalls de l'empresa actualitzats correctament",
  [`${patchSetBusinessDetailsToBusinessOnboardingDetails.name}_rejected`]:
    "Ha surgit un problema en intentar actualitzar els detalls de l'empresa",
  [`${patchSetHoldersToBusinessOnboardingDetails.name}_fulfilled`]: "Titulars de l'empresa actualitzats correctament",
  [`${patchSetHoldersToBusinessOnboardingDetails.name}_rejected`]:
    "No s'ha pogut actualitzar els titulars de l'empresa",
  [`${postSendEmailForNewVideoId.name}_fulfilled`]:
    'Correu per a sol·licitud de nova identificació de vídeo enviat correctament',
  [`${postSendEmailForNewVideoId.name}_rejected`]:
    "S'ha produït un error en enviar el correu per a la nova identificació de vídeo",
  REQUEST_PATCH_UN_SIGN_LOAN_LENDER_BORROWER_CONTRACT_FULFILLED: "S'ha anul·lat la signatura de contracte correctament",
  REQUEST_PATCH_UN_SIGN_LOAN_LENDER_BORROWER_CONTRACT_REJECTED:
    'Hi va haver un problema en anul·lar la signatura del contracte',
  [`${patchUnSignLoanLenderBorrowerContract.name}_fulfilled`]: "S'ha anul·lat la signatura de contracte correctament",
  [`${patchUnSignLoanLenderBorrowerContract.name}_rejected`]:
    'Hi va haver un problema en anul·lar la signatura del contracte',
  [`${patchSetLenderRequestId.name}_fulfilled`]: 'ID de sol·licitud modificat correctament',
  [`${patchSetLenderRequestId.name}_rejected`]: "Hi va haver un problema en modificar l'ID de la sol·licitud",
  [`${patchUpdateBorrowerContractLoan.name}_fulfilled`]: 'Dades actualitzades amb èxit',
  [`${patchUpdateBorrowerContractLoan.name}_rejected`]: 'Ha sorgit un problema al actualitzar les dades',
  [`${patchUpdatePaymentDateByPaymentLineId.name}_fulfilled`]: 'Data de pagament actualitzada correctament',
  [`${patchUpdatePaymentDateByPaymentLineId.name}_rejected`]:
    "S'ha produït un problema en actualitzar la data de pagament",
  [`${patchUpdatePaymentPlanLineStatus.name}_fulfilled`]: 'Estat de pagament canviat correctament',
  [`${patchUpdatePaymentPlanLineStatus.name}_rejected`]: "S'ha produït un problema en canviar l'estat de pagament",
  [`${patchSignLoanLenderBorrowerContract.name}_fulfilled`]:
    "S'ha marcat el contracte d'aquesta sol·licitud com a signat",
  [`${patchSignLoanLenderBorrowerContract.name}_rejected`]:
    "Ha sorgit un problema en marcar el contracte d'aquesta sol·licitud com a signat",
  [`${patchSetBorrowerOnboardingDetailsByRole.name}_fulfilled`]: 'Intervinent correctament afegit a la sol·licitud',
  [`${patchSetBorrowerOnboardingDetailsByRole.name}_rejected`]:
    "Ha sorgit un problema en afegir l'intervinent a la sol·licitud",
  [`${patchSendDocumentationIncidenceNotification.name}_fulfilled`]:
    "La notificació d'incidència s'ha enviat correctament",
  [`${patchSendDocumentationIncidenceNotification.name}_rejected`]:
    "S'ha produït un error a l'enviar la notificació d'incidència",
  [`${patchUpdatePaymentPlanLineSentDate.name}_fulfilled`]:
    'Correu electrònic de sol·licitud de pagament de la quota enviat correctament al client',
  [`${patchUpdatePaymentPlanLineSentDate.name}_rejected`]:
    'Hi va haver un problema en enviar el correu electrònic de sol·licitud de pagament de la quota al client',
  [`${patchAddRequiredFileTypeToDocumentationRequired.name}_fulfilled`]: 'Document sol·licitat correctament',
  [`${patchAddRequiredFileTypeToDocumentationRequired.name}_rejected`]:
    'Ha sorgit un problema en la sol·licitud de nou document',
  [`${patchSetDocumentRequiredIsNotSent.name}_fulfilled`]: 'Document marcat correctament com a no enviat',
  [`${patchSetDocumentRequiredIsNotSent.name}_rejected`]:
    "S'ha produït un problema en marcar el document com a no enviat",
  [`${patchUploadFileToDocumentationRequired.name}_fulfilled`]: 'Documentació carregada correctament',
  [`${patchUploadFileToDocumentationRequired.name}_rejected`]:
    'Ha sorgit un problema durant la càrrega de la documentació',
  [`${patchSetDocumentStatus.name}_fulfilled`]: 'Estat del document canviat correctament',
  [`${patchSetDocumentStatus.name}_rejected`]: "Ha sorgit un problema en canviar l'estat del document",
  [`${patchSyncBorrowerDocumentationByLoanId.name}_fulfilled`]: 'Documentació sincronitzada correctament',
  [`${patchSyncBorrowerDocumentationByLoanId.name}_rejected`]:
    'Ha sorgit un problema durant la sincronització de la documentació ',
  [`${patchUploadDocumentationToLender.name}_fulfilled`]: "Documentació enviada a l'entitat financera correctament",
  [`${patchUploadDocumentationToLender.name}_rejected`]:
    "Ha sorgit un problema en enviar la documentació a l'entitat financera",
  [`${patchRemoveRequiredFileTypeFromDocumentationRequired.name}_fulfilled`]:
    'Document sol·licitat eliminat correctament',
  [`${patchRemoveRequiredFileTypeFromDocumentationRequired.name}_rejected`]:
    'Ha sorgit un problema en eliminar el document sol·licitat',
  [`${patchAddPricingSpecInLenderContextInPricingSpec.name}_fulfilled`]: 'Codi de tarifa afegit correctament.',
  [`${patchAddPricingSpecInLenderContextInPricingSpec.name}_rejected`]:
    'Ha surgit un problema en afegir el codi de tarifa.',
  [`${patchRemovePricingSpecInLenderContextFromPricingSpecByLenderId.name}_fulfilled`]:
    'Codi de tarifa eliminat correctament.',
  [`${patchRemovePricingSpecInLenderContextFromPricingSpecByLenderId.name}_rejected`]:
    'Ha surgit un problema en eliminar el codi de tarifa.',
  [`${patchSetBrandInformationAndUploadLogoToCDN.name}_fulfilled`]:
    "S'ha actualitzat la informació de branding correctament.",
  [`${patchSetBrandInformationAndUploadLogoToCDN.name}_rejected`]:
    'Ha sorgit un problema en actualitzar la informació.',
  [`${postCreateUser.name}_fulfilled`]: 'Noves credencials creades correctament.',
  [`${postCreateUser.name}_rejected`]: 'Ha sorgit un problema en intentar crear les credencials.',
  [`${patchChangeLoanStatus.name}_fulfilled`]: "El canvi d'estat de la sol·licitud s'ha processat correctament",
  [`${patchChangeLoanStatus.name}_rejected`]: "Ha sorgit un problema en canviar l'estat de la sol·licitud",
  [`${patchProcessLoanApplicationInLenderManually.name}_fulfilled`]:
    "S'ha canviat l'estat d'aprovació de l'entitat financera correctament",
  [`${patchProcessLoanApplicationInLenderManually.name}_rejected`]:
    "Hi va haver un problema en canviar l'estat d'aprovació de l'entitat financera",
  [`${patchSetAreDocumentsConfirmed.name}_fulfilled`]: 'Documentació confirmada correctament',
  [`${patchSetAreDocumentsConfirmed.name}_rejected`]: 'Ha sorgit un problema en confirmar la documentació',
  [`${patchCreateSignatureReminderRequestForMerchantContract.name}_fulfilled`]:
    "S'ha enviat un recordatori de la signatura del contracte al comerciant correctament.",
  [`${patchCreateSignatureReminderRequestForMerchantContract.name}_rejected`]:
    'Ha sorgit un problema en enviar un recordatori de la signatura del contracte al comerciant.',
  [`${patchCreateSignatureRequestForMerchantContract.name}_fulfilled`]:
    "S'ha enviat un nou contracte al comerciant correctament.",
  [`${patchCreateSignatureRequestForMerchantContract.name}_rejected`]:
    'Ha sorgit un problema en enviar el nou contracte al comerciant.',
  [`${postCreateCheckoutSession.name}_fulfilled`]: 'Sol·licitud de pagament creada',
  [`${postCreateCheckoutSession.name}_rejected`]: "S'ha produït un problema en crear la sol·licitud de pagament.",
  [`${patchSetRangesForAgent.name}_fulfilled`]: 'Límits de tarifes modificats correctament',
  [`${patchSetRangesForAgent.name}_rejected`]: 'Ha sorgit un problema en modificar els límits de les tarifes',
  [`${deleteCheckoutSessionByCheckoutSessionId.name}_fulfilled`]:
    "La sol·licitud de pagament s'ha cancel·lat correctament",
  [`${deleteCheckoutSessionByCheckoutSessionId.name}_rejected`]:
    'Ha sorgit un problema en cancel·lar el procés de pagament',
  patchCreateApplicationsByPaymentMethodType_rejected: 'Ha sorgit un problema amb la evaluació de la sol·licitud',
  [`${patchUpdateLoanApplicationInLender.name}_fulfilled`]:
    "S'han modificat correctament les dades a l'entitat financera",
  [`${patchUpdateLoanApplicationInLender.name}_rejected`]:
    "Ha sorgit un problema en intentar modificar les dades a l'entitat financera",
  [`${patchUpdateLoanConditionsByPricingIdPrincipalAndPeriod.name}_fulfilled`]:
    "S'han modificat correctament les condicions del préstec",
  [`${patchUpdateLoanConditionsByPricingIdPrincipalAndPeriod.name}_rejected`]:
    'Hi ha hagut un problema en intentar modificar les condicions del préstec',
  [`${postCloneOrUpdateAgent.name}_fulfilled`]: "S'ha creat/actualitzat l'agent correctament",
  [`${postCloneOrUpdateAgent.name}_rejected`]: "Hi ha hagut un problema en intentar crear/actualitzar l'agent",
  [`${patchUpdateBorrowerDetails.name}_rejected`]:
    "La combinació de correu electrònic i telèfon introduïts no coincideixen amb la informació registrada d'aquest client",
  [`${patchSetCart.name}_fulfilled`]: "S'ha actualitzat correctament la sol·licitud",
  [`${patchSetCart.name}_rejected`]: 'Ha sorgit un problema en intentar modificar la sol·licitud',
  [`${patchUpdateDownPayment.name}_fulfilled`]: "S'ha actualitzat correctament la sol·licitud",
  [`${patchUpdateDownPayment.name}_rejected`]: 'Ha sorgit un problema en intentar modificar la sol·licitud',
  [`${patchUpdatePaymentMethodOptions.name}_fulfilled`]:
    "S'ha actualitzat correctament la configuració del mètode de pagament de la sol·licitud",
  [`${patchUpdatePaymentMethodOptions.name}_rejected`]:
    'Ha sorgit un problema en intentar modificar la configuració del mètode de pagament de la sol·licitud',
  [`${patchPaymentMethodModification.name}_fulfilled`]: "S'han actualitzat correctament les dades del vehicle",
  [`${patchPaymentMethodModification.name}_rejected`]:
    'Ha sorgit un problema en intentar actualitzar les dades del vehicle',
  [`${postPaymentMethodModificationPreview.name}_rejected`]:
    'Ha sorgit un problema en intentar previsualitzar els canvis de les dades del vehicle',

  // ─── Document Extractor Dialog ────────────────────────────────────────────────
  // Dialog
  DOCUMENT_EXTRACTOR_BUTTON_TEXT: 'Emplenar amb IA',
  DOCUMENT_EXTRACTOR_DIALOG_TITLE: 'Emplenar amb IA',
  DOCUMENT_EXTRACTOR_DIALOG_DESCRIPTION:
    'Carrega la documentació que tens per extreure automàticament les dades i emplenar el formulari.',
  DOCUMENT_EXTRACTOR_EXTRACT: 'Extreure',
  DOCUMENT_EXTRACTOR_CONFIRM_AND_PREFILL: 'Confirmar i emplenar',
  DOCUMENT_EXTRACTOR_EXTRACTING: 'Extraient documents...',
  DOCUMENT_EXTRACTOR_APPLYING: 'Aplicant dades extretes...',
  DOCUMENT_EXTRACTOR_DROP_FILES: 'Arrossega arxius aquí o fes clic per seleccionar',
  DOCUMENT_EXTRACTOR_FILE_SIZE_LIMIT_PREFIX: 'màx.',
  DOCUMENT_EXTRACTOR_FILE_SIZE_LIMIT_SUFFIX: 'MB per arxiu',
  DOCUMENT_EXTRACTOR_DRAG_REORDER_HINT:
    'Arrossega per reordenar — els documents més amunt a la llista tenen prioritat.',
  // Pre-fill confirmation
  DOCUMENT_EXTRACTOR_PREFILL_CONFIRM_TITLE: 'Emplenar el formulari amb les dades extretes?',
  DOCUMENT_EXTRACTOR_PREFILL_CONFIRM_DESCRIPTION:
    'Els camps del formulari que ja estiguessin omplerts i coincideixin amb les dades extretes seran sobreescrits. Aquesta acció no es pot desfer.',
  // File entry row
  DOCUMENT_EXTRACTOR_DATA_TITLE: 'Dades extretes',
  DOCUMENT_EXTRACTOR_NO_EXTRACTED_DATA_YET: "Aquest document encara no s'ha processat.",
  DOCUMENT_EXTRACTOR_EXPAND_ALL: 'Expandir tot',
  DOCUMENT_EXTRACTOR_COLLAPSE_ALL: 'Contraure tot',
  DOCUMENT_EXTRACTOR_STATUS_EXTRACTED: 'Extret',
  DOCUMENT_EXTRACTOR_STATUS_FAILED: 'Fallat',
  DOCUMENT_EXTRACTOR_STATUS_PENDING: 'Pendent',
  DOCUMENT_EXTRACTOR_DOC_TYPE_AUTO_DETECT: 'Detecció automàtica',
  DOCUMENT_EXTRACTOR_REMOVE_FILE_TITLE: 'Eliminar arxiu?',
  DOCUMENT_EXTRACTOR_REMOVE_FILE_DESCRIPTION: 'serà eliminat de la llista.',
  DOCUMENT_EXTRACTOR_DUPLICATE_DOC_TYPE_WARNING:
    "S'han detectat diversos documents del mateix tipus. El document més amunt a la llista té prioritat.",
  DOCUMENT_EXTRACTOR_EXTRACTION_FAILED_SELECT_TYPE:
    'Extracció fallida. Selecciona un tipus de document i torna-ho a intentar.',
  DOCUMENT_EXTRACTOR_LOW_CONFIDENCE_PREFIX: 'Confiança baixa',
  DOCUMENT_EXTRACTOR_REVIEW_DATA: 'Revisa les dades extretes amb cura.',
  DOCUMENT_EXTRACTOR_HIGH_PAGE_COUNT_PREFIX: 'Aquest PDF té',
  DOCUMENT_EXTRACTOR_HIGH_PAGE_COUNT_SUFFIX: "pàgines. Només s'ha processat la primera pàgina rellevant.",
  // Document type labels
  DOCUMENT_EXTRACTOR_TYPE_DNI_FRONT: 'DNI (front)',
  DOCUMENT_EXTRACTOR_TYPE_DNI_BACK: 'DNI (revers)',
  DOCUMENT_EXTRACTOR_TYPE_DNI_FRONT_BACK: 'DNI (front i revers)',
  DOCUMENT_EXTRACTOR_TYPE_NIE_FRONT: 'NIE (front)',
  DOCUMENT_EXTRACTOR_TYPE_NIE_BACK: 'NIE (revers)',
  DOCUMENT_EXTRACTOR_TYPE_NIE_EU_GREEN_CARD: 'NIE (carta verda)',
  DOCUMENT_EXTRACTOR_TYPE_PAYROLL: 'Nòmina',
  DOCUMENT_EXTRACTOR_TYPE_PENSION_REVALUATION: 'Revalorització de pensió',
  DOCUMENT_EXTRACTOR_TYPE_PERSONAL_INCOME_TAX: 'Declaració de la renda',
  DOCUMENT_EXTRACTOR_TYPE_BANK_CERTIFICATE: 'Certificat bancari',
  DOCUMENT_EXTRACTOR_TYPE_VEHICLE_INSPECTION: 'Inspecció tècnica de vehicle',
  // Validation errors
  DOCUMENT_EXTRACTOR_ERROR_UNSUPPORTED_FORMAT: 'format no compatible. Formats acceptats:',
  DOCUMENT_EXTRACTOR_ERROR_FILE_TOO_LARGE: 'supera la mida màxima de',
  DOCUMENT_EXTRACTOR_ERROR_EXTRACTION_FAILED: 'Extracció fallida. Si us plau, torna-ho a intentar.',
  DOCUMENT_EXTRACTOR_ERROR_RETRY_FAILED: 'Reintent fallit. Si us plau, torna-ho a intentar.',
  DOCUMENT_EXTRACTOR_ERROR_PDF_ROTATE_FAILED: 'Error en rotar el PDF. Si us plau, torna-ho a intentar.',

  // LENDER ORCHESTRATION (MERC-135)
  LENDER_ORCHESTRATION: 'Orquestració de lenders',
  LENDER_ORCHESTRATION_SUBTITLE: 'Repartiment de sol·licituds',
  LENDER_ORCHESTRATION_SUBTITLE_TEXT: 'Configuració per mètode de pagament, aplicada a tots els agents del merchant.',
  LENDER_ORCHESTRATION_COLUMN_STRATEGY: 'Enviament',
  LENDER_ORCHESTRATION_COLUMN_MODE: 'Mode',
  LENDER_ORCHESTRATION_COLUMN_STOP: 'Aturada',
  LENDER_ORCHESTRATION_COLUMN_RANKING: 'Rànquing',
  LENDER_ORCHESTRATION_MIXED: 'Mixt',
  LENDER_ORCHESTRATION_UNIFY: 'Unificar',
  LENDER_ORCHESTRATION_DEFAULT_TAG: 'default',
  LENDER_ORCHESTRATION_PRIORITY_LENDER_CELL: 'Entitat prioritària ·',
  LENDER_ORCHESTRATION_API_INFO_TITLE: 'Merchants integrats per API',
  LENDER_ORCHESTRATION_API_INFO_TEXT: 'Poden fixar una altra orquestració a cada sessió de checkout. Aquesta configuració és la que s\'aplica quan la sessió no indica res.',
  LENDER_ORCHESTRATION_LOAD_ERROR: 'No s\'ha pogut carregar l\'orquestració de lenders',
  CONFIGURATION_ERROR: 'Error de configuració',
  LENDER_ORCHESTRATION_STRATEGY_PARALLEL: 'Paral·lel',
  LENDER_ORCHESTRATION_STRATEGY_PARALLEL_SUMMARY: 'Totes alhora',
  LENDER_ORCHESTRATION_STRATEGY_PARALLEL_DESCRIPTION: 'La sol·licitud surt alhora cap a totes les entitats. Quan responen, el rànquing tria entre les que aproven. Màxima aprovació; més consultes del client a burós.',
  LENDER_ORCHESTRATION_STRATEGY_WATERFALL: 'Cascada',
  LENDER_ORCHESTRATION_STRATEGY_WATERFALL_SUMMARY: 'Una a una',
  LENDER_ORCHESTRATION_STRATEGY_WATERFALL_DESCRIPTION: 'S\'envia a la primera del rànquing i s\'espera la resposta abans de passar a la següent. S\'atura amb la resposta que triïs al punt 3. Menys petjada a burós i control del repartiment.',
  LENDER_ORCHESTRATION_MODE_AUTOMATIC: 'Automàtic',
  LENDER_ORCHESTRATION_MODE_AUTOMATIC_TITLE: 'La plataforma, automàticament',
  LENDER_ORCHESTRATION_MODE_AUTOMATIC_SUMMARY: 'Avança sola quan arriba cada resposta',
  LENDER_ORCHESTRATION_MODE_AUTOMATIC_DESCRIPTION: 'La sol·licitud avança per l\'ordre del rànquing tan bon punt arriba cada resposta. El teu equip no ha de fer res.',
  LENDER_ORCHESTRATION_MODE_MANUAL: 'Manual',
  LENDER_ORCHESTRATION_MODE_MANUAL_TITLE: 'El teu equip, a mà',
  LENDER_ORCHESTRATION_MODE_MANUAL_SUMMARY: 'El teu equip envia i registra cada resposta',
  LENDER_ORCHESTRATION_MODE_MANUAL_DESCRIPTION: 'Res no s\'envia automàticament: el teu equip processa manualment cada sol·licitud. El rànquing és només una recomanació.',
  LENDER_ORCHESTRATION_STOP_YES: 'Aprovada',
  LENDER_ORCHESTRATION_STOP_YES_TITLE: 'Quan una aprova',
  LENDER_ORCHESTRATION_STOP_YES_SUMMARY: 'Només una aprovació atura',
  LENDER_ORCHESTRATION_STOP_YES_DESCRIPTION: 'Només una aprovació atura la cascada. Si una entitat falla, rebutja o deixa la sol·licitud en estudi, es consulta la següent.',
  LENDER_ORCHESTRATION_STOP_MAYBE: 'Aprovada o en estudi',
  LENDER_ORCHESTRATION_STOP_MAYBE_TITLE: 'Quan una aprova o estudia',
  LENDER_ORCHESTRATION_STOP_MAYBE_SUMMARY: 'També una resposta en estudi',
  LENDER_ORCHESTRATION_STOP_MAYBE_DESCRIPTION: 'Una entitat que es queda l\'operació en estudi ja atura la cascada. Si falla o rebutja, es consulta la següent.',
  LENDER_ORCHESTRATION_STOP_NO: 'Primera resposta',
  LENDER_ORCHESTRATION_STOP_NO_TITLE: 'Amb la primera que contesti',
  LENDER_ORCHESTRATION_STOP_NO_SUMMARY: 'Qualsevol resposta, excepte fallada tècnica',
  LENDER_ORCHESTRATION_STOP_NO_DESCRIPTION: 'Aprovar, deixar en estudi o rebutjar aturen la cascada. Només en cas d\'una fallada tècnica passa a la següent.',
  LENDER_ORCHESTRATION_STOP_ERROR: 'Només la primera',
  LENDER_ORCHESTRATION_STOP_ERROR_TITLE: 'Només la primera, passi el que passi',
  LENDER_ORCHESTRATION_STOP_ERROR_SUMMARY: 'Una sola entitat, passi el que passi',
  LENDER_ORCHESTRATION_STOP_ERROR_DESCRIPTION: 'Només es consulta la primera entitat del rànquing. Sigui quina sigui la resposta, fins i tot una fallada tècnica, no se\'n consulta cap més.',
  LENDER_ORCHESTRATION_CHOOSE_MIN_APR: 'Menor cost i TAE',
  LENDER_ORCHESTRATION_CHOOSE_MIN_APR_SUMMARY: 'Primer la més barata per a tu, després menor TAE',
  LENDER_ORCHESTRATION_CHOOSE_MIN_APR_DESCRIPTION: 'Primer l\'entitat que menys et costa. A igualtat de cost, la de menor TAE per al teu client.',
  LENDER_ORCHESTRATION_CHOOSE_MAX_PROFITABILITY: 'Major rendibilitat',
  LENDER_ORCHESTRATION_CHOOSE_MAX_PROFITABILITY_SUMMARY: 'Primer la més rendible per a tu',
  LENDER_ORCHESTRATION_CHOOSE_MAX_PROFITABILITY_DESCRIPTION: 'Primer l\'entitat amb què l\'operació és més rendible per a tu.',
  LENDER_ORCHESTRATION_CHOOSE_SHARE_OF_WALLET: 'Preferir 0% d\'interès',
  LENDER_ORCHESTRATION_CHOOSE_SHARE_OF_WALLET_SUMMARY: 'Primer les entitats al 0% d\'interès',
  LENDER_ORCHESTRATION_CHOOSE_SHARE_OF_WALLET_DESCRIPTION: 'Si alguna entitat ofereix 0% d\'interès al client, va primer. Entre diverses al 0%, la que menys et costa.',
  LENDER_ORCHESTRATION_CHOOSE_PRIORITY_LENDER_THEN_PRICE: 'Entitat prioritària, després preu',
  LENDER_ORCHESTRATION_CHOOSE_PRIORITY_LENDER_THEN_PRICE_SUMMARY: 'Una entitat fixa primer, la resta per preu',
  LENDER_ORCHESTRATION_CHOOSE_PRIORITY_LENDER_THEN_PRICE_DESCRIPTION: 'L\'entitat que triïs va sempre primer si té tarifa per a l\'operació. La resta, per menor cost i TAE.',
  LENDER_ORCHESTRATION_CHOOSE_BORROWER_SELECTION: 'Tria el client',
  LENDER_ORCHESTRATION_CHOOSE_BORROWER_SELECTION_SUMMARY: 'El client tria al checkout',
  LENDER_ORCHESTRATION_CHOOSE_BORROWER_SELECTION_DESCRIPTION: 'El client veu les ofertes de les entitats al checkout i tria amb quina finançar. La plataforma no decideix per ell.',
  LENDER_ORCHESTRATION_CHOOSE_IBERIA: 'Iberia',
  LENDER_ORCHESTRATION_CHOOSE_IBERIA_SUMMARY: 'Repartiment acordat amb Iberia Cards',
  LENDER_ORCHESTRATION_CHOOSE_IBERIA_DESCRIPTION: 'Repartiment de primeres posicions acordat amb Iberia Cards: cada entitat guanya la primera posició un 10% de les vegades; la resta la decideix el preu. A 3 mesos, sempre per preu.',
  LENDER_ORCHESTRATION_CHOOSE_MANUAL: 'Manual',
  LENDER_ORCHESTRATION_CHOOSE_MANUAL_SUMMARY: 'Ordre fixat a la sessió',
  LENDER_ORCHESTRATION_CHOOSE_MANUAL_DESCRIPTION: 'Ordre fixat a cada sessió de checkout.',
  LENDER_ORCHESTRATION_CHOOSE_MIN_QUOTA: 'Menor quota',
  LENDER_ORCHESTRATION_CHOOSE_MIN_QUOTA_SUMMARY: 'Primer la de menor quota',
  LENDER_ORCHESTRATION_CHOOSE_MIN_QUOTA_DESCRIPTION: 'Primer l\'entitat amb la quota més baixa.',
  LENDER_ORCHESTRATION_QUESTION_STRATEGY: 'Com s\'envia la sol·licitud a les entitats?',
  LENDER_ORCHESTRATION_QUESTION_MODE: 'Qui fa avançar la cascada? Només en cascada.',
  LENDER_ORCHESTRATION_QUESTION_STOP: 'Amb quina resposta s\'atura la cascada? Només en cascada. El mateix exemple de quatre entitats a cada opció: la 1a falla, la 2a rebutja, la 3a la deixa en estudi, la 4a aprova.',
  LENDER_ORCHESTRATION_QUESTION_RANKING: 'En quin ordre es prefereixen les entitats? En cascada marca l\'ordre de consulta; en paral·lel, quina guanya entre les que aproven.',
  LENDER_ORCHESTRATION_PRIORITY_LENDER: 'Entitat prioritària',
  LENDER_ORCHESTRATION_PRIORITY_LENDER_TEXT: 'Llista limitada a les entitats del merchant.',
  LENDER_ORCHESTRATION_LOCKED_TITLE: 'Només un super_admin ho pot canviar',
  LENDER_ORCHESTRATION_LOCKED_TEXT: 'Aquest valor està restringit. Pots canviar la resta de la configuració; es mantindrà tal com està.',
  LENDER_ORCHESTRATION_MANUAL_WARNING_TITLE: 'Cascada en mode manual',
  LENDER_ORCHESTRATION_MANUAL_WARNING_TEXT: 'Cap sol·licitud s\'enviarà a una entitat fins que el teu equip la registri. Les operacions quedaran en anàlisi mentrestant.',
  LENDER_ORCHESTRATION_ERROR_WATERFALL_BORROWER: 'Tria el client només funciona amb enviament en paral·lel',
  LENDER_ORCHESTRATION_ONLY_PARALLEL: 'Només amb enviament en paral·lel',
  LENDER_ORCHESTRATION_DEFAULT_HINT: 'Default de la plataforma per a aquest tipus: $v1 · $v2',
  LENDER_ORCHESTRATION_RESET_DEFAULT: 'Restablir default',
  LENDER_ORCHESTRATION_APPLY: 'Aplicar a $v1 agents',
  LENDER_ORCHESTRATION_RESTRICTED: 'super_admin',
  LENDER_ORCHESTRATION_LENDERS_LOAD_ERROR: 'No s\'han pogut carregar les entitats de cada mètode de pagament',
  LENDER_ORCHESTRATION_READ_ONLY_TITLE: 'Només un super_admin pot canviar aquest mètode de pagament',
  LENDER_ORCHESTRATION_READ_ONLY_TEXT: 'Els seus agents tenen rànquings diferents i algun està restringit. Unificar-lo requereix un super_admin.',
  LENDER_ORCHESTRATION_APPLY_ONE: 'Aplicar a 1 agent',
  [`${patchSetProcessingConfigToMerchantAgents.name}_fulfilled`]: 'S\'ha aplicat l\'orquestració de lenders.',
  [`${patchSetProcessingConfigToMerchantAgents.name}_rejected`]: 'No s\'ha pogut aplicar l\'orquestració de lenders.',
  LENDER_ORCHESTRATION_DIAGRAM_REQUEST: 'Sol·licitud',
  LENDER_ORCHESTRATION_DIAGRAM_AT_ONCE: 'alhora',
  LENDER_ORCHESTRATION_DIAGRAM_APPROVES: 'aprova',
  LENDER_ORCHESTRATION_DIAGRAM_REJECTS: 'rebutja',
  LENDER_ORCHESTRATION_DIAGRAM_REJECTED: 'ha rebutjat',
  LENDER_ORCHESTRATION_DIAGRAM_WHEN_ANSWERS: 'quan respongui',
  LENDER_ORCHESTRATION_DIAGRAM_REVIEW: 'en estudi',
  LENDER_ORCHESTRATION_DIAGRAM_FAILS: 'falla',
  LENDER_ORCHESTRATION_DIAGRAM_ANY_RESULT: 'qualsevol resultat',
  LENDER_ORCHESTRATION_DIAGRAM_NOT_CONSULTED: 'no es consulta',
  LENDER_ORCHESTRATION_DIAGRAM_WINS: 'guanya',
  LENDER_ORCHESTRATION_DIAGRAM_IN_RANKING_ORDER: (
    <>
      en l'<tspan fontWeight={700}>ordre del rànquing</tspan>, una rere l'altra
    </>
  ),
  LENDER_ORCHESTRATION_DIAGRAM_PLATFORM: 'plataforma',
  LENDER_ORCHESTRATION_DIAGRAM_YOUR_TEAM: 'el teu equip',
  LENDER_ORCHESTRATION_DIAGRAM_CONSULTING: 'consultant…',
  LENDER_ORCHESTRATION_DIAGRAM_WAITING: 'en espera',
  LENDER_ORCHESTRATION_DIAGRAM_AUTO_HINT: 'cada resposta dispara sola la consulta següent',
  LENDER_ORCHESTRATION_DIAGRAM_MANUAL_HINT_TOP: 'l\'ordre és només una recomanació',
  LENDER_ORCHESTRATION_DIAGRAM_MANUAL_HINT: 'no s\'envia res sol · el teu equip processa manualment cada sol·licitud',
  LENDER_ORCHESTRATION_DIAGRAM_COST_FOR_YOU: 'el que et costa',
  LENDER_ORCHESTRATION_DIAGRAM_CUSTOMER_APR: 'TAE del client',
  LENDER_ORCHESTRATION_DIAGRAM_MIN_APR_HINT: 'A i B empaten en cost → guanya la de menor TAE',
  LENDER_ORCHESTRATION_DIAGRAM_PROFITABILITY: 'rendibilitat de l\'operació per a tu',
  LENDER_ORCHESTRATION_DIAGRAM_COSTS_YOU: 'et costa',
  LENDER_ORCHESTRATION_DIAGRAM_ALWAYS_FIRST: 'la que triïs, sempre 1a',
  LENDER_ORCHESTRATION_DIAGRAM_REST_BY_PRICE: 'la resta, per menor cost i TAE',
  LENDER_ORCHESTRATION_DIAGRAM_NO_PRICING_FALLBACK: 'si no té tarifa per a l\'operació, només mana el preu',
  LENDER_ORCHESTRATION_DIAGRAM_CUSTOMER_CHECKOUT: 'Checkout del client',
  LENDER_ORCHESTRATION_DIAGRAM_INSTALMENTS_OF: 'quotes de',
  LENDER_ORCHESTRATION_DIAGRAM_FIRST_POSITIONS: '10% de primeres posicions',
  LENDER_ORCHESTRATION_DIAGRAM_RESERVED_EACH: 'reservat a cada entitat',
  LENDER_ORCHESTRATION_DIAGRAM_REMAINING: '70% restant',
  LENDER_ORCHESTRATION_DIAGRAM_BY_COST_APR: 'per menor cost i TAE',
  LENDER_ORCHESTRATION_DIAGRAM_THREE_MONTHS: 'a 3 mesos: sempre per preu',
};

export const ca_alt_setup_fee = {
  SETUP_FEE: 'Comisión de apertura',
};

export default ca;
